export default {
  /* 路由 */
  '路由/首页': 'Home Page',
  '路由/数据可视化': 'Data Visualization',
  '路由/电站监控': 'Station Monitoring',
  '路由/运维分析': 'Operation and Maintenance',
  '路由/生产管理': 'Production',
  '路由/数据分析': 'Data Analysis',
  '路由/虚拟电厂': 'Virtual Power Plant',
  '路由/设备管理': 'Equipment',
  '路由/配置管理': 'Configuration',
  '路由/系统监控': 'System Monitoring',
  '路由/站级监控': 'Station-level Monitoring',
  '路由/电站地图': 'Station Map',
  '路由/生产概览': 'Production Overview',
  '路由/告警管理': 'Alarm Management',
  '路由/告警信息': 'Alarm Information',
  '路由/抄表结算': 'Meter Reading Settlement',
  '路由/运行策略': 'Operation Strategy',
  '路由/策略操作历史': 'Strategy Opertaion History',
  '路由/每日电表同步': 'Daily Meter Synchronism',
  '路由/数据补录': 'Data Completion',
  '路由/参数设置': 'Parameter Settings',
  '路由/空调运行参数设定': 'Airconditioner parameter Settings',
  '路由/故障录波': 'Fault Recorder',
  '路由/功率跟踪': 'Power Tracking',
  '路由/负荷跟踪': 'Load Tracking',
  '路由/满充容量统计': 'Capacity Statistics',
  '路由/充电电量汇总': 'Charge Energy Summary',
  '路由/充放电记录': 'Charge and Discharge Recorder',
  '路由/需量分析': 'Demand Analysis',
  '路由/电压数据分析': 'Voltage Data Analysis',
  '路由/电压一致性': 'Voltage Consistency',
  '路由/温度热管理': 'Temperature Thermal Management',
  '路由/储能分析': 'Energy Storage Analysis',
  '路由/电能质量治理': 'Power Quality Control',
  '路由/电价趋势': 'Power Tariff Trend',
  '路由/电表数据分析': 'Meter Data Anaysis',
  '路由/运营监控': 'Operation Monitoring',
  '路由/收益管理': 'Earning Management',
  '路由/企业信息': 'Company Information',
  '路由/接入管理': 'Access Management',
  '路由/数据日志': 'Data Log',
  '路由/委托管理': 'Delegate Management',
  '路由/基线管理': 'Baseline Management',
  '路由/申报管理': 'Rep Management',
  '路由/结算管理': 'Settlement Management',
  '路由/电站单元': 'Station Unit',
  '路由/电表': 'Meter',
  '路由/能量链': 'eLink',
  '路由/能量块': 'eBlock',
  '路由/设备型号': 'Equipment Model',
  '路由/电站管理': 'Station',
  '路由/设备升级': 'Upgrade',
  '路由/eLink查询': 'eLink Search',
  '路由/API白名单设置': 'API White List Settings',
  '路由/在线用户': 'Online Customers',
  '路由/定时任务': 'Schedule Tasks',
  '路由/标签管理': 'Label',
  '路由/固件管理': 'Firmware',
  '路由/版本信息': 'Version',
  '路由/时段电价': 'Periodic Price',
  '路由/每日收益修改': 'Daily Earning Modification',

  '路由/经评分析': 'Performance Analysis',
  '路由/电站评分总览': 'Station Rating Overview',
  '路由/电站评价详情': 'Station Evaluation Details',
  '路由/电站实际运行数据': 'Station Actual Operation Data',

  '路由/参数设置': 'Parameter Setting',
  '路由/系统复位': 'System Reset',
  '路由/协控设置': 'Coordination Control',
  '路由/遥控设置': 'Telecontrol',
  '路由/遥控设置历史': 'Telecontrol Setting Log',
  '路由/实时数据': 'Real-Time Data',
  '路由/采集点表设置': 'Acquisition Point Table',
  '路由/采集通道设置': 'Acquisition Channel',
  '路由/系统监控': 'System Monitoring',
  '路由/在线用户': 'Online User',
  '路由/定时任务': 'Schedule Task',

  '路由/系统管理': 'System',
  '路由/用户管理': 'User',
  '路由/角色管理': 'Role',
  '路由/菜单管理': 'Menu',
  '路由/部门管理': 'Department',
  '路由/岗位管理': 'Position',
  '路由/字典管理': 'Dictionary',

  '路由/通知公告': 'Notification',
  '路由/操作日志': 'Operation Log',
  '路由/系统日志': 'System Log',
  '路由/个人中心': 'Personal Center',
  '路由/告警管理（运维专用）': 'Alarm Management (Operation and Maintenance)',
  '路由/运维日报': 'Operation Daily Report',
  '路由/电站基本信息': 'Station Basic Information',
  '路由/电站设备信息': 'Station Equipment Information',
  '路由/电站拓扑': 'Station Topology',
  '路由/空调详情': 'Air Conditioner Details',
  '路由/历史升级': 'Upgrade History',
  '路由/光伏': 'Photovoltaic',
  '路由/设备模型': 'Equipment Model Settings',
  '路由/设备点表': 'Equipment Point Table',


  /* 全局 */
  '全局/奇点能源': 'JD Energy',
  '全局/重新登录提示': 'The login status has expired. You can stay on this page or log in again',//key
  '全局/会话过期提示': 'Invalid or Expired session, please log in again',//key
  '全局/系统接口异常': (s) => `System interface ${s} Exception`, //key
  '全局/系统提示': 'System Prompt',
  '全局/重新登录': 'Login Again',
  '全局/选择电站': 'Select Station',
  '全局/400客服电话': '400 Customer Service Hotline',
  '全局/登录状态已过期，您可以继续留在该页面，或者重新登录': 'The login status has expired. You can continue to stay on this page or log in again',
  '全局/无效的会话，或者会话已过期，请重新登录': 'Invalid session, or session has expired, please log in again',
  '全局/数据正在处理，请勿重复提交': 'The data is being processed, please do not resubmit',
  '全局/能量链': 'eLink',
  '全局/能量块': 'eBlock',
  '全局/电表': 'Meter',
  '全局/确定要删除吗?': 'Are you sure you want to delete?',
  

  '全局/取消': 'Cancel',
  '全局/确定': 'Confirm',
  '全局/编辑': 'Edit',
  '全局/删除': 'Delete',
  '全局/保存': 'Save',
  '全局/查询': 'Search',
  '全局/搜索': 'Search',
  '全局/重置': 'Reset',
  '全局/选择': 'Select',
  '全局/提交': 'Submit',
  '全局/修改': 'Modify',
  '全局/设置': 'Setting',
  '全局/设置成功': 'Setting Successful',
  '全局/设置失败': 'Setting Failure',
  '全局/全选': 'Select All',
  '全局/成功': 'Successful',
  '全局/失败': 'Failure',
  '全局/日期': 'Date',
  '全局/新增': 'New',
  '全局/返回': 'Back',
  '全局/操作': 'Operation',
  '全局/查看': 'View',
  '全局/保存成功': 'Save Success',
  '全局/否': 'No',
  '全局/是': 'Yes',


  '全局/后端接口连接异常': 'Backend Interface Connection Exception',
  '全局/系统接口请求超时': 'System Interface Request Timeout',
  '全局/正在下载数据，请稍候': 'Downloading Data, Please Wait',
  '全局/下载文件出现错误，请联系管理员！': 'Error downloading file, please contact the administrator!',



  '全局/账号': 'Account',
  '全局/密码': 'Password',
  '全局/验证码': 'Verification Code',
  '全局/记住密码': 'Remember Password',
  '全局/登录': 'Login',
  '全局/登录中': 'Logging',
  '全局/立即注册': 'Register Now',
  '全局/请输入您的账号': 'Please Input Your Account',
  '全局/请输入您的密码': 'Please Input Your Password',
  '全局/请输入验证码': 'Please Input Verification Code',
  '全局/是否切换版本': 'Whether to switch version',
  '全局/切换新版': 'Switch to New Version',
  '全局/留在旧版': 'Stay on the Old Version',
  '全局/实体表': 'Physical Meter',
  '全局/虚拟表': 'Virtual Meter',




  /* 首页 */
  '首页/分布地图': 'Map',
  '首页/布局大小': 'Layout Size',
  '首页/全屏': 'Full Screen',
  '首页/切换新版': 'New Version',
  '首页/个人中心': 'Personal Center',
  '首页/布局设置': 'Layout Settings',
  '首页/退出登录': 'Logout',
  '首页/个人信息': 'Personal Information',
  '首页/用户名称': 'Name',
  '首页/手机号码': 'Phone Number',
  '首页/用户邮箱': 'Email',
  '首页/所属部门': 'Department',
  '首页/所属角色': 'Role',
  '首页/创建日期': 'Create Date',
  '首页/基本资料': 'General Information',
  '首页/用户昵称': 'Alias',
  '首页/性别': 'Gender',
  '首页/男': 'Male',
  '首页/女': 'Female',
  '首页/保存': 'Save',
  '首页/关闭': 'Close',
  '首页/LOGO设置': 'LOGO Settings',
  '首页/主页LOGO': 'Home Page LOGO',
  '首页/数据可视化LOGO': 'Data Visualization LOGO',
  '首页/旧密码': 'Old Password',
  '首页/新密码': 'New Password',
  '首页/确认密码': 'Confirm Password',
  '首页/主题风格设置': 'Theme Style Settings',
  '首页/主题颜色': 'Theme Color',
  '首页/系统布局配置': 'System Layout Configuration',
  '首页/开启': 'Open',
  '首页/固定': 'Lock',
  '首页/显示LOGO': 'Display LOGO',
  '首页/动态标题': 'Dynamic Title',
  '首页/保存配置': 'Save',
  '首页/重置配置': 'Reset',
  '首页/清空': 'Clearance',
  '首页/确定': 'Confirm',
  '首页/电站列表': 'Station List',
  '首页/电站名称': 'Station Name',
  '首页/装机容量': 'Installed Capacity',
  '首页/地址': 'Address',
  '首页/操作': 'Operation',
  '首页/客服电话': 'Customer Service Hotline',
  '首页/加载更多': 'Load More',
  '首页/查看': 'View',
  '首页/电站规模': 'Station Scale',
  '首页/安全运行天数': 'Safe Operation Days',
  '首页/累计装机容量': 'Accumulated Installed Capacity',
  '首页/累计装机功率': 'Accumulated Installed Power',
  '首页/电站个数': 'The Number of Station',
  '首页/能量链数量': 'The Number of eLink',
  '首页/能量块数量': 'The Number of eBlock',
  '首页/收益分析': 'Earnings Analysis',
  '首页/累计收益': 'Accumulated Earnings',
  '首页/万元': 'Thousand Euros',
  '首页/月': 'Month',
  '首页/所辖电站累计收益': "All Stations' Accumulated Earnings",
  '首页/储能分析': 'Energy Storage Analysis',
  '首页/充放电量': 'Charge and Discharge Energy',
  '首页/累计总充电量': 'Accumulated Charging',
  '首页/累计总放电量': 'Accumulated Discharge',
  '首页/充电': 'Charge',
  '首页/放电': 'Discharge',
  '首页/个': 'Units',

  '首页/修改密码': 'Modify Password',
  '首页/请输入旧密码': 'Please Input Old Password',
  '首页/请输入新密码': 'Please Input New Password',
  '首页/请确认新密码': 'Please Confirm New Password',
  '首页/两次输入的密码不一致': 'The two passwords are inconsistent',
  '首页/旧密码不能为空': 'Old Password Cannot Be Empty',
  '首页/新密码不能为空': 'New Password Cannot Be Empty',
  '首页/确认密码不能为空': 'Confirm Password Cannot Be Empty',
  '首页/修改成功': 'Modify Successful',


  '首页/邮箱': 'Email',
  '首页/用户昵称不能为空': 'User Nickname Cannot Be Empty',
  '首页/邮箱地址不能为空': 'Email Address Cannot Be Empty',
  '首页/请输入正确的邮箱地址': 'Please Input Correct Email Address',
  '首页/手机号码不能为空': 'Phone Number Cannot Be Empty',
  '首页/请输入正确的手机号码': 'Please Input Correct Phone Number',
  '首页/修改头像': 'Modify Avatar',
  '首页/点击上传头像': 'Click Upload Avatar',
  '首页/选择': 'Select',
  '首页/提交': 'Submit',
  '首页/主页LOGO': 'Home Page LOGO',
  '首页/数据可视化LOGO': 'Data Visualization LOGO',
  '首页/修改主页LOGO': 'Modify Home Page LOGO',
  '首页/修改数据可视化LOGO': 'Modify Data Visualization LOGO',
  '首页/文件格式错误，请上传图片类型,如：JPG，PNG后缀的文件。': 'File Format Error, Please Upload Image Type, Such as: JPG, PNG Suffix File.',


  /* 站级监控  */
  '站级监控/主监控': 'Main Monitoring',
  '站级监控/能量链': 'eLink',
  '站级监控/能量块': 'eBlock',
  '站级监控/电表': 'Meter',
  '站级监控/光伏表': 'Photovoltaic Meter',
  '站级监控/负荷跟踪': 'Load Tracking',
  '站级监控/消防': 'Fire Fighting',
  '站级监控/空调': 'Air Conditioner',
  '站级监控/统计信息': 'Statistical Information',
  '站级监控/昨日收益': 'Yesterday Earning',
  '站级监控/累计收益': 'Accumulated Earning',
  '站级监控/今日充电': 'Today Charging Energy',
  '站级监控/累计充电': 'Accumulated Charging',
  '站级监控/今日放电': 'Today Discharging Energy',
  '站级监控/累计放电': 'Accumulated Discharging',
  '站级监控/实时功率': 'Real-Time Power',
  '站级监控/电网电压': 'Grid Voltage',
  '站级监控/剩余电量': 'Battery Residual Energy',
  '站级监控/今日电站SOC-功率跟踪分析曲线': 'Daily Station SOC-Power Tracking Analysis Curve',
  '站级监控/功率': 'Power',
  '站级监控/电网功率': 'Grid Power',
  '站级监控/运行信息': 'Operation Information',
  '站级监控/装机容量': 'Installed Capacity',
  '站级监控/投运时间': 'Commissioning Time',
  '站级监控/在线能量链': 'Online eLinks',
  '站级监控/在线能量块': 'Online eBlocks',
  '站级监控/采样时间': 'Sampling Time',
  '站级监控/总有功功率': 'Total Active Power',
  '站级监控/总无功功率': 'Total Reactive Power',
  '站级监控/电池组最大可充电功率': 'Battery Pack Maximum Chargeable Power',
  '站级监控/电池组最大可放电功率': 'Battery Pack Maximum Dischargeable Power',
  '站级监控/电网A相总电流': 'Grid A Line-to-Neutral Voltage',
  '站级监控/电网B相总电流': 'Grid B Line-to-Neutral Voltage',
  '站级监控/电网C相总电流': 'Grid C Line-to-Neutral Voltage',
  '站级监控/统计信息': 'Statistics Information',
  '站级监控/系统剩余可放电量': 'System Residual Dischargeable Energy',
  '站级监控/日总充电量': 'Daily Total Charging Energy',
  '站级监控/日总放电量': 'Daily Total Discharging Energy',
  '站级监控/总SOC': 'Total SOC',
  '站级监控/系统CPU占用率': 'System CPU Usage',
  '站级监控/系统内存占用率': 'Syetem Memory Usage',
  '站级监控/文件系统占用率': 'File System Usage',
  '站级监控/虚拟电厂控制参数': 'Virtual Power Plant Control Parameters',
  '站级监控/最大可充功率': 'Maximum Chargeable Power',
  '站级监控/最大可放功率': 'Maximum Dischargeable Power',
  '站级监控/第三方控制使能': 'Third Party Contrl Enable',
  '站级监控/第三方控制功率值': 'Third Party Control Power',
  '站级监控/状态': 'State',
  '站级监控/系统运行状态': 'System Operation State',
  '站级监控/断路器状态': 'Circuit Breaker State',
  '站级监控/断开': 'Break',
  '站级监控/闭合': 'Close',
  '站级监控/开关状态': 'Switch State',
  '站级监控/开机': 'Power On',
  '站级监控/设备型号': 'Equipment Model',
  '站级监控/工作状态': 'Working State',
  '站级监控/实时功率': 'Real-Time Power',
  '站级监控/电池簇': 'Battery Cluster',
  '站级监控/运行参数': 'Operation Parameter',
  '站级监控/PCS运行状态': 'PCS Operation State',
  '站级监控/并网': 'Grid Connection',
  '站级监控/PCS运行模式': 'PCS Operation Mode',
  '站级监控/交流恒功率': 'Alternating Current Constant Power',
  '站级监控/变流器效率': 'Conveter Efficiency',
  '站级监控/对地绝缘阻抗': 'Insulating Impedance to Earth',
  '站级监控/直流接触器状态': 'Direct Current Contactor State',
  '站级监控/交流接触器状态': 'Alternating Current Contactor State',
  '站级监控/有功功率': 'Active Power',
  '站级监控/无功功率': 'Reactive Power',
  '站级监控/视在功率': 'Apparent Power',
  '站级监控/功率因素': 'Power Factor',
  '站级监控/环境温度': 'Ambient Temperature',
  '站级监控/机箱内温度': 'Internal Chassis Temperature',
  '站级监控/AB线电压': 'AB Line-to-Line Voltage',
  '站级监控/BC线电压': 'BC Line-to-Line Voltage',
  '站级监控/CA线电压': 'CA Line-to-Line Voltage',
  '站级监控/A相电流': 'A Line-to-Neutral Voltage',
  '站级监控/B相电流': 'B Line-to-Neutral Voltage',
  '站级监控/C相电流': 'C Line-to-Neutral Voltage',
  '站级监控/电网频率': 'Grid Frequency',
  '站级监控/直流信息': 'Direct Current Information',
  '站级监控/查看 eBlock 详情': 'View eBlock Details',
  '站级监控/已停用': 'Disabled',
  '站级监控/默认标题': 'Default Title',
  '站级监控/UUID复制成功': 'UUID Copied Successfully',
  '站级监控/查看 PCS 运行参数': 'View PCS Operation Parameters',
  '站级监控/查看电池簇详情': 'View Battery Cluster Details',
  '站级监控/eLink有功功率': 'eLink Active Power',
  '站级监控/PCS直流侧功率': 'PCS Direct Current Power',
  '站级监控/PCS直流侧电压': 'PCS DC side voltage',
  '站级监控/PCS直流侧电流': 'PCS DC side current',
  '站级监控/电池荷电量百分比': 'Percentage of State of charge',
  '站级监控/PCS功率因数': 'PCS Power Factor',
  '站级监控/极佳': 'Excellent',
  '站级监控/佳': 'Good',
  '站级监控/优秀': 'Excellent',
  '站级监控/良好': 'Good',
  '站级监控/合格': 'Qualified',
  '站级监控/建议更换': 'Suggest Replacement',
  '站级监控/停止运行': 'Stop Running',
  '站级监控/考虑需量与箱变保护后的最大可充功率': 'Consider the demand and the maximum rechargeable power after the box transformer protection',
  '站级监控/考虑需量与箱变保护后的最大可放功率': 'Consider the demand and the maximum discharge power after the box transformer protection',

  /* BCS */
  '站级监控/电池总压': 'Battery Total Voltage',
  '站级监控/电池电流': 'Battery Total Current',
  '站级监控/直流功率': 'Direct Current Power',
  '站级监控/时间': 'Duration',
  '站级监控/启动时间': 'Start Duration',
  '站级监控/停机时间': 'Stop Duration',
  '站级监控/电压统计': 'Voltage Statistics',
  '站级监控/最高单体电压': 'Highest Cell Voltage',
  '站级监控/最高电压位置': 'Highest Cell Voltage Index',
  '站级监控/最低单体电压': 'Lowest Cell Voltage',
  '站级监控/最低电压位置': 'Lowest Cell Voltage Index',
  '站级监控/最大压差': 'Highest Voltage Difference',
  '站级监控/温度统计': 'Temperature Statistics',
  '站级监控/最高单体温度': 'Highest Cell Temperature',
  '站级监控/最高温度位置': 'Highest Cell Temperature Index',
  '站级监控/最低单体温度': 'Lowest Cell Temperature',
  '站级监控/最低温度位置': 'Lowest Cell Temperature Index',
  '站级监控/最大温差': 'Highest Temperature Difference',
  '站级监控/SOC统计': 'SOC Statistics',
  '站级监控/最高单体SOC': 'Highest Cell SOC',
  '站级监控/最高SOC位置': 'Highest Cell SOC Index',
  '站级监控/最低单体SOC': 'Lowest Cell SOC',
  '站级监控/最低SOC位置': 'Lowest Cell SOC Index',
  '站级监控/最大SOC差': 'Highest SOC Difference',
  '站级监控/序号': 'Index',
  '站级监控/均衡': 'Balance',
  '站级监控/未均衡': 'Unbalance',
  '站级监控/内阻统计': 'Resistance Statistics',
  '站级监控/最高单体内阻': 'Highest Cell Resistance',
  '站级监控/最高内阻位置': 'Highest Cell Resistance Index',
  '站级监控/最低单体内阻': 'Lowest Cell Resistance',
  '站级监控/最低内阻位置': 'Lowest Cell Resistance Index',
  '站级监控/最大内阻差': 'Highest Resistance Difference',
  '站级监控/单体电池电压实时曲线': 'Cell Real-Time Voltage Curve',
  '站级监控/单体电池温度实时曲线': 'Cell Real-Time Temperature Curve',
  '站级监控/单体电池SOC实时曲线': 'Cell Real-Time SOC Curve',
  '站级监控/单体电池内阻实时曲线': 'Cell Real-Time Resistance Curve',
  '站级监控/详情': 'Details',
  '站级监控/遥测量': 'Telemetry',
  '站级监控/电池剩余电量': 'Battery Residual Energy',
  '站级监控/工作状态': 'Working State',
  '站级监控/最高电芯电压': 'Highest Cell Voltage',
  '站级监控/最高电芯温度': 'Highest Cell Temperature',
  '站级监控/PCS交流侧有功功率': 'PCS Alternating Current Active Power',
  '站级监控/PCS功率因素': 'PCS Power Factor',
  '站级监控/直流电压': 'Direct Current Voltage',
  '站级监控/空调状态': 'Air Conditioner State',
  '站级监控/允许最大充电功率': 'Permitted Maxinum Charging Power',
  '站级监控/最低电芯电压': 'Lowest Cell Voltage',
  '站级监控/最低电芯温度': 'Lowest Cell Temperature',
  '站级监控/PCS交流侧无功功率': 'PCS Alternating Current Reactive Power',
  '站级监控/直流电流': 'Direct Current Current',
  '站级监控/空调蒸发器温度': 'Air Conditioner Evaporator Temperature',
  '站级监控/佳': 'Good',
  '站级监控/允许最大放电功率': 'Permitted Maximum Discharging Power',
  '站级监控/电芯最高压差': 'Highest Voltage Difference',
  '站级监控/电芯最高温差': 'Highest Temperature Difference',
  '站级监控/PCS交流侧视在功率': 'PCS Alternating Current Apparent Power',
  '站级监控/直流功率': 'Direct Current Power',
  '站级监控/空调冷凝器温度': 'Air Conditioner Condenser Temperature',
  '站级监控/并网点电表参数': 'Grid-Connected Meter Parameters',
  '站级监控/A相无功功率': 'A Phase Reactive Power',
  '站级监控/B相无功功率': 'B Phase Reactive Power',
  '站级监控/C相无功功率': 'C Phase Reactive Power',
  '站级监控/A相有功功率': 'A Phase Active Power',
  '站级监控/B相有功功率': 'B Phase Active Power',
  '站级监控/C相有功功率': 'C Phase Active Power',
  '站级监控/总有功功率': 'Total Active Power',
  '站级监控/总无功功率': 'Total Reactive Power',
  '站级监控/A相功率因数': 'A Phase Power Factor',
  '站级监控/B相功率因数': 'B Phase Power Factor',
  '站级监控/C相功率因数': 'C Phase Power Factor',
  '站级监控/总功率因数': 'Total Power Factor',
  '站级监控/频率': 'Frequency',
  '站级监控/正向有功电能': 'Positive Active Energy',
  '站级监控/反向有功电能': 'Negative Active Energy',
  '站级监控/暂无数据': 'No Data',
  '站级监控/并网点功率': 'Grid-Connected Meter Power',
  '站级监控/关口表功率': 'PCC Meter Power',
  '站级监控/负载功率': 'Load Power',
  '站级监控/方阵消防预警级别': 'Matrix Fire Fighting Alarm Level',
  '站级监控/消防主机CO浓度': 'Fire Fighting Computor Co Concentration',
  '站级监控/消防主机在线状态': 'Fire Fighting Computor Online State',
  '站级监控/消防主机H2浓度': 'Fire Fighting Computor H2 Concentration',
  '站级监控/主机喷洒状态': 'Master Spray State',
  '站级监控/消防主机风机状态': 'Fire Fighting Computor Wind TurbineState',
  '站级监控/消防主机通信协议版本号': 'Fire Fighting Computor Communication Protocol Version',
  '站级监控/消防主机手动报警': 'Fire Fighting Computor Manual Alarm',
  '站级监控/消防主机程序版本号': 'Fire Fighting Computor Version',
  '站级监控/消防主机手动急停': 'Fire Fighting Computor Manual Emergency Stop',
  '站级监控/消防主机温感状态': 'Fire Fighting Computor Temperature Sensor State',
  '站级监控/柜体消防预警级别': 'Cabinet Fire Fighting Alarm Level',
  '站级监控/柜体温度': 'Cabinet Temperature',
  '站级监控/柜体湿度': 'Cabinet Humidity',
  '站级监控/CO浓度': 'Co Concentration',
  '站级监控/烟雾浓度': 'Smoke Concentration',
  '站级监控/CO状态': 'Co State',
  '站级监控/VOC状态': 'VOC State',
  '站级监控/柜内主机喷洒状态': 'Internal Chassis Master Spray State',
  '站级监控/消防中继手动报警': 'Fire Relay Manual Alarm',
  '站级监控/消防中继手动急停': 'Fire Relay Manual Emergency Stop',
  '站级监控/消防中继程序版本号': 'Fire Relay Version',
  '站级监控/消防中继H2浓度': 'Fire Relay H2 Concentration',
  '站级监控/冷却方式': 'Cooling Type',
  '站级监控/风冷': 'Air Cooling',
  '站级监控/eLink型号': 'eLink Model',
  '站级监控/eLink控制柜': 'eLink Control Cabinet',
  '站级监控/返回': 'Return',
  '站级监控/告警历史': 'Alarm History',
  '站级监控/告警时间': 'Alarm Time',
  '站级监控/故障名称': 'Fault Name',
  '站级监控/查询': 'Search',
  '站级监控/序号': 'Index',
  '站级监控/空调编号': 'Air Conditioner Index',
  '站级监控/告警开始时间': 'Alarm Start Time',
  '站级监控/告警结束时间': 'Alarm Stop Time',
  '站级监控/故障key': 'Fault Key',

  '站级监控/故障名称模糊搜索': 'Fault Name Fuzzy Search',
  '站级监控/年': 'Year',
  '站级监控/月': 'January, February, March, April, May, June, July, August, September, October, November, December',
  '站级监控/PCS运行参数': 'PCS Operation Parameters',
  '站级监控/遥测': 'Telemetry',
  '站级监控/遥信': 'Telesignaling',
  '站级监控/电网A相电压': 'Grid A Phase Voltage',
  '站级监控/电网B相电压': 'Grid B Phase Voltage',
  '站级监控/电网C相电压': 'Grid C Phase Voltage',
  '站级监控/逆变A相电流': 'Inverter A Phase Current',
  '站级监控/逆变B相电流': 'Inervter B Phase Current',
  '站级监控/逆变C相电流': 'Inverter C Phase Current',
  '站级监控/逆变有功功率': 'Inverter Active Power',
  '站级监控/逆变无功功率': 'Inverter Reactive Power',
  '站级监控/逆变视在功率': 'Inverter Apparent Power',
  '站级监控/电网频率': 'Grid Frequency',
  '站级监控/功率因数': 'Power Factor',
  '站级监控/总母线电压': 'Main Bus Voltage',
  '站级监控/正半母线电压': 'Positive Semi-Bus Voltage',
  '站级监控/负半母线电压': 'Negative Semi-Bus Voltage',
  '站级监控/总电网有功功率': 'Main Grid Active Power',
  '站级监控/总电网无功功率': 'Main Grid Reactive Power',
  '站级监控/重要负载有功功率': 'Primary Load Active Power',
  '站级监控/重要负载无功功率': 'Primary Load Reactive Power',
  '站级监控/电池电压': 'Battery Voltage',
  '站级监控/DCDC低压侧电压': 'Voltage at DCDC Low-Voltage Side',
  '站级监控/DCDC总电流': 'DCDC Total Current',
  '站级监控/DCDC总功率': 'DCDC Total Power',
  '站级监控/DCDC功率给定值': 'DCDC Set Power',
  '站级监控/PV1电压': 'Photovolatic1 Voltage',
  '站级监控/PV2电压': 'Photovolatic2 Voltage',
  '站级监控/PV3电压': 'Photovolatic3 Voltage',
  '站级监控/PV4电压': 'Photovolatic4 Voltage',
  '站级监控/PV1功率': 'Photovolatic1 Power',
  '站级监控/PV2功率': 'Photovolatic2 Power',
  '站级监控/PV3功率': 'Photovolatic3 Power',
  '站级监控/PV4功率': 'Photovolatic4 Power',
  '站级监控/PV总功率': 'Photovolatic Total Power',
  '站级监控/PV功率给定值': 'Photovolatic Set Power',
  '站级监控/逆变A相电压': 'Inverter A Phase Voltage',
  '站级监控/逆变B相电压': 'Inverter B Phase Voltage',
  '站级监控/逆变C相电压': 'Inverter C Phase Voltage',
  '站级监控/A相电流直流分量': 'A Phase Current Direct Current Component',
  '站级监控/B相电流直流分量': 'B Phase Current Direct Current Component',
  '站级监控/C相电流直流分量': 'C Phase Current Direct Current Component',
  '站级监控/A相电压直流分量': 'A Phase Voltage Direct Current Component',
  '站级监控/B相电压直流分量': 'B Phase Voltage Direct Current Component',
  '站级监控/C相电压直流分量': 'C Phase Voltage Direct Current Component',
  '站级监控/负载A相电压': 'Load A Phase Voltage',
  '站级监控/负载B相电压': 'Load B Phase Voltage',
  '站级监控/负载C相电压': 'Load C Phase Voltage',
  '站级监控/负载A相电流': 'Load A Phase Current',
  '站级监控/负载B相电流': 'Load B Phase Current',
  '站级监控/负载C相电流': 'Load C Phase Current',
  '站级监控/DCDC电感1电流': 'DCDC Inductance1 Current',
  '站级监控/DCDC电感2电流': 'DCDC Inductance2 Current',
  '站级监控/DCDC电感3电流': 'DCDC Inductance3 Current',
  '站级监控/DCDC电感4电流': 'DCDC Inductance4 Current',
  '站级监控/PV1电流': 'Photovolatic1 Current',
  '站级监控/PV2电流': 'Photovolatic2 Current',
  '站级监控/PV3电流': 'Photovolatic3 Current',
  '站级监控/PV4电流': 'Photovolatic4 Current',
  '站级监控/DSP温度': 'DSP Temperature',
  '站级监控/DCDCISO电阻1': 'DCDC ISO Resistance1',
  '站级监控/DCDCISO电阻2': 'DCDC ISO Resistance2',
  '站级监控/母线ISO电阻1': 'Bus ISO Resistance1',
  '站级监控/母线ISO电阻2': 'Bus ISO Resistance2',
  '站级监控/漏电流': 'Current Leakage ',
  '站级监控/DCDC充电功率限值': 'DCDC Charge Power Threshold',
  '站级监控/DCDC放电功率限值': 'DCDC Discharge Power Threshold',
  '站级监控/电池ISO电压': 'Battery ISO Voltage',
  '站级监控/CPU1中断执行时间': 'CPU1 Interrupt Duration',
  '站级监控/CPU2中断执行时间': 'CPU2 Interrupt Duration',
  '站级监控/放电功率累加值': 'Discharge Accumulated Power',
  '站级监控/充电功率累加值': 'Charge Accumulated Power',
  '站级监控/通讯协议版本': 'Communication Protocol Version',
  '站级监控/FPGA软件版本': 'FPGA Software Version ',
  '站级监控/CPU1软件版本': 'CPU1 Software Version',
  '站级监控/CPU2软件版本': 'CPU2 Software Version',
  '站级监控/Boot1软件版本': 'Boot1 Software Version',
  '站级监控/Boot2软件版本': 'Boot2 Software Version',
  '站级监控/软件ID号-APP': 'Software ID-APP',
  '站级监控/软件ID号-FPGA': 'Software ID-FPGA',
  '站级监控/主机状态': 'PCS State',
  '站级监控/运行模式': 'Operation State',
  '站级监控/并网自检': 'Grid-Connected Self-Check',
  '站级监控/离网自检': 'Off-Grid Self-Check',
  '站级监控/并网运行': 'Grid-Connected Operation',
  '站级监控/离网运行': 'Off-Grid Operation',
  '站级监控/并离网一体运行': 'On/Off Grid Operation',
  '站级监控/主-AC指令标志': 'Master-AC Command Mark',
  '站级监控/主-PV指令标志': 'Master-PV Command Mark',
  '站级监控/主-DCDC指令标志': 'Master-DCDC Command Mark',
  '站级监控/AC状态机': 'AC State Machine',
  '站级监控/AC-2-Main状态反馈': 'AC-2-Main State Response',
  '站级监控/网侧继电器自检': 'Grid Relay Self-Check',
  '站级监控/不控整流自检': 'Uncontrol Rectify Self-Check',
  '站级监控/母线绝缘阻抗检测': 'Bus Insulation Impedance Check',
  '站级监控/漏电流自检': 'Current Leakage Self-Check',
  '站级监控/平衡桥自检': 'Balance Bridge Self-Check',
  '站级监控/逆变电压振幅相位检测': 'Inverter Voltage Amplitude Phase Check',
  '站级监控/电感电流采样检测': 'Inductance Current Sampling Check',
  '站级监控/逆变继电器检测': 'Inverter Relay Check',
  '站级监控/状态机工作状态': 'State Machine Working State',
  '站级监控/状态返回值': 'State Return',
  '站级监控/环路状态': 'Loop State',
  '站级监控/ISO自检完成标志': 'ISO Self-Check Finish Mark',
  '站级监控/直流接触器件反馈状态': 'Direct Current Contactor Response State',
  '站级监控/温度降额状态': 'Temperature Derating State',
  '站级监控/DC/DC状态（PV1）': 'DCDC State(PV1)',
  '站级监控/DC/DC模式（PV1）': 'DCDC Mode(PV1)',
  '站级监控/MPPT模式（PV1）': 'MPPT Mode(PV1)',
  '站级监控/MPPT状态（PV1）': 'MPPT State(PV1)',
  '站级监控/电压范围（PV1）': 'Voltage Range(PV1)',
  '站级监控/DC/DC状态（PV2）': 'DCDC State(PV2)',
  '站级监控/DC/DC模式（PV2）': 'DCDC Mode(PV2)',
  '站级监控/MPPT模式（PV2）': 'MPPT Mode(PV2)',
  '站级监控/MPPT状态（PV2）': 'MPPT State(PV2)',
  '站级监控/电压范围（PV2）': 'Voltage Range(PV2)',
  '站级监控/DC/DC状态（PV3）': 'DCDC State(PV3)',
  '站级监控/DC/DC模式（PV3）': 'DCDC Mode(PV3)',
  '站级监控/MPPT模式（PV3）': 'MPPT Mode(PV3)',
  '站级监控/MPPT状态（PV3）': 'MPPT State(PV3)',
  '站级监控/电压范围（PV3）': 'Voltage Range(PV3)',
  '站级监控/DC/DC状态（PV4）': 'DCDC State(PV4)',
  '站级监控/DC/DC模式（PV4）': 'DCDC Mode(PV4)',
  '站级监控/MPPT模式（PV4）': 'MPPT Mode(PV4)',
  '站级监控/MPPT状态（PV4）': 'MPPT State(PV4)',
  '站级监控/电压范围（PV4）': 'Voltage Range(PV4)',
  '站级监控/PV状态机': 'Photovoltaic State Machine',
  '站级监控/PV状态反馈': 'Photovoltaic State Response',
  '站级监控/PV并联模式': 'Photovoltaic Parellel Mode',
  '站级监控/恒流模式标志': 'Constant Current Mode Mark',
  '站级监控/PCS运行LED': 'PCS Operation LED',
  '站级监控/电池侧接触器控制': 'Battery Contactor Control',
  '站级监控/扰流风扇控制': 'Turbulent Flow Fan Control',
  '站级监控/电池侧绝缘阻抗继电器控制1': 'Battery Insulation Impedance Relay Control1',
  '站级监控/电池侧绝缘阻抗继电器控制2': 'Battery Insulation Impedance Relay Control2',
  '站级监控/PV侧绝缘阻抗继电器控制1': 'Photovoltaic Insulation Impedance Relay Control1',
  '站级监控/PV侧绝缘阻抗继电器控制2': 'Photovoltaic Insulation Impedance Relay Control2',
  '站级监控/继电器驱动芯片使能信号': 'Relay Driver Chip Enable Signal',
  '站级监控/接地继电器控制': 'Ground Relay Control',
  '站级监控/离网继电器控制': 'Off-Grid Relay Control',
  '站级监控/N线继电器控制1': 'N Line Relay Control1',
  '站级监控/N线继电器控制2': 'N Line Relay Control2',
  '站级监控/电网侧软启继电器控制': 'Grid Soft Start Relay Control',
  '站级监控/电网侧继电器控制信号1': 'Grid Relay Control Signal1',
  '站级监控/电网侧继电器控制信号2': 'Grid Relay Control Signal2',
  '站级监控/漏电流自检控制': 'Current Leakage Self-Check Control',
  '站级监控/继电器控制切换信号': 'Relay Control Switching Signal',
  '站级监控/逆变继电器控制信号': 'Inverter Relay Control Signal',
  '站级监控/系统运行总故障': 'System Operation Total Fault',
  '站级监控/电网总故障': 'Grid Total Fault',
  '站级监控/逆变器总故障': 'Inverter Total Fault',
  '站级监控/PV运行总故障': 'PV Operation Total Fault',
  '站级监控/DCDC运行总故障': 'DCDC Operation Total Fault',
  '站级监控/电网开机故障': 'Grid Power On Fault',
  '站级监控/PV开机故障': 'PV Power On Fault',
  '站级监控/远程关机故障': 'Remote Power Off Fault',
  '站级监控/母线硬件过压故障': 'Bus Hardware Over Voltage Fault',
  '站级监控/母线过压': 'Bus Over Voltage',
  '站级监控/母线欠压': 'Bus Under Voltage',
  '站级监控/母线二级过压': 'Bus Over Voltage Level2',
  '站级监控/母线二级欠压': 'Bus Under Voltage Level2',
  '站级监控/正母线硬件过压故障': 'Positive Bus Hardware Over Voltage Fault',
  '站级监控/负母线硬件过压故障': 'Negative Bus Hardware Over Voltage Fault',
  '站级监控/上位机通信故障': 'Monitoring Software Communication Fault',
  '站级监控/系统锁定故障': 'System Lock Fault',
  '站级监控/母线软起失败故障': 'Bus Soft Start Fail Fault',
  '站级监控/电池相关故障': 'Battery Related Fault',
  '站级监控/E2ROM故障': 'E2ROM Fault',
  '站级监控/FRAM故障': 'FRAM Fault',
  '站级监控/逆变电流零漂故障': 'Inverter Current Zero Drift Fault',
  '站级监控/DCDC电流零漂故障': 'DCDC Current Zero Drift Fault',
  '站级监控/PV电流零漂故障': 'PV Current Zero Drift Fault',
  '站级监控/CPU3心跳故障': 'CPU3 Beating Fault',
  '站级监控/母线不平衡故障': 'Bus Unequalization Fault',
  '站级监控/风机1故障': 'Wind Turbine1 Fault',
  '站级监控/风机2故障': 'Wind Turbine2 Fault',
  '站级监控/风机3故障': 'Wind Turbine3 Fault',
  '站级监控/半母线短路故障': 'Semi-Bus Short Circuit Fault',
  '站级监控/母线短路故障': 'Bus Short Circuit Fault',
  '站级监控/FPGA与CPU1通信故障': 'FPGA and CPU1 Communication Fault',
  '站级监控/FPGA与CPU2通信故障': 'FPGA and CPU2 Communication Fault',
  '站级监控/AFCI模块自检故障': 'AFCI Module Self-Check Fault',
  '站级监控/AFCI模块通信故障': 'AFCI Communication Fault',
  '站级监控/通道1直流拉弧故障': 'Channel1 Direct Current Arc Fault',
  '站级监控/通道2直流拉弧故障': 'Channel2 Direct Current Arc Fault',
  '站级监控/通道3直流拉弧故障': 'Channel3 Direct Current Arc Fault',
  '站级监控/通道4直流拉弧故障': 'Channel4 Direct Current Arc Fault',
  '站级监控/漏电流故障': 'Current Leakage Fault',
  '站级监控/电网过压': 'Grid Over Voltage',
  '站级监控/电网欠压': 'Grid Under Voltage',
  '站级监控/电网过频': 'Grid Over Frequency',
  '站级监控/电网欠频': 'Grid Under Frequency',
  '站级监控/电网二级过压': 'Grid Over Voltage Level2',
  '站级监控/电网二级欠压': 'Grid Under Voltage Level2',
  '站级监控/电网二级过频': 'Grid Over Frequency Level2',
  '站级监控/电网二级欠频': 'Grid Under Frequency Level2',
  '站级监控/电网谐振故障': 'Grid Syntony Fault',
  '站级监控/电网电压穿越故障': 'Grid Voltage Crossing Through Fault',
  '站级监控/电网相序故障': 'Grid Phase Sequence Fault',
  '站级监控/电网电压开机故障': 'Grid Voltage Power On Fault',
  '站级监控/电网对地短路故障': 'Grid Ground Short Circuit Fault',
  '站级监控/电网锁定故障': 'Grid Lock Fault',
  '站级监控/A相电感电流逐波限流': 'A Phase Inductance Current Limit By Waves', 
  '站级监控/B相电感电流逐波限流': 'B Phase Inductance Current Limit By Waves',
  '站级监控/C相电感电流逐波限流': 'C Phase Inductance Current Limit By Waves',
  '站级监控/A相电感电流过流': 'A Phase Inductance Over Current ',
  '站级监控/B相电感电流过流': 'B Phase Inductance Over Current ',
  '站级监控/C相电感电流过流': 'C Phase Inductance Over Current ',
  '站级监控/并网110%过载': 'Grid-Connected 110% Over Load',
  '站级监控/并网120%过载': 'Grid-Connected 120% Over Load',
  '站级监控/离网110%过载': 'Off-Grid 110% Over Load',
  '站级监控/离网120%过载': 'Off-Grid 120% Over Load',
  '站级监控/孤岛保护': 'Isolated Island Protection',
  '站级监控/接地故障': 'Ground Fault',
  '站级监控/并网输出电流直流分量过大': 'Grid-Connected Output Current DC Component Extra Large',
  '站级监控/离网输出电压直流分量过大': 'Off-Grid Output Current DC Component Extra Large',
  '站级监控/逆变器故障锁定': 'Inverter Fault Lock',
  '站级监控/继电器自检故障': 'Relay Self-Check Fault',
  '站级监控/不控整流故障': 'Uncontrol Rectify Fault',
  '站级监控/母线绝缘检测故障': 'Bus Insulation Check Fault',
  '站级监控/逆变电压幅值相序故障': 'Inverter Voltage Amplitude Order Fault',
  '站级监控/电感电流检测异常': 'Inductance Current Check Abnormal',
  '站级监控/平衡桥逐波限流故障': 'Balance Bridge current limit By Waves',
  '站级监控/平衡桥硬件过流故障': 'Balance Bridege Hardware Over Current Fault',
  '站级监控/半母线电压不平衡': 'Semi-Bus Voltage Unequalization',
  '站级监控/逆变继电器自检故障': 'Inverter Relay Self-Check Fault',
  '站级监控/平衡桥自检故障': 'Balance Bridge Self-Check Fault',
  '站级监控/漏电流自检故障': 'Current Leakage Self-Check Fault',
  '站级监控/离网接地继电器故障': 'Off-Grid Ground Relay Fault',
  '站级监控/逆变继电器运行断开故障': 'Inverter Relay Operation Break Fault',
  '站级监控/PV1硬件过流': 'PV1 Hardware Over Current',
  '站级监控/PV1反接': 'PV1 Reverse',
  '站级监控/PV1欠压': 'PV1 Under Voltage',
  '站级监控/PV1过压': 'PV1 Over Voltage',
  '站级监控/PV1启机失败': 'PV1 Power On Failed',
  '站级监控/PV2硬件过流': 'PV2 Hardware Over Current',
  '站级监控/PV2反接': 'PV2 Reverse',
  '站级监控/PV2欠压': 'PV2 Under Voltage',
  '站级监控/PV2过压': 'PV2 Over Voltage',
  '站级监控/PV2启机失败': 'PV2 Power On Failed',
  '站级监控/PV3硬件过流': 'PV3 Hardware Over Current',
  '站级监控/PV3反接': 'PV3 Reverse',
  '站级监控/PV3欠压': 'PV3 Under Voltage',
  '站级监控/PV3过压': 'PV3 Over Voltage',
  '站级监控/PV3启机失败': 'PV3 Power On Failed',
  '站级监控/PV4硬件过流': 'PV4 Hardware Over Current',
  '站级监控/PV4反接': 'PV4 Reverse',
  '站级监控/PV4欠压': 'PV4 Under Voltage',
  '站级监控/PV4过压': 'PV4 Over Voltage',
  '站级监控/PV4启机失败': 'PV4 Power On Failed',
  '站级监控/PV散热器过温': 'PV Radiator Over Temperature',
  '站级监控/PV绝缘阻抗异常': 'PV Insulation Impedance Abnormal',
  '站级监控/PV温度采样异常': 'PV Temperature Sampling Abnormal',
  '站级监控/PV总故障': 'PV Total Fault',
  '站级监控/故障锁存': 'Fault Latch',
  '站级监控/并联模式启机条件': 'Parallel Connection Mode Power On Condition',
  '站级监控/低压侧一级过流': 'Over Current Level1 at Low Voltage Side',
  '站级监控/低压侧二级过流': 'Over Current Level2 at Low Voltage Side',
  '站级监控/低压侧一级过压': 'Over Voltage Level1 at Low Voltage Side',
  '站级监控/低压侧二级过压': 'Over Voltage Level2 at Low Voltage Side',
  '站级监控/低压侧一级欠压': 'Under Voltage Level1 at Low Voltage Side',
  '站级监控/低压侧二级欠压': 'Under Voltage Level2 at Low Voltage Side',
  '站级监控/一级离网过载': 'Off-Grid Over Load Level1',
  '站级监控/二级离网过载': 'Off-Grid Over Load Level2',
  '站级监控/环境过温': 'Environment Over Temperature',
  '站级监控/环境欠温': 'Environment Under Temperature',
  '站级监控/继电器故障': 'Relay Fault',
  '站级监控/绝缘阻抗自检故障': 'Insulation Impedance Self-Check Fault',
  '站级监控/DCDC锁定故障': 'DCDC Lock Fault',
  '站级监控/电池电压过低': 'Battery Voltage Ultra Low',
  '站级监控/电池电压过高': 'Battery Voltage Ultra High',
  '站级监控/低压侧硬件过流故障1': 'Hardware Over Current Fault1 at Low Voltage Side',
  '站级监控/低压侧硬件过流故障2': 'Hardware Over Current Fault2 at Low Voltage Side',
  '站级监控/低压侧硬件过流故障3': 'Hardware Over Current Fault3 at Low Voltage Side',
  '站级监控/低压侧硬件过流故障4': 'Hardware Over Current Fault4 at Low Voltage Side',
  '站级监控/低压侧总硬件过流故障': 'Total Hardware Over Current at Low Voltage Side',
  '站级监控/电池电流互校故障': 'Battery Current Mutual Calibration Fault',
  '站级监控/实时故障信息1': 'Real-Time Fault Imformation1',
  '站级监控/实时故障信息2': 'Real-Time Fault Imformation2',
  '站级监控/实时故障信息3': 'Real-Time Fault Imformation3',
  '站级监控/实时故障信息4': 'Real-Time Fault Imformation4',
  '站级监控/实时故障信息5': 'Real-Time Fault Imformation5',
  '站级监控/实时故障信息6': 'Real-Time Fault Imformation6',
  '站级监控/实时故障信息7': 'Real-Time Fault Imformation7',
  '站级监控/实时故障信息8': 'Real-Time Fault Imformation8',
  '站级监控/系统锁定故障原因': 'System Lock Fault Reason',
  '站级监控/电网锁定故障原因': 'Grid Lock Fault Reason',
  '站级监控/逆变器锁定故障原因': 'Inverter Lock Fault Reason',
  '站级监控/PV锁定故障原因': 'PV Lock Fault Reason',
  '站级监控/DCDC锁定故障原因': 'DCDC Lock Fault Reason',
  '站级监控/系统关机故障': 'System Power Off Fault',
  '站级监控/交流侧电网关机故障': 'AC Grid Power Off Fault',
  '站级监控/交流侧逆变关机故障': 'AC Inverter Power Off Fault',
  '站级监控/PV测关机故障': 'PV Power Off Fault',
  '站级监控/DCDC测关机故障': 'DCDC Power Off Fault',
  '站级监控/BMS软件版本': 'BMS Software Version',
  '站级监控/eBlock运行模式': 'eBlock Operation Mode',
  '站级监控/SOP控制模式': 'SOP Control Mode',
  '站级监控/SOE充电上限': 'SOE Charge Upper Limit',
  '站级监控/SOE放电下限': 'SOE Discharge Lower Limit',
  '站级监控/eBlock工作状态': 'eBlock Working State',
  '站级监控/上次工作状态': 'Last Working State',
  '站级监控/SOH': 'SOH',
  '站级监控/上次充电SOC': 'Last Charge SOC',
  '站级监控/上次放电SOC': 'Last Discharge SOC',
  '站级监控/当前额定安时': 'Current Rated Ah',
  '站级监控/当前额定电量': 'Current Rated Energy',
  '站级监控/电池真实SOC': 'Battery Actual SOC',
  '站级监控/电池显示SOC': 'Battery Indicate SOC',
  '站级监控/电池显示剩余安时': 'Battery Indicate Residual Ah',
  '站级监控/电池真实SOE': 'Battery Actual SOE',
  '站级监控/电池显示SOE': 'Battery Indicate SOE',
  '站级监控/电池显示剩余电量': 'Battery Indicate Residual Energy',
  '站级监控/电池累计充电量': 'Battery Accumulated Charge Energy',
  '站级监控/电池累计放电量': 'Battery Accumulated Discharge Energy',
  '站级监控/电池最后一次充电Ah数': 'Battery Last Charge Ah',
  '站级监控/电池最后一次放电Ah数': 'Battery Last Discharge Ah',
  '站级监控/电池最后一次充电kWh数': 'Battery Last Charge kWh',
  '站级监控/电池最后一次放电kWh数': 'Battery Last Discharge kWh',
  '站级监控/Flash写成功次数': 'Flash Write Success Number',
  '站级监控/Flash写失败次数': 'Flash Write Fail Number',
  '站级监控/安时积分': 'Ah Integrate',
  '站级监控/EMS正常运行时间': 'Ems Normal Operation Duration',
  '站级监控/修正标志': 'Modify Mark',
  '站级监控/电池系统最大允许充电功率': 'Battery System Max Permitted Charge Power',
  '站级监控/电池系统最大允许放电功率': 'Battery System Max Permitted Discharge Power',
  '站级监控/输入异常': 'Input Abnormal',
  '站级监控/电芯均衡开关1': 'Cell Equalization Switch1',
  '站级监控/电芯均衡开关2': 'Cell Equalization Switch2',
  '站级监控/电芯均衡开关3': 'Cell Equalization Switch3',
  '站级监控/电芯均衡开关4': 'Cell Equalization Switch4',
  '站级监控/DC上次满充电量': 'DC Last Fully Charge Energy',
  '站级监控/DC上次满放电量': 'DC Last Fully Discharge Energy',
  '站级监控/DC上次满充容量': 'DC Last Fully Charge Capacity',
  '站级监控/DC上次满放容量': 'DC Last Fully Discharge Capacity',
  '站级监控/AC上次满充电量': 'AC Last Fully Charge Energy',
  '站级监控/AC上次满放电量': 'AC Last Fully Discharge Energy',
  '站级监控/交流侧充电效率': 'AC Charge Efficiency',
  '站级监控/交流侧额定电量': 'AC Rated Energy',
  '站级监控/AC显示SOE': 'AC Indicate SOE',
  '站级监控/AC真实SOE': 'AC Actual SOE',
  '站级监控/AC剩余电量': 'AC Residual Energy',
  '站级监控/AC上次放电量': 'AC Last Discharge Energy',
  '站级监控/AC上次充电量': 'AC Last Charge Energy',
  '站级监控/AC电量截止标志': 'AC Energy Cutoff Mark',
  '站级监控/AC累积放电量': 'AC Accumulated Discharge Energy',
  '站级监控/AC累积充电量': 'AC Accmulated Charge Energy',
  '站级监控/柜体累计充电量': 'Cabinet Accumulated Charge Energy',
  '站级监控/柜体累计放电量': 'Cabinet Accumulated Discharge Energy',
  '站级监控/均衡指令失效': 'Equalization Command Fail',
  '站级监控/电芯不均衡': 'Cell Unequalization',
  '站级监控/Flash写失败故障': 'Flash Write Fail',
  '站级监控/BMS故障码': 'BMS Fault Code',
  '站级监控/BMS故障属性': 'BMS Fault Attribute',
  '站级监控/电池总电压': 'Battery Total Voltage',
  '站级监控/电池总电流': 'Battery Total Current',
  '站级监控/电池充电限制电流': 'Battery Charge Current Limit',
  '站级监控/电池放电限制电流': 'Battery Discharge Current Limit',
  '站级监控/电池充电限制电压': 'Battery Charge Voltage Limit',
  '站级监控/电池放电限制电压': 'Battery Discharge Voltage Limit',
  '站级监控/直流侧安时积分': 'DC Ah Integrate',
  '站级监控/eBlock工作状态': 'eBlock Working State',
  '站级监控/电池平均电压': 'Battery Average Voltage',
  '站级监控/电池电压有效数目': 'Battery Effective Voltage Number',
  '站级监控/电池平均温度': 'Battery Average Temperature',
  '站级监控/电池温度有效数目': 'Battery Effective Temperature Number',
  '站级监控/最高电压': 'Max Voltage',
  '站级监控/最高电压BMU-ID': 'Max Voltage BMU-ID',
  '站级监控/最高电压电池位置': 'Max Voltage Cell Index',
  '站级监控/最低电压': 'Min Voltage',
  '站级监控/最低电压BMU-ID': 'Min Voltage BMU-ID',
  '站级监控/最低电压电池位置': 'Min Voltage Cell Index',
  '站级监控/最高温度': 'Max Temperature',
  '站级监控/最高温度BMU-ID': 'Max Temperature BMU-ID',
  '站级监控/最高温度电池位置': 'Max Temperature Cell Index',
  '站级监控/最低温度': 'Min Temperature',
  '站级监控/最低温度BMU-ID': 'Min Temperature BMU-ID',
  '站级监控/最低温度电池位置': 'Min Temperature Cell Index',
  '站级监控/电池系统最大允许充电功率': 'Battery System Max Permitted Charge Power',
  '站级监控/电池系统最大允许放电功率': 'Battery System Max Permitted Discharge Power',
  '站级监控/柜体故障码1': 'Cabinet Fault Code1',
  '站级监控/柜体故障码1属性': 'Cabinet Fault Code1 Attribute',
  '站级监控/柜体故障码2': 'Cabinet Fault Code2',
  '站级监控/柜体故障码2属性': 'Cabinet Fault Code2 Attribute',
  '站级监控/柜体故障码3': 'Cabinet Fault Code3',
  '站级监控/柜体故障码3属性': 'Cabinet Fault Code3 Attribute',
  '站级监控/PCS通信故障计数': 'PCS Communication Fault Number',
  '站级监控/FLASH通信故障计数': 'Flash Communication Fault Number',
  '站级监控/PCS通信丢包率': 'PCS Communication Loss Ratio',
  '站级监控/Flash操作计数': 'Flash Operation Number',
  '站级监控/EMS断网最大时长': 'EMS Offline Max Duration',
  '站级监控/EMS接收计数': 'EMS Receive Number',
  '站级监控/EMS丢数据次数计数': 'EMS Data Loss Number',
  '站级监控/EMS发送计数': 'EMS Send Number',
  '站级监控/均衡指令1': 'Equalization Command1',
  '站级监控/均衡指令2': 'Equalization Command2',
  '站级监控/均衡指令3': 'Equalization Command3',
  '站级监控/均衡指令4': 'Equalization Command4',
  '站级监控/BCS运行时长': 'BCS Operation Duration',
  '站级监控/BCS心跳': 'BCS Heartbeat',
  '站级监控/PCS心跳': 'PCS Heartbeat',
  '站级监控/EMS心跳': 'EMS Heartbeat',
  '站级监控/BMU通信故障': 'BMU Communicaiton Fault',
  '站级监控/EMS通信故障': 'EMS Communication Fault',
  '站级监控/PCS通信故障': 'PCS Communication Fault',
  '站级监控/电池管理芯片故障': 'Battery Management Chip Fault',
  '站级监控/锁机故障': 'Lock Fault',
  '站级监控/电池断线故障': 'Battery Break Fault',
  '站级监控/水机故障': 'Water Machine Fault',
  '站级监控/电气火灾': 'Electrical Fire',
  '站级监控/电池热失控': 'Battery Thermal Runaway',
  '站级监控/电芯电压失效': 'Cell Voltage Ineffective',
  '站级监控/电芯多点温度无效': 'Cell Multiple Temperature Ineffective',
  '站级监控/总压过压p1': 'Total Over Voltage P1',
  '站级监控/总压欠压p1': 'Total Under Voltage P1',
  '站级监控/电芯充电过流p1': 'Cell Charge Over Current P1',
  '站级监控/电芯放电过流p1': 'Cell Discharge Over Current P1',
  '站级监控/电芯充电过压p1': 'Cell Charge Over Voltage P1',
  '站级监控/电芯充电欠压p1': 'Cell Charge Under Voltage P1',
  '站级监控/电芯充电过温p1': 'Cell Charge Over Temperature P1',
  '站级监控/电芯充电欠温p1': 'Cell Charge Under Temperature P1',
  '站级监控/电芯放电过温p1': 'Cell Discharge Over Temperature P1',
  '站级监控/电芯放电欠温p1': 'Cell Discharge Under Temperature P1',
  '站级监控/电芯温度充电极差P1': 'Cell Charge Temperature Difference P1',
  '站级监控/电芯温度放电极差P1': 'Cell Discharge Temperature Difference P1',
  '站级监控/电芯电压充电极差P1': 'Cell Charge Voltage Difference P1',
  '站级监控/电芯电压放电极差P1': 'Cell Discharge Voltage Difference P1',
  '站级监控/水机通信故障': 'Water Machine Communication Fault',
  '站级监控/门禁故障': 'Entrance Guard Fault',
  '站级监控/电池断线故障': 'Battery Break Fault',
  '站级监控/直流电压采样故障': 'DC Voltage Sampling Fault',
  '站级监控/MSD故障': 'MSD Fault',
  '站级监控/BCS运行模式故障': 'BCS Operation Mode Fault',
  '站级监控/电气火灾': 'Electrical Fire ',
  '站级监控/电池热失控': 'Battery Thermal Runaway',
  '站级监控/水冷告警': 'Water Cooling Alarm',
  '站级监控/水冷故障': 'Water Cooling Fault',
  '站级监控/电池管理芯片故障': 'Battery Management Chip Fault',
  '站级监控/烟感报警': 'Smoke Sensor Alarm',
  '站级监控/高温报警': 'High Temperature Alarm',
  '站级监控/CO报警': 'CO Alarm',
  '站级监控/柜体气溶胶': 'Cabinet Aerosol',
  '站级监控/锁机故障': 'Lock Fault',
  '站级监控/PCS通信故障': 'PCS Communication Fault',
  '站级监控/BMU通信故障': 'BMU Communication Fault',
  '站级监控/EMS通信故障': 'EMS Communication Fault',
  '站级监控/水冷通信故障': 'Water Cooling Communication Fault',
  '站级监控/FLASH通信故障': 'Flash Communication Fault',
  '站级监控/消防通信故障': 'Fire Communication Fault',
  '站级监控/电池管理芯片通信故障': 'Battery Management Chip Communication Fault',
  '站级监控/风机通信故障': 'Wind Turbine Communication Fault',
  '站级监控/除湿机通信故障': 'Dehumidifier Communication Fault',
  '站级监控/BMU1通信': 'BMU1 Communication ',
  '站级监控/BMU2通信': 'BMU2 Communication ',
  '站级监控/BMU3通信': 'BMU3 Communication ',
  '站级监控/BMU4通信': 'BMU4 Communication ',
  '站级监控/电池充电过压P1': 'Battery Charge Over Voltage P1',
  '站级监控/电池充电过压P2': 'Battery Charge Over Voltage P2',
  '站级监控/电池充电过压P3': 'Battery Charge Over Voltage P3',
  '站级监控/电池充电过压截止': 'Battery Charge Over Voltage Cutoff',
  '站级监控/电池放电欠压P1': 'Battery Discharge Under Voltage P1',
  '站级监控/电池放电欠压P2': 'Battery Discharge Under Voltage P2',
  '站级监控/电池放电欠压P3': 'Battery Discharge Under Voltage P3',
  '站级监控/电池放电欠压截止': 'Battery Discharge Under Voltage Cutoff',
  '站级监控/电池总电压过压P1': 'Battery Total Over Voltage P1',
  '站级监控/电池总电压过压P2': 'Battery Total Over Voltage P2',
  '站级监控/电池总电压过压P3': 'Battery Total Over Voltage P3',
  '站级监控/电池总电压过压截止': 'Battery Total Over Voltage Cutoff',
  '站级监控/电池总电压欠压P1': 'Battery Total Under Voltage P1',
  '站级监控/电池总电压欠压P2': 'Battery Total Under Voltage P2',
  '站级监控/电池总电压欠压P3': 'Battery Total Under Voltage P3',
  '站级监控/电池总电压欠压截止': 'Battery Total Under Voltage Cutoff',
  '站级监控/电池充电电压极差P1': 'Battery Charge Voltage Difference P1',
  '站级监控/电池充电电压极差P2': 'Battery Charge Voltage Difference P2',
  '站级监控/电池充电电压极差P3': 'Battery Charge Voltage Difference P3',
  '站级监控/电池充电电压极差截止': 'Battery Charge Voltage Difference Cutoff',
  '站级监控/电池放电电压极差P1': 'Battery Discharge Voltage Difference P1',
  '站级监控/电池放电电压极差P2': 'Battery Discharge Voltage Difference P2',
  '站级监控/电池放电电压极差P3': 'Battery Discharge Voltage Difference P3',
  '站级监控/电池放电电压极差截止': 'Battery Discharge Voltage Difference Cutoff',
  '站级监控/电池电压失效': 'Battery Voltage Ineffective',
  '站级监控/电池充电过温度P1': 'Battery Charge Over Temperature P1',
  '站级监控/电池充电过温度P2': 'Battery Charge Over Temperature P2',
  '站级监控/电池充电过温度P3': 'Battery Charge Over Temperature P3',
  '站级监控/电池充电过温度截止': 'Battery Charge Over Temperature Cutoff',
  '站级监控/电池充电欠温度P1': 'Battery Charge Under Temperature P1',
  '站级监控/电池充电欠温度P2': 'Battery Charge Under Temperature P2',
  '站级监控/电池充电欠温度P3': 'Battery Charge Under Temperature P3',
  '站级监控/电池充电欠温度截止': 'Battery Charge Under Temperature Cutoff',
  '站级监控/电池放电过温度P1': 'Battery Discharge Over Temperature P1',
  '站级监控/电池放电过温度P2': 'Battery Discharge Over Temperature P2',
  '站级监控/电池放电过温度P3': 'Battery Discharge Over Temperature P3',
  '站级监控/电池放电过温度截止': 'Battery Discharge Over Temperature Cutoff',
  '站级监控/电池放电欠温度P1': 'Battery Discharge Under Temperature P1',
  '站级监控/电池放电欠温度P2': 'Battery Discharge Under Temperature P2',
  '站级监控/电池放电欠温度P3': 'Battery Discharge Under Temperature P3',
  '站级监控/电池放电欠温度截止': 'Battery Discharge Under Temperature Cutoff',
  '站级监控/电池充电温度极差P1': 'Battery Charge Temperature Difference P1',
  '站级监控/电池充电温度极差P2': 'Battery Charge Temperature Difference P2',
  '站级监控/电池充电温度极差P3': 'Battery Charge Temperature Difference P3',
  '站级监控/电池充电温度极差STOP': 'Battery Charge Temperature Difference Cutoff',
  '站级监控/电池放电温度极差P1': 'Battery Discharge Temperature Difference P1',
  '站级监控/电池放电温度极差P2': 'Battery Discharge Temperature Difference P2',
  '站级监控/电池放电温度极差P3': 'Battery Discharge Temperature Difference P3',
  '站级监控/电池放电温度极差STOP': 'Battery Discharge Temperature Difference Cutoff',
  '站级监控/电池单点温度无效': 'Battery Single Temperature Ineffective',
  '站级监控/电池多点温度无效': 'Battery Multiple Temperature Ineffective',
  '站级监控/电芯充电过流P1': 'Cell Charge Over Current P1',
  '站级监控/电芯充电过流P2': 'Cell Charge Over Current P2',
  '站级监控/电芯充电过流P3': 'Cell Charge Over Current P3',
  '站级监控/电芯充电过流截止': 'Cell Charge Over Current Cutoff',
  '站级监控/电芯放电过流P1': 'Cell Discharge Over Current P1',
  '站级监控/电芯放电过流P2': 'Cell Discharge Over Current P2',
  '站级监控/电芯放电过流P3': 'Cell Discharge Over Current P3',
  '站级监控/电芯放电过流截止': 'Cell Discharge Over Current Cutoff',
  '站级监控/电器火灾锁定': 'Electrical Fire Lock',
  '站级监控/电池热失控锁定': 'Battery Thermal Runaway Lock',
  '站级监控/DI1状态': 'DI1 State',
  '站级监控/DI2状态': 'DI2 State',
  '站级监控/DI3状态': 'DI3 State',
  '站级监控/DI4状态': 'DI4 State',
  '站级监控/DI5状态': 'DI5 State',
  '站级监控/DI6状态': 'DI6 State',
  '站级监控/DI7状态': 'DI7 State',
  '站级监控/DI8状态': 'DI8 State',
  '站级监控/DI9状态': 'DI9 State',
  '站级监控/DI10状态': 'DI10 State',
  '站级监控/DI11状态': 'DI11 State',
  '站级监控/DI12状态': 'DI12 State',
  '站级监控/DI13状态': 'DI13 State',
  '站级监控/DI14状态': 'DI14 State',
  '站级监控/DI15状态': 'DI15 State',
  '站级监控/DI16状态': 'DI16 State',
  '站级监控/DO1状态': 'DO1 State',
  '站级监控/DO2状态': 'DO2 State',
  '站级监控/DO3状态': 'DO3 State',
  '站级监控/DO4状态': 'DO4 State',
  '站级监控/DO5状态': 'DO5 State',
  '站级监控/DO6状态': 'DO6 State',
  '站级监控/DO7状态': 'DO7 State',
  '站级监控/DO8状态': 'DO8 State',
  '站级监控/DO9状态': 'DO9 State',
  '站级监控/DO10状态': 'DO10 State',
  '站级监控/DO11状态': 'DO11 State',
  '站级监控/DO12状态': 'DO12 State',
  '站级监控/DO13状态': 'DO13 State',
  '站级监控/DO14状态': 'DO14 State',
  '站级监控/DO15状态': 'DO15 State',
  '站级监控/DO16状态': 'DO16 State',
  '站级监控/PACK总电压': 'PACK Total Voltage',
  '站级监控/PACK正焊接排温度': 'PACK Positive Busbar Temperature',
  '站级监控/PACK负焊接排温度': 'PACK Negative Busbar Temperature',
  '站级监控/露点温度': 'Dew Point Temperature',
  '站级监控/电池管理芯片1温度': 'Battery Management Chip1 Temperature',
  '站级监控/电池管理芯片2温度': 'Battery Management Chip2 Temperature',
  '站级监控/BMU-APP版本号': 'BMU-APP Version',
  '站级监控/BMU-BOOT版本号': 'BMU-BOOT Version',
  '站级监控/BMU编号': 'BMU Code',
  '站级监控/LTC6813-1通信故障': 'LTC6813-1 Communication Fault',
  '站级监控/LTC6813-2通信故障': 'LTC6813-2 Communication Fault',
  '站级监控/LTC6813-3通信故障': 'LTC6813-3 Communication Fault',
  '站级监控/LTC6813-4通信故障': 'LTC6813-4 Communication Fault',
  '站级监控/LTC6813-PEC通信故障': 'LTC6813-PEC Communication Fault',
  '站级监控/BMU-CAN通信故障': 'BMU-CAN Communication Fault',
  '站级监控/均衡异常': 'Equalization Abnormal',
  '站级监控/电池采样芯片1总负断线': 'Battery Sampling Chip1 Main Negative Break',
  '站级监控/电池采样芯片2总负断线': 'Battery Sampling Chip2 Main Negative Break',
  '站级监控/电池采样芯片3总负断线': 'Battery Sampling Chip3 Main Negative Break',
  '站级监控/电池采样芯片4总负断线': 'Battery Sampling Chip4 Main Negative Break',
  '站级监控/电池采集芯片高温': 'Battery Sampling Chip High Temperature',
  '站级监控/AFE-1采样故障': 'AFE-1 Sampling Fault',
  '站级监控/AFE-2采样故障': 'AFE-2 Sampling Fault',
  '站级监控/AFE-3采样故障': 'AFE-3 Sampling Fault',
  '站级监控/AFE-4采样故障': 'AFE-4 Sampling Fault',
  '站级监控/正母排温度断线': 'Positive Busbar Temperature Break',
  '站级监控/负母排温度断线': 'Negative Busbar Temperature Break',
  '站级监控/BCS均衡控制帧通信故障': 'BCS Equalization Control Frame Communication Fault',
  '站级监控/电池焊接排温度断线': 'Battery Busbar Temperature Break',
  '站级监控/MSD温度断线': 'MSD Temperature Break',
  '站级监控/CELL-1均衡': 'Cell-1 Equalization',
  '站级监控/CELL-2均衡': 'Cell-2 Equalization',
  '站级监控/CELL-3均衡': 'Cell-3 Equalization',
  '站级监控/CELL-4均衡': 'Cell-4 Equalization',
  '站级监控/CELL-5均衡': 'Cell-5 Equalization',
  '站级监控/CELL-6均衡': 'Cell-6 Equalization',
  '站级监控/CELL-7均衡': 'Cell-7 Equalization',
  '站级监控/CELL-8均衡': 'Cell-8 Equalization',
  '站级监控/CELL-9均衡': 'Cell-9 Equalization',
  '站级监控/CELL-10均衡': 'Cell-10 Equalization',
  '站级监控/CELL-11均衡': 'Cell-11 Equalization',
  '站级监控/CELL-12均衡': 'Cell-12 Equalization',
  '站级监控/CELL-13均衡': 'Cell-13 Equalization',
  '站级监控/CELL-14均衡': 'Cell-14 Equalization',
  '站级监控/CELL-15均衡': 'Cell-15 Equalization',
  '站级监控/CELL-16均衡': 'Cell-16 Equalization',
  '站级监控/CELL-17均衡': 'Cell-17 Equalization',
  '站级监控/CELL-18均衡': 'Cell-18 Equalization',
  '站级监控/CELL-19均衡': 'Cell-19 Equalization',
  '站级监控/CELL-20均衡': 'Cell-20 Equalization',
  '站级监控/CELL-21均衡': 'Cell-21 Equalization',
  '站级监控/CELL-22均衡': 'Cell-22 Equalization',
  '站级监控/CELL-23均衡': 'Cell-23 Equalization',
  '站级监控/CELL-24均衡': 'Cell-24 Equalization',
  '站级监控/CELL-25均衡': 'Cell-25 Equalization',
  '站级监控/CELL-26均衡': 'Cell-26 Equalization',
  '站级监控/CELL-27均衡': 'Cell-27 Equalization',
  '站级监控/CELL-28均衡': 'Cell-28 Equalization',
  '站级监控/CELL-29均衡': 'Cell-29 Equalization',
  '站级监控/CELL-30均衡': 'Cell-30 Equalization',
  '站级监控/CELL-31均衡': 'Cell-31 Equalization',
  '站级监控/CELL-32均衡': 'Cell-32 Equalization',
  '站级监控/CELL-1电压断线': 'Cell-1 Voltage Break',
  '站级监控/CELL-2电压断线': 'Cell-2 Voltage Break',
  '站级监控/CELL-3电压断线': 'Cell-3 Voltage Break',
  '站级监控/CELL-4电压断线': 'Cell-4 Voltage Break',
  '站级监控/CELL-5电压断线': 'Cell-5 Voltage Break',
  '站级监控/CELL-6电压断线': 'Cell-6 Voltage Break',
  '站级监控/CELL-7电压断线': 'Cell-7 Voltage Break',
  '站级监控/CELL-8电压断线': 'Cell-8 Voltage Break',
  '站级监控/CELL-9电压断线': 'Cell-9 Voltage Break',
  '站级监控/CELL-10电压断线': 'Cell-10 Voltage Break',
  '站级监控/CELL-11电压断线': 'Cell-11 Voltage Break',
  '站级监控/CELL-12电压断线': 'Cell-12 Voltage Break',
  '站级监控/CELL-13电压断线': 'Cell-13 Voltage Break',
  '站级监控/CELL-14电压断线': 'Cell-14 Voltage Break',
  '站级监控/CELL-15电压断线': 'Cell-15 Voltage Break',
  '站级监控/CELL-16电压断线': 'Cell-16 Voltage Break',
  '站级监控/CELL-17电压断线': 'Cell-17 Voltage Break',
  '站级监控/CELL-18电压断线': 'Cell-18 Voltage Break',
  '站级监控/CELL-19电压断线': 'Cell-19 Voltage Break',
  '站级监控/CELL-20电压断线': 'Cell-20 Voltage Break',
  '站级监控/CELL-21电压断线': 'Cell-21 Voltage Break',
  '站级监控/CELL-22电压断线': 'Cell-22 Voltage Break',
  '站级监控/CELL-23电压断线': 'Cell-23 Voltage Break',
  '站级监控/CELL-24电压断线': 'Cell-24 Voltage Break',
  '站级监控/CELL-25电压断线': 'Cell-25 Voltage Break',
  '站级监控/CELL-26电压断线': 'Cell-26 Voltage Break',
  '站级监控/CELL-27电压断线': 'Cell-27 Voltage Break',
  '站级监控/CELL-28电压断线': 'Cell-28 Voltage Break',
  '站级监控/CELL-29电压断线': 'Cell-29 Voltage Break',
  '站级监控/CELL-30电压断线': 'Cell-30 Voltage Break',
  '站级监控/CELL-31电压断线': 'Cell-31 Voltage Break',
  '站级监控/CELL-32电压断线': 'Cell-32 Voltage Break',
  '站级监控/CELL-1温度断线': 'Cell-1 Temperature Break',
  '站级监控/CELL-2温度断线': 'Cell-2 Temperature Break',
  '站级监控/CELL-3温度断线': 'Cell-3 Temperature Break',
  '站级监控/CELL-4温度断线': 'Cell-4 Temperature Break',
  '站级监控/CELL-5温度断线': 'Cell-5 Temperature Break',
  '站级监控/CELL-6温度断线': 'Cell-6 Temperature Break',
  '站级监控/CELL-7温度断线': 'Cell-7 Temperature Break',
  '站级监控/CELL-8温度断线': 'Cell-8 Temperature Break',
  '站级监控/CELL-9温度断线': 'Cell-9 Temperature Break',
  '站级监控/CELL-10温度断线': 'Cell-10 Temperature Break',
  '站级监控/CELL-11温度断线': 'Cell-11 Temperature Break',
  '站级监控/CELL-12温度断线': 'Cell-12 Temperature Break',
  '站级监控/CELL-13温度断线': 'Cell-13 Temperature Break',
  '站级监控/CELL-14温度断线': 'Cell-14 Temperature Break',
  '站级监控/CELL-15温度断线': 'Cell-15 Temperature Break',
  '站级监控/CELL-16温度断线': 'Cell-16 Temperature Break',
  '站级监控/CELL-17温度断线': 'Cell-17 Temperature Break',
  '站级监控/CELL-18温度断线': 'Cell-18 Temperature Break',
  '站级监控/CELL-19温度断线': 'Cell-19 Temperature Break',
  '站级监控/CELL-20温度断线': 'Cell-20 Temperature Break',
  '站级监控/CELL-21温度断线': 'Cell-21 Temperature Break',
  '站级监控/CELL-22温度断线': 'Cell-22 Temperature Break',
  '站级监控/CELL-23温度断线': 'Cell-23 Temperature Break',
  '站级监控/CELL-24温度断线': 'Cell-24 Temperature Break',
  '站级监控/CELL-25温度断线': 'Cell-25 Temperature Break',
  '站级监控/CELL-26温度断线': 'Cell-26 Temperature Break',
  '站级监控/CELL-27温度断线': 'Cell-27 Temperature Break',
  '站级监控/CELL-28温度断线': 'Cell-28 Temperature Break',
  '站级监控/CELL-29温度断线': 'Cell-29 Temperature Break',
  '站级监控/CELL-30温度断线': 'Cell-30 Temperature Break',
  '站级监控/CELL-31温度断线': 'Cell-31 Temperature Break',
  '站级监控/CELL-32温度断线': 'Cell-32 Temperature Break',
  '站级监控/BMU软件ID': 'BMU Software ID',
  '站级监控/BMU编号': 'BMU Code',
  '站级监控/烟雾浓度': 'Smoke Concentration',
  '站级监控/柜体温度': 'cabinet_temp',
  '站级监控/CO浓度': 'CO Concentration',
  '站级监控/VOC浓度': 'VOC Concentration',
  '站级监控/探测器状态': 'Detector State',
  '站级监控/上风机故障状态': 'Upper Wind Turbine Fault State',
  '站级监控/上风机换气设置': 'Upper Wind Turbine Ventilation Set',
  '站级监控/上风机风门状态': 'Upper Wind Turbine Door State',
  '站级监控/上风机状态': 'Upper Wind Turbine State',
  '站级监控/下风机故障状态': 'Lower Wind Turbine Fault State',
  '站级监控/下风机换气设置': 'Lower Wind Turbine Ventilation Set',
  '站级监控/下风机风门状态': 'Lower Wind Turbine Door State',
  '站级监控/下风机状态': 'Lower Wind Turbine State',
  '站级监控/电池火灾VOC浓度限值': 'Battery Fire VOC Concentration Limit',
  '站级监控/柜体火灾温度上限值': 'Cabinet Fire Temperature Limit',
  '站级监控/柜体高温门限值': 'Cabinet High Temperature Limit',
  '站级监控/柜体烟雾门限值': 'Cabinet Smoke Limit',
  '站级监控/加热开启温度': 'Heat Start Temperature',
  '站级监控/环境温度值': 'Ambient Temperature',
  '站级监控/环境湿度值': 'Environment Humidity',
  '站级监控/加热状态': 'Heat State',
  '站级监控/除湿机状态': 'Dehumidifier State',
  '站级监控/除湿机控制模式': 'Dehumidifer Control Mode',
  '站级监控/控湿开启值': 'Control Humidity Start Value',
  '站级监控/控湿停止值': 'Contrl Humidity Stop Value',
  '站级监控/pack出水温度': 'PACK Output Water Temperature',
  '站级监控/pack回水温度': 'PACK Input Water Temperature',
  '站级监控/pack进水口压力值': 'PACK Input Water Pressure',
  '站级监控/pack出水口压力值': 'PACK Output Water Pressure',
  '站级监控/pack泵转速': 'PACK Pump Speed',
  '站级监控/BMS请求设定温度': 'BMS Request Set Temperature',
  '站级监控/BMS请求设定模式': 'BMS Request Set Mode',
  '站级监控/水机通信计数': 'Water Machine Communication Number',
  '站级监控/pack工作状态': 'PACK Working State',
  '站级监控/压缩机': 'Compressor',
  '站级监控/压缩机加热带': 'Compressor Heat Strip',
  '站级监控/电加热': 'Electrical Heat',
  '站级监控/风机1': 'Wind Turbine1',
  '站级监控/风机2': 'Wind Turbine2',
  '站级监控/风机3': 'Wind Turbine3',
  '站级监控/风机4': 'Wind Turbine4',
  '站级监控/PCS泵转速': 'PCS Pump Speed',
  '站级监控/PCS工作状态': 'PCS Working State',
  '站级监控/PCS出水温度': 'PCS Output Water Temperature',
  '站级监控/PCS回水温度': 'PCS Input Water Temperature',
  '站级监控/PCS进水口压力值': 'PCS Input Water Pressure',
  '站级监控/PCS出水口压力值': 'PCS Output Water Pressure',
  '站级监控/出风温度': 'Output Wind Temperature',
  '站级监控/环境温度': 'Ambient Temperature',
  '站级监控/系统高压压力': 'System Hight Pressure Value',
  '站级监控/FC阀开度': 'FC Valve Opening',
  '站级监控/风扇1转速': 'Fan1 Speed',
  '站级监控/风扇2转速': 'Fan2 Speed',
  '站级监控/风扇3转速': 'Fan3 Speed',
  '站级监控/风扇4转速': 'Fan4 Speed',
  '站级监控/pack供水泵': 'PACK Water Pump',
  '站级监控/pcs供水泵': 'PCS Water Pump',
  '站级监控/压机转速': 'Compressor Speed',
  '站级监控/进风温度': 'Input Wind Temperature',
  '站级监控/pack故障编码': 'PACK Fault Code',
  '站级监控/pack故障等级': 'PACK Fault Level',
  '站级监控/pcs故障编码': 'PCS Fault Code',
  '站级监控/pcs故障等级': 'PCS Fault Level',
  '站级监控/控制模式': 'Control Mode',
  '站级监控/运行模式': 'Operation Mode',
  '站级监控/制冷设定温度': 'Refrigeration Set Temperature',
  '站级监控/制热设定温度': 'Heat Set Temperature',
  '站级监控/Pack消防信息': 'Pack Fire Information',



  // 光伏监控
  '光伏监控/光伏': 'Photovoltaic',
  '光伏监控/光伏概况': 'Photovoltaic Overview',
  '光伏监控/光伏列表': 'Photovoltaic List',
  '光伏监控/更新时间': 'Update Time',
  '光伏监控/功率曲线': 'Power Curve',
  '光伏监控/总有功功率': 'Total Active Power',
  '光伏监控/总无功功率': 'Total Reactive Power',
  '光伏监控/总功率因数': 'Total Power Factor',
  '光伏监控/日发电量': 'Daily Generation',
  '光伏监控/总发电量': 'Total Generation',
  '光伏监控/总功率': 'Total Power',
  '光伏监控/系统状态': 'System State',
  '光伏监控/有功功率': 'Active Power',
  '光伏监控/查看日发电量统计': 'View Daily Generation Statistics',
  '光伏监控/光伏个数': 'Photovoltaic Number',
  '光伏监控/时间': 'Time',
  '光伏监控/无功功率': 'Reactive Power',
  '光伏监控/日出': 'Sunrise',
  '光伏监控/日落': 'Sunset',
  '光伏监控/日出日落时间': 'Sunrise and Sunset Time',
  '光伏监控/光伏每日发电量统计': 'Photovoltaic Daily Generation Statistics',
  '光伏监控/查询': 'Query',
  
  /* 电站地图 */
  '电站地图/点击地图进行面积测量，双击结束绘制': 'Click on the map to measure the area, double-click to end the drawing',
  '电站地图/知道了': 'OK',
  '电站地图/搜索电站': 'Search Station',
  '电站地图/装机容量': 'Installed Capacity',
  '电站地图/点击进入': 'Click to Enter',
  '电站地图/面积测量': 'Area Measurement',
  '电站地图/清除面积测量': 'Clear Area Measurement',
  '电站地图/面积测量': 'Area Measurement',
  '电站地图/地址': 'Address',

  /* EMS */
  '站级监控/产品型号': 'Product Model',
  '站级监控/产品序列号': 'Product Serial Number',
  '站级监控/硬件版本': 'Hardware Version',
  '站级监控/BOOT版本': 'BOOT Version',
  '站级监控/APP版本': 'APP Version',
  '站级监控/MCU温度': 'MCU Temperature',
  '站级监控/逆变A相IGBT温度': 'Inverter A Phase IGBT Temperature',
  '站级监控/逆变B相IGBT温度': 'Inverter B Phase IGBT Temperature',
  '站级监控/逆变C相IGBT温度': 'Inverter C Phase IGBT Temperature',
  '站级监控/逆变不平衡桥温度': 'Inverter Unbalance Bridge Temperature',
  '站级监控/DCDC_MOS温度': 'DCDC MOS Temperature',
  '站级监控/MPPT_MOS温度': 'MPPT MOS Temperature',
  '站级监控/24V蓄电池电压': 'Battery 24V Voltage',
  '站级监控/（电表）A相电压': 'Meter A Phase Voltage',
  '站级监控/（电表）B相电压': 'Meter B Phase Voltage',
  '站级监控/（电表）C相电压': 'Meter C Phase Voltage',
  '站级监控/（电表）AB线电压': 'Meter AB Line Voltage',
  '站级监控/（电表）BC线电压': 'Meter BC Line Voltage',
  '站级监控/（电表）CA线电压': 'Meter CA Line Voltage',
  '站级监控/（电表）A相电流': 'Meter A Phase Current',
  '站级监控/（电表）B相电流': 'Meter B Phase Current',
  '站级监控/（电表）C相电流': 'Meter C Phase Current',
  '站级监控/（电表）A相有功功率': 'Meter A Phase Active Power',
  '站级监控/（电表）B相有功功率': 'Meter B Phase Active Power',
  '站级监控/（电表）C相有功功率': 'Meter C Phase Active Power',
  '站级监控/（电表）合相有功功率': 'Meter Total Active Power',
  '站级监控/（电表）A相无功功率': 'Meter A Phase Reactive Power',
  '站级监控/（电表）B相无功功率': 'Meter B Phase Reactive Power',
  '站级监控/（电表）C相无功功率': 'Meter C Phase Reactive Power',
  '站级监控/（电表）合相无功功率': 'Meter Total Reactive Power',
  '站级监控/（电表）A相功率因数': 'Meter A Phase Power Factor',
  '站级监控/（电表）B相功率因数': 'Meter B Phase Power Factor',
  '站级监控/（电表）C相功率因数': 'Meter C Phase Power Factor',
  '站级监控/（电表）总功率因数': 'Meter Total Power Factor',
  '站级监控/（电表）频率': 'Meter Frequency',
  '站级监控/（电表）正向有功总电能': 'Meter Positive Total Active Energy',
  '站级监控/（电表）A相正向有功电能': 'Meter A Phase Positive Active Energy',
  '站级监控/（电表）B相正向有功电能': 'Meter B Phase Positive Active Energy',
  '站级监控/（电表）C相正向有功电能': 'Meter C Phase Positive Active Energy',
  '站级监控/（电表）正向有功净电能': 'Meter Positive Net Active Energy',
  '站级监控/反向有功总电能': 'Meter Negative Total Reactive Energy',
  '站级监控/A相反向有功电能': 'Meter A Phase Negative Active Energy',
  '站级监控/B相反向有功电能': 'Meter B Phase Negative Active Energy',
  '站级监控/C相反向有功电能': 'Meter C Phase Negative Active Energy',
  '站级监控/反向有功净电能': 'Meter Negative Net Active Energy',
  '站级监控/EMS运行状态': 'EMS Operation State',
  '站级监控/并离网状态': 'Grid-Connected-Disconnected State',
  '站级监控/负载消耗状态': 'Load Consumption State',
  '站级监控/PV输出功率状态': 'PV Output Power State',
  '站级监控/电网电能状态': 'Grid Energy State',
  '站级监控/门碰': 'Door Suck',
  '站级监控/急停': 'Emergency Stop',
  '站级监控/黑启动': 'Black Start',
  '站级监控/DRM1': 'DRM1',
  '站级监控/DRM2': 'DRM2',
  '站级监控/DRM3': 'DRM3',
  '站级监控/DRM4': 'DRM4',
  '站级监控/DRM5': 'DRM5',
  '站级监控/DRM6': 'DRM6',
  '站级监控/BCS通信故障': 'BCS Communication Fault',
  '站级监控/BCS通信CRC故障': 'BCS Communication CRC Fault',
  '站级监控/1路SCI通信故障': 'Bus1 SCI Communication Fault',
  '站级监控/2路SCI通信故障': 'Bus2 SCI Comunication Fault',
  '站级监控/电表通信故障': 'Meter Communication Fault',
  '站级监控/Flash通信故障': 'Flash Communication Fault',
  '站级监控/EEprom通信故障': 'EEPROM Communication Fault',
  '站级监控/除湿机通信故障': 'Dehumidifier Communication Fault',
  '站级监控/排风机通信故障': 'Ventilation Communication Fault',
  '站级监控/逆变A相IGBT过温保护': 'Inverter A Phase IGBT Over Temperature Protection',
  '站级监控/逆变B相IGBT过温保护': 'Inverter B Phase IGBT Over Temperature Protection',
  '站级监控/逆变C相IGBT过温保护': 'Inverter C Phase IGBT Over Temperature Protection',
  '站级监控/逆变平衡桥过温保护': 'Inverter Balance Bridge Over Temperature Protection',
  '站级监控/DCDC_MOS过温保护': 'DCDC MOS Over Temperature Protection',
  '站级监控/MPPT_MOS过温保护': 'MPPT MOS Over Temperature Protection',
  '站级监控/电网电压A相互校异常': 'Grid A Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/电网电压B相互校异常': 'Grid B Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/电网电压C相互校异常': 'Grid C Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/逆变电压A相互校异常': 'Inverter A Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/逆变电压B相互校异常': 'Inverter B Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/逆变电压C相互校异常': 'Inverter C Phase Voltage Mutual Calibrate Abnormal',
  '站级监控/逆变A相IGBT过温告警': 'Inverter A Phase IGBT Over Temperature Alarm',
  '站级监控/逆变B相IGBT过温告警': 'Inverter B Phase IGBT Over Temperature Alarm',
  '站级监控/逆变C相IGBT过温告警': 'Inverter C Phase IGBT Over Temperature Alarm',
  '站级监控/离网过载': 'Off-Grid Over Load',
  '站级监控/逆变A相IGBT NTC开路': 'Inverter A Phase IGBT NTC Open Circuit',
  '站级监控/逆变A相IGBT NTC短路': 'Inverter A Phase IGBT NTC Short Circuit',
  '站级监控/逆变B相IGBT NTC开路': 'Inverter B Phase IGBT NTC Open Circuit',
  '站级监控/逆变B相IGBT NTC短路': 'Inverter B Phase IGBT NTC Short Circuit',
  '站级监控/逆变C相IGBT NTC开路': 'Inverter C Phase IGBT NTC Open Circuit',
  '站级监控/逆变C相IGBT NTC短路': 'Inverter C Phase IGBT NTC Short Circuit',
  '站级监控/逆变不平衡桥 NTC开路': 'Inverter Unbalance Bridge NTC Open Circuit',
  '站级监控/逆变不平衡桥 NTC短路': 'Inverter Unbalance Bridge NTC Short Circuit',
  '站级监控/DCDC_MOS NTC开路': 'DCDC MOS NTC Open Circuit',
  '站级监控/DCDC_MOS NTC短路': 'DCDC MOS NTC Short Circuit',
  '站级监控/MPPT_MOS NTC开路': 'MPPT MOS NTC Open Circuit',
  '站级监控/MPPT_MOS NTC短路': 'MPPT MOS NTC Short Circuit',
  '站级监控/24V蓄电池过压': 'Battery 24V Over Voltage',
  '站级监控/24V蓄电池欠压': 'Battery 24V Under Voltage',
  '站级监控/RTC时间类型异常': 'RTC Time Type Abnormal',
  '站级监控/SD卡检测任务创建失败': 'SD Check Task Create Fail',
  '站级监控/SD卡HOST初始化失败': 'SD HOST Initialization Fail',
  '站级监控/SD卡不存在': 'SD Not Exist',
  '站级监控/SD卡挂在失败': 'SD Mount Fail',
  '站级监控/SD卡格式化失败': 'SD Format Fail',
  '站级监控/SD卡修改驱动盘符失败': 'SD Modify Driver Dish Symbol Fail',
  '站级监控/SD卡打开文件失败': 'SD Open File Fail',
  '站级监控/SD卡写文件失败': 'SD Write File Fail',
  '站级监控/SD卡读文件失败': 'SD Read File Fail',


  '站级监控/天': 'Day',
  '站级监控/元': 'Yuan',
  '站级监控/光伏': 'Photovoltaic',
  '站级监控/eBlock详情': 'eBlock Details',
  '站级监控/电压': 'Voltage',
  '站级监控/电流': 'Current',
  '站级监控/温度': 'Temperature',
  '站级监控/内阻': 'Resistance',
  '站级监控/系统内存占用': 'System Memory Usage',
  '站级监控/电芯数量': 'Number',
  '站级监控/电芯温度': 'T',
  '站级监控/电芯电压': 'V',
  '站级监控/电芯内阻': 'R',
  '站级监控/正常电芯': 'Normal',
  '站级监控/低温电芯': 'Low Temperature',
  '站级监控/高温电芯': 'High Temperature',
  '站级监控/电芯': 'Cell',
  '站级监控/pack编号': 'Pack Index',
  '站级监控/电芯编号': 'Cell Index',
  '站级监控/号': 'No.',
  '站级监控/全部': 'All',
  
  

  /* 时段电价 */
  '时段电价/自定义电价': 'Custom Price',
  '时段电价/时段电价': 'Periodic Price',
  '时段电价/当前电站使用的电价': 'Current Station Price',
  '时段电价/电价名称': 'Price Name',
  '时段电价/新增电价': 'Add Price',
  '时段电价/尖峰': 'Sharp',
  '时段电价/高峰': 'Peak',
  '时段电价/平': 'Flat',
  '时段电价/低谷': 'Valley',
  '时段电价/深谷': 'Deep Valley',
  '时段电价/预设状态': 'Preset State',
  '时段电价/已预设': 'Preset',
  '时段电价/未预设': 'Not Preset',
  '时段电价/创建人': 'Creator',
  '时段电价/创建时间': 'Create Time',
  '时段电价/生效月份': 'Effective Month',
  '时段电价/操作': 'Operation',
  '时段电价/查看': 'View',
  '时段电价/设为默认': 'Set as Default',
  '时段电价/编辑': 'Edit',
  '时段电价/此表为当前电站所使用的电价，纯展示': 'This table is the current station price, pure display',
  '时段电价/需要修改电价时，先在右侧电价表中查看，如有需要的电价则直接设为默认电价，如无则新增电价': 'If you need to modify the price, first check in the right price table, if there is a price you need, set it as the default price directly, if not, add a new price',
  '时段电价/新增电价必须输入电价名称，按格式规范填写': 'The new price must be input the price name, and fill in the format specification',
  '时段电价/确定要将此电价设置为默认吗': 'Are you sure you want to set this price as default?',
  '时段电价/当前电价已更新': 'Current price has been updated',
  '时段电价/是否删除该电价记录': 'Are you sure you want to delete this price record?',
  '时段电价/删除成功': 'Delete Success',
  '时段电价/确定': 'Confirm',
  '时段电价/取消': 'Cancel',
  '时段电价/提示': 'Notice',


  '时段电价/新增电价': 'Add Price',
  '时段电价/电价名称': 'Price Name',
  '时段电价/电价名称示例': 'Price Name Example',
  '时段电价/生效月份': 'Effective Month',
  '时段电价/选择月份': 'Select Month',
  '时段电价/同步国网电价': 'Sync National Grid Price',
  '时段电价/取消': 'Cancel',
  '时段电价/确定': 'Confirm',
  '时段电价/请输入电价名称': 'Please Input Price Name',
  '时段电价/请选择日期': 'Please Select Date',
  '时段电价/充电': 'Charge',
  '时段电价/放电': 'Discharge',
  '时段电价/同步成功': 'Sync Success',
  '时段电价/暂无国网电价，以新增为准': 'No National Grid Price, add as new',
  '时段电价/新增成功': 'Add Success',

  '时段电价/尖峰时段': 'Sharp Period',
  '时段电价/高峰时段': 'Peak Period',
  '时段电价/平时段': 'Flat Period',
  '时段电价/低谷时段': 'Valley Period',
  '时段电价/深谷时段': 'Deep Valley Period',
  '时段电价/充放电状态': 'Charge-Discharge State',
  '时段电价/时段': 'Period',
  '时段电价/电价(元)': 'Price(Yuan)',
  '时段电价/充放': 'Charge-Discharge',
  '时段电价/充': 'Charge',
  '时段电价/放': 'Discharge',
  '时段电价/时段电价设置提示': 'Setting Periodic Price, Step 1: Select Date on the left, Step 2: Configure Price on the right. Double-click the date on the left to fill in the price into the table',
  '时段电价/全选': 'Select All',
  '时段电价/月': 'Month',
  '时段电价/清空已选': 'Clear Selected',
  '时段电价/上个月': 'Last Month',
  '时段电价/今天': 'Today',
  '时段电价/下个月': 'Next Month',
  '时段电价/已经是最后一个时段': 'Already the last period',
  '时段电价/请检查时间格式': 'Please Check Time Format',
  '时段电价/到': 'To',
  '时段电价/开始时间': 'Start Time',
  '时段电价/结束时间': 'End Time',
  '时段电价/时间': 'Time',
  '时段电价/电价(元/kWh)': 'Price(Yuan/kWh)',
  '时段电价/元/kWh': 'Yuan/kWh',
  '时段电价/添加': 'Add',
  '时段电价/删除': 'Delete',
  '时段电价/暂无数据': 'No Data',
  '时段电价/请选择要设置的日期': 'Please Select Date',
  '时段电价/设置成功': 'Set Success',
  '时段电价/正在保存,请稍后': 'Saving, please wait',
  '时段电价/请选择生效日期': 'Please Select Effective Date',
  '时段电价/生效日期不能与已有日期重叠': 'Effective Date Cannot Overlap with Existing Date',
  '时段电价/请输入电价名称': 'Please Input Price Name',
  '时段电价/电价时段未覆盖 0-24h': 'Price Period Does Not Cover 0-24h',
  '时段电价/重新计算中，请稍候': 'Recalculating, please wait',
  '时段电价/确定要删除吗?': 'Are you sure you want to delete?',
  '时段电价/序号': 'No.',
  '时段电价/时段名称': 'Period Name',
  '时段电价/电价': 'Price',
  '时段电价/请选择名称': 'Please Select Name',
  '时段电价/请选择颜色': 'Please Select Color',
  '时段电价/选择颜色': 'Select Color',
  '时段电价/生效日期': 'Effective Date',
  '时段电价/电价历史': 'Price History',
  '时段电价/创建电价': 'Create Price',
  '时段电价/创建/编辑电价': 'Create/Edit Price',
  '时段电价/正在重新计算收益，请稍等': 'Recalculating Profit, please wait',
  '时段电价/状态': 'Status',
  '时段电价/开始日期': 'Start Date',
  '时段电价/结束日期': 'End Date',
  '时段电价/操作人': 'Operator',
  '时段电价/操作时间': 'Operation Time',
  '时段电价/已生效': 'Effective',
  '时段电价/已删除': 'Deleted',



  /* 数据补录 */
  '数据补录/能量链': 'eLink',
  '数据补录/时间段': 'Time',
  '数据补录/选择数据类型': 'Select Data Type',
  '数据补录/请输入备注': 'Please Input Remark',
  '数据补录/开始': 'Start',
  '数据补录/传输历史': 'Transmission History',
  '数据补录/操作人': 'Operator',
  '数据补录/操作时间': 'Operation Time',
  '数据补录/起始时间-结束时间': 'Start Time - End Time',
  '数据补录/数据类型': 'Data Type',
  '数据补录/传输结果': 'Transmission Result',
  '数据补录/备注': 'Remark',
  '数据补录/操作': 'Operation',
  '数据补录/删除': 'Delete',
  '数据补录/eLink数据': 'eLink Data',
  '数据补录/eBlock数据': 'eBlock Data',
  '数据补录/电芯数据': 'Cell Data',
  '数据补录/电表数据': 'Meter Data',
  '数据补录/无任何数据得到重传': 'No Data Re-Transmitted',
  '数据补录/部分数据得到重传': 'Part of the Data Re-Transmitted',
  '数据补录/所有数据都得到了重传': 'All Data Re-Transmitted',
  '数据补录/请求数据格式错误': 'Request Data Format Error',
  '数据补录/数据正在补充中': 'Data is being supplemented',
  '数据补录/确认补录?': 'Confirm Replenishment?',
  '数据补录/确认删除?': 'Confirm Delete?',
  '数据补录/删除成功': 'Delete Success',


  /* 状态 */
  '站级监控/空状态': 'Empty',
  '站级监控/停机': 'Stop',
  '站级监控/待机': 'Idle',
  '站级监控/充电': 'Charge',
  '站级监控/放电': 'DisCharge',
  '站级监控/降额': 'Degrade',
  '站级监控/告警': 'Alarm',
  '站级监控/故障': 'Fault',
  '站级监控/正常': 'Normal',
  '站级监控/关机': 'Power Off',
  '站级监控/初始状态': 'Initial State',
  '站级监控/正常状态': 'Normal State',
  '站级监控/禁充': 'Ban Charge',
  '站级监控/禁放': 'Ban Discharge',
  '站级监控/报警': 'Alarm',
  '站级监控/待机': 'Idle',
  '站级监控/故障': 'Fault',
  '站级监控/未知': 'Unknown',
  '站级监控/提示': 'Notice',
  '站级监控/建议': 'Advice',

  '站级监控/设备无该配置': 'Equipment without This Configuration',
  '站级监控/系统正常': 'System Normal',
  '站级监控/系统故障': 'System Fault',
  '站级监控/通信故障': 'Communication Fault',
  '站级监控/液位正常': 'Liquid Level Normal',
  '站级监控/未喷洒': 'Not Spray',
  '站级监控/停机': 'Stop',
  '站级监控/制热': 'Heat',
  '站级监控/制冷': 'Refrigerate',
  '站级监控/故障': 'Fault',
  '站级监控/除湿': 'Dehumidify',
  '站级监控/送风': 'Blow',
  '站级监控/开关机': 'Power on-off',
  '站级监控/BMU故障': 'BMU Fault',
  '站级监控/BMU告警': 'BMU Alarm',
  '站级监控/电池电压故障': 'Battery Voltage Fault',
  '站级监控/电池电压告警': 'Battery Voltage Alarm',
  '站级监控/电池温度故障': 'Battery Temperature Fault',
  '站级监控/电池温度告警': 'Battery Temperature Alarm',
  '站级监控/柜体通信故障': 'Cabinet Communication Fault',
  '站级监控/柜体通信告警': 'Cabinet Communication Alarm',
  '站级监控/直流接触器': 'DC Contactor',
  '站级监控/急停': 'Emergency Stop',
  '站级监控/充放电过流': 'Charge-Discharge Over Current',
  '站级监控/电流传感器故障': 'Current Sensor Fault',
  '站级监控/绝缘故障': 'Insulation Fault',
  '站级监控/火灾': 'Fire',
  '站级监控/水冷空调故障': 'Water Cooling Air Conditioner Fault',
  '站级监控/水冷空调告警': 'Water Cooling Air Conditioner Alarm',
  '站级监控/门禁': 'Entrance Guard',
  '站级监控/烟感': 'Smoke Sensor',
  '站级监控/温感': 'Temperature Sensor',
  '站级监控/气溶胶': 'Aerosol',
  '站级监控/SOC高': 'Hight SOC ',
  '站级监控/SOC低': 'Low SOC ',
  '站级监控/电箱气溶胶': 'Electrical Box Aerosol',
  '站级监控/水箱缺水': 'Water Tank Lack',
  '站级监控/通信板24V电压低': 'Communication Board 24V Voltage Low',
  '站级监控/消防中继在线状态': 'Fire Relay Online State',
  '站级监控/一级预警': 'Forewarn Level1',
  '站级监控/二级预警': 'Forewarn Level2',
  '站级监控/三级预警': 'Forewarn Level3',
  '站级监控/液位正常': 'Liquid Level Normal',
  '站级监控/液位低': 'Liquid Level Low',
  '站级监控/未喷洒': 'Not Spray',
  '站级监控/已喷洒': 'Sprayed',
  '站级监控/正在喷洒': 'Spraying',
  '站级监控/热失控': 'Thermal Runaway',
  '站级监控/异常': 'Abnormal',
  '站级监控/按下': 'Press',
  '站级监控/设备ID': 'Equipment ID',
  '站级监控/当前功率': 'Current Power',
  '站级监控/设置功率': 'Set Power',
  '站级监控/单设备': 'Single Equipment',
  '站级监控/汇总': 'Summary',

  /* 空调和消防 */
  '站级监控/消防中继在线状态': 'Fire Relay Online State',
  '站级监控/Pack消防预警级别': 'PACK Fire Forewarn Level',
  '站级监控/Pack温度': 'PACK Temperature',
  '站级监控/Pack湿度': 'PACK Humidity',
  '站级监控/CO浓度': 'CO Concentration',
  '站级监控/CO状态': 'CO State',
  '站级监控/VOC状态': 'VOC State',
  '站级监控/Pack状态': 'PACK State',
  '站级监控/消防探测器在线状态': 'Fire Detector Online State',
  '站级监控/voc(可燃气体浓度)': 'VOC(Volatile Organic Compounds)',
  '站级监控/水冷': 'Liquid  Cooling',
  '站级监控/开关机状态': 'Power on-off State',
  '站级监控/空调机组状态': 'Air Conditioner',
  '站级监控/湿度': 'Humidity',
  '站级监控/回风温度': 'RAT',
  '站级监控/回风温度详情': 'Return Air Temperature',
  '站级监控/外风机': 'External Wind Turbine',
  '站级监控/膨胀阀': 'Expansion Valve',
  '站级监控/加热器': 'Heater',
  '站级监控/蒸发器': 'Evaporator',
  '站级监控/蒸发温度': 'Evaporator Temperature',
  '站级监控/压缩机': 'Compressor',
  '站级监控/压缩机高低压开关': 'Compressor High-Low Voltgage Switch',
  '站级监控/过欠压模块': 'Under Voltage Module',
  '站级监控/冷凝器': 'Condensor',
  '站级监控/内风机': 'Internal Wind Turbine',
  '站级监控/空调厂家信息': 'Air Conditioner Manufacturer',
  '站级监控/空调产品型号': 'Air Conditioner Product Model',
  '站级监控/空调软件版本': 'Air Conditioner Software Version',
  '站级监控/柜内温度': 'Internal Cabinet Temperature',
  '站级监控/冷凝器温度': 'Condensor Temperature',
  '站级监控/蒸发器温度': 'Evaporator Temperature',
  '站级监控/柜外温度': 'External Cabinet Temperature',
  '站级监控/交流电压': 'AC Voltage',
  '站级监控/直流电压': 'DC Voltage',
  '站级监控/内风机转速': 'Internal Wind Turbine Speed',
  '站级监控/外风机转速': 'External Wind Turbine Speed',
  '站级监控/湿度值': 'Humidity',
  '站级监控/空调机组状态': 'Air Conditoner Group State',
  '站级监控/制冷开启温度': 'Refrigeration Start Temperature',
  '站级监控/制冷停止温度': 'Refrigeration Stop Temperature',
  '站级监控/制热开启温度': 'Heat Start Temperature',
  '站级监控/制热停止温度': 'Heat Stop Temperature',
  '站级监控/柜内高温告警点': 'Internal Cabinet Hight Temperature Alarm',
  '站级监控/柜内低温告警点': 'Internal Cabinet Low Temperature Alarm',
  '站级监控/冷凝器温度高温保护点': 'Condensor Hight Temperature Protection',
  '站级监控/蒸发器温度冻结保护点': 'Evaporator Frozen Protection',
  '站级监控/除湿开启湿度': 'Dehumidify Start Humidity',
  '站级监控/除湿停止湿度': 'Dehumidify Stop Humidity',
  '站级监控/湿度告警限制': 'Humidity Alarm Limit',
  '站级监控/湿度校正值': 'Humidity Calibration Value',
  '站级监控/开关机': 'Power on-off',
  '站级监控/除湿开启温度': 'Dehumidify Start Temperature',
  '站级监控/除湿停止温度': 'Dehumidify Stop Temperature',
  '站级监控/制冷状态': 'Refrigerate State',
  '站级监控/加热状态': 'Heat State',
  '站级监控/内风机状态': 'Internal Wind Turbine State',
  '站级监控/外风机状态': 'External Win Turbine State',
  '站级监控/应急风机状态': 'Emergency Wind Turbine State',
  '站级监控/预留开关量1输出': 'Reserved Switch Value1 Output',
  '站级监控/预留开关量2输出': 'Reserved Switch Value2 Output',
  '站级监控/监控关机': 'Monitoring Stop',
  '站级监控/除湿状态': 'Dehumidify State',
  '站级监控/压缩机状态': 'Compressor State',
  '站级监控/加热器状态': 'Heater State',
  '站级监控/柜内传感器故障': 'Internal Cabinet Sensor Fault',
  '站级监控/蒸发器温度传感器故障': 'Evaporator Temperature Sensor Fault',
  '站级监控/冷凝器温度传感器故障': 'Condensor Temperature Sensor Fault',
  '站级监控/柜外温度传感器故障': 'External Cabinet Temperature Sensor Fault',
  '站级监控/湿度传感器故障': 'Humidity Sensor Fault',
  '站级监控/湿度过高告警': 'Humidify Extra High Alarm',
  '站级监控/内风机告警': 'Internal Wind Turbine Alarm',
  '站级监控/外风机告警': 'External Wind Turbine Alarm',
  '站级监控/空调门禁告警': 'Air Conditioner Entrance Guard Alarm',
  '站级监控/冷凝器高压告警': 'Condensor Hight Pressure Alarm',
  '站级监控/蒸发器冻结告警': 'Evaporator Frozen Alarm',
  '站级监控/制冷告警（压缩机&制冷系统告警）': 'Refrigerate Alarm(Compressor&Refrigeration System Alarm)',
  '站级监控/高温告警': 'High Temperature Alarm',
  '站级监控/低温告警': 'Low Temperature Alarm',
  '站级监控/加热器告警': 'Heater Alarm',
  '站级监控/过电压告警': 'Over Voltage Alarm',
  '站级监控/欠电压告警': 'Under Voltage Alarm',
  '站级监控/高低电压告警': 'High-Low Voltage Alarm',
  '站级监控/高低压力告警': 'High-Low Pressure Alarm',
  '站级监控/高低温度告警': 'High-Low Temperature Alarm',


  '站级监控/eBlock序号': 'eBlock Order',
  '站级监控/eBlock型号': 'eBlock Model',
  '站级监控/查看': 'View',
  '站级监控/关闭': 'Close',
  '站级监控/离线': 'Offline',
  '站级监控/在线': 'Online',
  '站级监控/开启': 'Start',
  '站级监控/停止': 'Stop',
  '站级监控/运行': 'Run',
  '站级监控/空调参数': 'Air Conditioner Parameter',
  '站级监控/冷凝温度': 'Condenser Temperature',
  '站级监控/全部': 'All',
  '站级监控/总功率': 'Total Power',
  '站级监控/选择设备': 'Select Device',
  '站级监控/重置': 'Reset',
  '站级监控/功率曲线': 'Power Curve',
  '站级监控/CO2减排量': 'CO2 Reduction',
  '站级监控/节约标准煤': 'Standard Coal Savings',
  '站级监控/减少森林砍伐': 'Forest Reduction',
  '站级监控/吨': 'Ton',
  '站级监控/棵': 'Tree',
  '站级监控/日充电量': 'Daily Charging Energy',
  '站级监控/日放电量': 'Daily Discharging Energy',
  '站级监控/电量': 'Energy',
  '站级监控/电量统计': 'Energy Statistics',
  '站级监控/节能减排': 'Energy Conservation and Emission Reduction',
  '站级监控/功率跟踪': 'Power Tracking',
  '站级监控/SOC曲线': 'SOC Curve',

  '站级监控/独立逆变': 'Independent Inverter',
  '站级监控/直流恒功率': 'DC Constant Power',
  '站级监控/交流恒功率': 'AC Constant Power',
  '站级监控/直流恒压': 'DC Constant Voltage',
  '站级监控/交流恒压': 'AC Constant Voltage',
  '站级监控/直流恒流': 'DC Constant Current',
  '站级监控/交流恒流': 'AC Constant Current',
  '站级监控/老化模式': 'Ageing Mode',
  '站级监控/停机': 'Stop',
  '站级监控/自检': 'Self-Check',
  '站级监控/待机': 'Idle',
  '站级监控/并网': 'Grid-Connection',
  '站级监控/天': 'Day',
  '站级监控/小时': 'Hour',
  '站级监控/分': 'Minute',
  '站级监控/IGBT-A温度': 'IGBT-A Phase Temperature',
  '站级监控/IGBT-B温度': 'IGBT-B Phase Temperature',
  '站级监控/IGBT-C温度': 'IGBT-C Phase Temperature',
  '站级监控/电网信息': 'Grid Information',
  '站级监控/系统状态': 'System State',
  '站级监控/电池功率': 'Battery Power',
  '站级监控/重要负载功率': 'Important Load Power',
  '站级监控/光伏功率': 'PV Power',


  '站级监控/BMU状态帧丢失计数': 'BMU State Frame Loss Num',
  '站级监控/BMU均衡帧丢失计数': 'BMU Equalization Frame Loss Num',
  '站级监控/BMU电压帧丢失计数': 'BMU Voltage Frame Loss Num',
  '站级监控/BMU温度帧丢失计数': 'BMU Temperature Frame Loss Num',
  '站级监控/BMU帧芯片丢失计数': 'BMU Chip Frame Loss Num',
  '站级监控/BMU帧pack丢失计数': 'BMU Pack Frame Loss Num',
  '站级监控/BMS算法版本': 'BMS Algorithm Version',
  '站级监控/SOE算法版本': 'SOE Algorithm Version',
  '站级监控/SOH算法版本': 'SOH Algorithm Version',
  '站级监控/SOP算法版本': 'SOP Algorithm Version',
  '站级监控/SOS算法版本': 'SOS Algorithm Version',
  '站级监控/被动均衡算法版本': 'Passive Equalizaiton Algorithm Version',
  '站级监控/CLB算法版本': 'CLB Algorithm Version',
  '站级监控/电池最高电压': 'Battery Highest Voltage',
  '站级监控/电池最低电压': 'Battery Lowest Voltage',
  '站级监控/电池最高温度': 'Battery Highest Temperature',
  '站级监控/电池最低温度': 'Battery Lowest Temperature',
  '站级监控/eBlock消防主机状态': 'eBlock Fire Fighting Computor State',
  '站级监控/eBlock消防抑制剂液位状态': 'eBlock Fire Inhibitor Liquid Level State',
  '站级监控/eBlock消防喷洒状态': 'eBlock Fire Spray State',
  '站级监控/空调详情': 'Air Conditioner Details',
  '站级监控/补电': 'Recharge',
  '站级监控/电池仓': 'Battery Cabinet',



  /* 生产概览 */
  '生产概览/按日': 'Daily',
  '生产概览/按月': 'Monthly',
  '生产概览/按年': 'Yearly',
  '生产概览/日期': 'Date',
  '生产概览/至': 'To',
  '生产概览/查询': 'Search',
  '生产概览/导出': 'Download',
  '生产概览/重置': 'Reset',
  '生产概览/节省电费': 'Saving Cost',
  '生产概览/充电量': 'Charging Energy',
  '生产概览/放电量': 'Discharging Energy',
  '生产概览/充放电效率': 'Charging-Discharging Efficiency',
  '生产概览/充放电量统计': 'Charging-Discharging Energy',
  '生产概览/全部': 'Total',
  '生产概览/柱状图': 'Histgram',
  '生产概览/表格': 'Table',
  '生产概览/收益': 'Earning',
  '生产概览/电量': 'Energy',
  '生产概览/储能收益柱状图': 'Energy Storage Earning Histgram',
  '生产概览/放电（尖峰）': 'Discharge(Sharp)',
  '生产概览/放电（高峰）': 'Discharge(Peak)',
  '生产概览/放电（平）': 'Discharge(Flat)',
  '生产概览/放电（低谷）': 'Discharge(Valley)',
  '生产概览/放电（深谷）': 'Discharge(Deep Valley)',
  '生产概览/充电（尖峰）': 'Charge(Sharp)',
  '生产概览/充电（高峰）': 'Charge(Peak)',
  '生产概览/充电（平）': 'Charge(Flat)',
  '生产概览/充电（低谷）': 'Charge(Valley)',
  '生产概览/充电（深谷）': 'Charge(Deep Valley)',
  '生产概览/时间': 'Date',
  '生产概览/效率': 'Efficiency',
  '生产概览/充电量': 'Charging Energy',
  '生产概览/放电量': 'Discharging Energy',
  '生产概览/总放电': 'Total Discharging Energy',
  '生产概览/总充电': 'Total Charging Energy',
  '生产概览/元': 'Yuan',
  '生产概览/电价': 'Electricity Price',
  '生产概览/充电': 'Charging',
  '生产概览/放电': 'Discharging',

  '生产概览/类型': 'Type',
  '生产概览/尖峰': 'Sharp',
  '生产概览/高峰': 'Peak',
  '生产概览/平': 'Flat',
  '生产概览/低谷': 'Valley',
  '生产概览/深谷': 'Deep Valley',
  '生产概览/储能收益统计': 'Energy Storage Earning Statistics',
  '生产概览/总': 'Total',
  '生产概览/是否确认导出所有数据项': 'Are you sure you want to export all data items',

  /* 告警信息 */
  '告警信息/离线告警': 'Offline Alarm',
  '告警信息/非计划运行': 'Unplanned Operation',
  '告警信息/故障预警': 'Fault Forewarn',
  '告警信息/故障历史': 'Fault History',
  '告警信息/起始时间': 'Date',
  '告警信息/告警等级': 'Alarm Level',
  '告警信息/全部': 'Total',
  '告警信息/查询': 'Search',
  '告警信息/重置': 'Reset',
  '告警信息/设备名称': 'Equipment Name',
  '告警信息/设备UUID': 'Equipment UUID',
  '告警信息/故障等级': 'Fault Level',
  '告警信息/故障属性': 'Fault Attribute',
  '告警信息/故障动作': 'Fault Action',
  '告警信息/持续时间': 'Duration',
  '告警信息/故障描述': 'Fault Description',
  '告警信息/故障码': 'Fault Code',
  '告警信息/备注': 'Remark',

  '告警信息/时间': 'Time',
  '告警信息/请输入设备名称': 'Please Input Equipment Name',
  '告警信息/设备ID': 'Equipment ID',
  '告警信息/请输入设备ID': 'Please Input Equipment ID',
  '告警信息/类型': 'Type',
  '告警信息/请选择类型': 'Please Select Type',
  '告警信息/整站': 'Whole Station',
  '告警信息/能量链': 'eLink',
  '告警信息/能量块': 'eBlock',
  '告警信息/电表': 'Meter',
  '告警信息/至': 'To',
  '告警信息/开始时间': 'Start Time',
  '告警信息/结束时间': 'End Time',

  '告警信息/提示': 'Note',
  '告警信息/告警': 'Alarm',
  '告警信息/故障': 'Fault',
  '告警信息/严重故障': 'Serious Fault',

  '告警信息/请输入备注': 'Please Input Remark',
  '告警信息/告警确认': 'Alarm Confirm',
  '告警信息/确认中...': 'Confirming...',
  '告警信息/告警已确认': 'Alarm Confirmed',
  '告警信息/故障消失': 'Fault Disappear',
  '告警信息/故障触发': 'Fault Trigger',
  '告警信息/开始': 'Start',
  '告警信息/结束': 'End',


  '告警管理/实时告警': `Real-Time Alarm`,
  '告警管理/告警历史': `Alarm History`,
  '告警管理/起始时间': `Date`,
  '告警管理/告警等级': `Alarm Level`,
  '告警管理/故障动作': `Fault Action`,
  '告警管理/能量链': `eLink`,
  '告警管理/能量块': `eBlock`,
  '告警管理/查询': `Search`,
  '告警管理/重置': `Reset`,
  '告警管理/导出': `Download`,
  '告警管理/上报时间': `Report Time`,
  '告警管理/故障编码表': `Fault Code Table`,
  '告警管理/请输入故障编码': `Please Input Fault Code`,
  '告警管理/设备名称': `Equipment Name`,
  '告警管理/设备UUID': `Equipment ID`,
  '告警管理/故障等级': `Fault Level`,
  '告警管理/故障属性': `Fault Attribute`,
  '告警管理/持续时间': `Duration`,
  '告警管理/状态': `State`,
  '告警管理/审核人': `Auditor`,
  '告警管理/审核时间': `Audit Time`,
  '告警管理/故障描述': `Fault Description`,
  '告警管理/备注': `Remark`,
  '告警管理/操作': `Operation`,
  '告警管理/全部': `Total`,
  '告警管理/提示': `Note`,
  '告警管理/告警': `Alarm`,
  '告警管理/故障': `Fault`,
  '告警管理/严重故障': `Serious Fault`,
  '告警管理/故障触发': `Fault Trigger`,
  '告警管理/故障消失': `Fault Disappear`,
  '告警管理/故障编码表': `Fault Code Table`,
  '告警管理/新增': `Add`,
  '告警管理/设备类型': `Equipment Model`,
  '告警管理/故障详情': `Fault Details`,
  '告警管理/编辑': `Edit`,
  '告警管理/删除': `Delete`,
  '告警管理/修改故障编码': `Modify Fault Code`,
  '告警管理/故障编码': `Fault Code`,
  '告警管理/取消': `Cancel`,
  '告警管理/确定': `Confirm`,
  '告警管理/编码': `Code`,
  '告警管理/请输入编码搜索': `Please Input Code to Search`,
  '告警管理/绝缘阻抗低': `Insulation Impedance Low`,
  '告警管理/电池正负极绝缘阻抗值过低': `Battery Positive/Negative Insulation Impedance Extra Low`,
  '告警管理/直流接触器断开': `Direct Current Contactor Break`,
  '告警管理/直流断路器未闭合': `Direct Current Circuit Breaker No Closed`,
  '告警管理/逆变相序错误': `Inverter Order Failure`,
  '告警管理/PCS内部逆变相序错误': `PCS Inner Inverter Order Failure`,
  '告警管理/逆变电压异常': `Inverter Voltage Abnormal`,
  '告警管理/逆变电压软起失败': `Inverter Soft Start Fail`,
  '告警管理/交流电压采样故障': `Alternating Current Voltage Sampling Fault`,
  '告警管理/交流电压采样值异常': `Alternating Current Voltage Sampling Value Abnormal`,
  '告警管理/直流母线电压异常': `Direct Current Bus Voltage Abnormal`,
  '告警管理/直流电压采样值异常': `Direct Current Voltage Sampling Value Abnormal`,
  '告警管理/交流电流异常': `Alternating Current Abnormal`,
  '告警管理/交流电流采样值异常': `Alternating Current Sampling Value Abnormal`,
  '告警管理/直流电流异常': `Direct Current Abnormal`,
  '告警管理/直流电流采样值异常': `Direct Current Sampling Value Abnormal`,
  '告警管理/电池正负极反接': `Battery Positive/Negative Reverse`,
  '告警管理/直流正负极接反': `Direct Current Positive/Negative Reverse`,
  '告警管理/故障录波存储故障': `Fault Recorder Storage Fault`,
  '告警管理/铁电存储器故障（故障录播功能）': `FRAM Fault(Fault Record Broadcast Function)`,
  '告警管理/参数设置存储故障': `Paramter Set Storage Fault`,
  '告警管理/EEPROM存储故障，换机': `EEPROM Storage Fault, Change Machine`,
  '告警管理/交流AC辅源24V异常': `AC Auxiliary 24V Abnormal`,
  '告警管理/直流DC辅源24V异常': `DC Auxiliary 24V Abnorml`,
  '告警管理/辅源停机故障': `Auxiliary Stop Fault`,
  '告警管理/并机通信故障': `Parallel Machine Communication Fault`,
  '告警管理/并机CAN通信故障': `Parallel Machine CAN Communication Fault`,
  '告警管理/BCS通信故障（485端口）': `BCS Communicaiton Fault(485 Port)`,
  '告警管理/RS485与BCS通信故障': `RS485 and BCS Communication Fault`,
  '告警管理/CPU1与CPU2通信故障': `CPU1 and CPU2 Communication Fault`,
  '告警管理/FPGA通信故障': `FPGA Communication Fault`,
  '告警管理/DSP与FPGA通信故障': `DSP and FPGA Communication Fault`,
  '告警管理/接口板通信故障': `Interface Board Communication Fault`,
  '告警管理/相对地短路故障': `Phase to Ground Short Circuit Fault`,
  '告警管理/发生电网单相对地短路故障': `Grid Single Phase to Ground Short Circuit Fault`,
  '告警管理/电网相序错误': `Grid Order Fault`,
  '告警管理/电网相序接线错误': `Grid Order Wire Fault`,
  '告警管理/三相电流不均衡': `Three Phase Current Unequalization`,
  '告警管理/交流三相电流不平衡': `Alternating Current Three Phase Current Unbalance`,
  '告警管理/模块ID错误': `Module ID Failure`,
  '告警管理/并机模块地址设置异常(超过最大值10)': `Parallel Machine Module Address Set Abnormal(Over Max 10)`,
  '告警管理/电网谐振关机': `Grid Syntony Power Off`,
  '告警管理/并网电流发生谐振，电流谐波过大': `Grid Connection Current Syntony Occur, Current Harmonic Extra Large`,
  '告警管理/直流分量告警': `Direct Current Component Alarm`,
  '告警管理/并网电流直流分量超标': `Grid Connection Direct Current Component Over Standard`,
  '告警管理/机型、系列号、版本信息参数异常': `Model, Serial Number, Version' Parameter Abnormal`,
  '告警管理/产品未被授权': `Product Unauthorized`,
  '告警管理/程序升级': `Program Upgrade`,
  '告警管理/程序正在接收升级数据': `Program Receiving Upgrade Data`,
  '告警管理/电网电压高': `Grid Voltage High`,
  '告警管理/电网有效值过高告警': `Grid Effective Value Extra High Alarm`,
  '告警管理/电网电压低': `Grid Voltage Low`,
  '告警管理/电网有效值过低告警': `Grid Effective Value Extra Low Alarm`,
  '告警管理/电网频率高': `Grid Frequency High`,
  '告警管理/电网频率过高告警': `Grid Frequency Extra High Alarm`,
  '告警管理/电网频率低': `Grid Frequency Low`,
  '告警管理/电网频率过低告警': `Grid Frequency Extra Low Alarm`,
  '告警管理/直流母线电压高': `Direct Current Bus Voltage High`,
  '告警管理/直流母线电压过高': `Direct Current Bus Voltage Extra High`,
  '告警管理/直流母线电压低': `Direct Current Bus Voltage Low`,
  '告警管理/直流母线电压过低': `Direct Current Bus Voltage Extrax Low`,
  '告警管理/直流输入电压高': `Direct Current Input Voltage Extra Low`,
  '告警管理/直流电池电压过高告警': `Direct Current Battery Voltage Extra High Alarm`,
  '告警管理/直流输入电压低': `Direct Current Input Voltage Low`,
  '告警管理/直流电池电压过低告警': `Direct Current Battery Voltage Extra Low Alarm`,
  '告警管理/软起电路故障': `Soft Start Circuit Fault`,
  '告警管理/直流母线电压软起故障，换机': `Direct Current Bus Voltage Soft Start Fault, Change Machine`,
  '告警管理/直流母线连接故障': `Direct Current Bus Linkage Fault`,
  '告警管理/正负母线偏压故障': `Positive Negative Bus Bias Voltage Fault`,
  '告警管理/环境温度过高': `Ambient Temperature Extra High`,
  '告警管理/PCS内部腔体温度＞80℃': `PCS Inner Chamber Temperature > 80℃`,
  '告警管理/环境温度过低': `Ambient Temperature Extra High`,
  '告警管理/A相IGBT温度过高': `A Phase IGBT Temperature＞95℃`,
  '告警管理/IGBTA温度＞95℃': `B Phase IGBT Temperature Extra High`,
  '告警管理/B相IGBT温度过高': `B Phase IGBT Temperature Extra High`,
  '告警管理/C相IGBT温度过高': `C Phase IGBT Temperature Extra High`,
  '告警管理/A相IGBT-NTC故障': `A Phase IGBT-NTC Fault`,
  '告警管理/IGBTA温度检测电路故障': `IGBT A Temperature Check Circuit Fault`,
  '告警管理/B相IGBT-NTC故障': `B Phase IGBT-NTC Fault`,
  '告警管理/IGBTB温度检测电路故障': `IGBT B Temperature Check Circuit Fault`,
  '告警管理/C相IGBT-NTC故障': `C Phase IGBT-NTC Fault`,
  '告警管理/IGBTC温度检测电路故障': `IGBT C Temperature Checkt Circuit Fault`,
  '告警管理/环境温度传感器故障': `Ambient Temperature Sensor Fault`,
  '告警管理/IGBT温度过温降额': `IGBT Over Temperature Derating`,
  '告警管理/环境温度降额': `Ambient Temperature Derating`,
  '告警管理/IGBT温度不平衡': `IGBT Temperature Unbalance`,
  '告警管理/IGBT温度差异＞10℃': `IGBT Temperature Difference＞10℃`,
  '告警管理/IGBT温度过低': `IGBT Temperature Extra Low`,
  '告警管理/IGBT温度过低降额': `IGBT Temperature Extra Low Derating`,
  '告警管理/任一IGBT温度小于-25℃': `Any IGBT Temperature < -25℃`,
  '告警管理/直流输入过压': `Direct Current Input Over Voltage`,
  '告警管理/直流母线过压': `Direct Current Bus Over Voltage`,
  '告警管理/A相限流保护': `A Phase Current Limit Protection`,
  '告警管理/B相限流保护': `B Phase Current Limit Protection`,
  '告警管理/C相限流保护': `C Phase Current Limit Protection`,
  '告警管理/A相过流': `A Phase Over Current`,
  '告警管理/B相过流': `B Phase Over Current`,
  '告警管理/C相过流': `C Phase Over Current`,
  '告警管理/正母线硬件过压': `Positive Bus Hardware Over Voltage`,
  '告警管理/负母线硬件过压': `Negative Bus Hardware Over Voltage`,
  '告警管理/直流辅源告警': `Direct Current Auxiliary Alarm`,
  '告警管理/交流辅源告警': `Alternating Current Auxiliary Alarm`,
  '告警管理/辅源电压与额定电压相差超过10%': `Auxiliaryand Rated's Voltage Difference > 10%`,
  '告警管理/直流硬件过流': `Direct Current Hardware Over Current`,
  '告警管理/直流过流': `Direct Current Over Current`,
  '告警管理/急停': `Emergency Stop`,
  '告警管理/PCS外部干接点1急停信号触发': `PCS External Dry Contact1 Emergency Stop Signal Trigger`,
  '告警管理/内部风扇故障': `Internal Fan Fault`,
  '告警管理/内部风扇故障告警': `Internal Fan Fault Alarm`,
  '告警管理/外部风扇故障': `External Fan Fault`,
  '告警管理/外部风机故障告警': `External Fan Fault Alarm`,
  '告警管理/并机同步信号异常': `Parallel Machine Synchronism Signal Abnormal`,
  '告警管理/并机CAN同步信号故障': `Parallel Machine CAN Synchronism Signal Fault`,
  '告警管理/交流防雷': `Alternating Current Lightning Protection`,
  '告警管理/交流防雷告警': `Alternating Current Lightning Protection Alarm`,
  '告警管理/CPU2-CPU1通信故障': `CPU2-CPU1 Communication Fault`,
  '告警管理/正母线软件过压': `Positive Bus Software Over Voltage`,
  '告警管理/负母线软件过压': `Negative Bus Software Over Voltage`,
  '告警管理/锁相环故障': `Lock Phase Circular Fault`,
  '告警管理/软件锁相环故障': `Software Lock Phase Circular Fault`,
  '告警管理/中点不平衡故障': `Neutral Point Unbalance Fault`,
  '告警管理/无法响应主MCU命令': `Response Master MCU Command Fail`,
  '告警管理/直流电压不适合运行': `Direct Current Voltage Unsuitable Operation`,
  '告警管理/直流电池电压不满足运行条件': `Direct Current Battery Voltage Unsatisfied Operation Conditions`,
  '告警管理/电网电压不适合运行': `Grid Voltage Unsuitable Operation`,
  '告警管理/电网电压不满足运行条件': `Grid Voltage Unsatisfied Operation Conditions`,
  '告警管理/电网频率不适合运行': `Grid Frequency Unsuitable Operation`,
  '告警管理/电网频率不满足运行条件': `Grid Frequency Unsatisfied Operation Conditions`,
  '告警管理/BCS关机': `BCS Power Off`,
  '告警管理/BCS下发关机命令': `BCS Deliver Shutdown Command`,
  '告警管理/老化模式启动': `Ageing Mode Start`,
  '告警管理/故障禁止启机': `Fault Ban Start`,
  '告警管理/不允许再次启机': `Ban Start Again`,
  '告警管理/系统不存在主机': `System Master No Exist`,
  '告警管理/并机模式未识别到主机': `Parallel Machine Mode Master Unidentify`,
  '告警管理/绝缘阻抗未检测': `Insulation Impedance No Check`,
  '告警管理/远程关机': `Remote Shutdown`,
  '告警管理/功率调度降额': `Power Dispatch Derating`,
  '告警管理/0XX ， XX=降额百分比（0~99）': `0XX ， XX=Derating Percentage（0~99）`,
  '告警管理/环境温度降额': `Ambient Temperature Derating`,
  '告警管理/1XX ， XX=降额百分比（0~99）': `1XX ， XX=Derating Percentage（0~99）`,
  '告警管理/IGBT温度降额': `IGBT Temperature Derating`,
  '告警管理/3XX ， XX=降额百分比（0~99）': `3XX ， XX=Derating Percentage（0~99）`,
  '告警管理/过载降额': `Over Load Derating`,
  '告警管理/4XX ， XX=降额百分比（0~99）': `4XX ， XX=Derating Percentage（0~99）`,
  '告警管理/PCS通信故障': `PCS Communication Fault`,
  '告警管理/全部PCS通信故障': `Total PCS Communication Fault`,
  '告警管理/BMU通信故障': `BMU Communication Fault`,
  '告警管理/eLink通信故障': `eLink Communication Fault`,
  '告警管理/eLink与eBlock通信故障': `eLink and eBlock Communication Fault`,
  '告警管理/消防监控通信故障': `Fire Monitoring Communication Fault`,
  '告警管理/水冷机组通信故障': `Water Cooling Unit Communication Fault`,
  '告警管理/1号或者2号水冷机组通信故障': `1# or 2# water Cooling Unit Communication Fault`,
  '告警管理/空调通信故障': `Air Conditioner Communication Fault`,
  '告警管理/1号或者2号空调通信故障': `1# or 2# Air Conditioner Communication Fault`,
  '告警管理/H2传感器通信故障': `H2 Sensor Communication Fault`,
  '告警管理/CO2传感器通信故障': `CO2 Sensor Communication Fault`,
  '告警管理/VOC传感器通信故障': `VOC Sensor Communication Fault`,
  '告警管理/温湿度传感器通信故障': `Temperature and Moisture Sensor Communication Fault`,
  '告警管理/水温传感器通信故障': `Water Temperature Sensor Communication Fault`,
  '告警管理/flash芯片通信故障': `Flash Chip Communication Fault`,
  '告警管理/电池热失控': `Battery Thermal Runaway`,
  '告警管理/柜体电池热失控': `Cabinet Battery Thermal Runaway`,
  '告警管理/电气火灾': `Electrical Fire`,
  '告警管理/储能柜体电气火灾': `Energy Storage Cabinet Electrical Fire`,
  '告警管理/绝缘故障': `Insulation Fault`,
  '告警管理/储能柜体绝缘阻抗故障': `Energy Storage Cabinet Insulation Impedance Fault`,
  '告警管理/eBlock柜体锁定': `eBlock Cabinet Lock`,
  '告警管理/消防由eLink主导监测时，发生电池热失控或电气火灾时，eLink对储能柜体执行了锁定动作': `When Battery Thermal Runaway or Electrical Fire Occur, eLink Perform a Locking Action on Energy Storage Cabinet Subject to Fire Monitoring dominated by eLink`,
  '告警管理/eBlock运行模式故障': `eBlock Operation Mode Fault`,
  '告警管理/eBlock372柜体，设为裸机模式时，监测到BMU通信': `eBlock372 Cabinet Detect BMU Communication when Bare Machine Mode is Set`,
  '告警管理/传感器通信故障': `Sensor Communication Fault`,
  '告警管理/电流传感器通信故障': `Current Sensor Communication Fault`,
  '告警管理/电流传感器故障': `Current Sensor Fault`,
  '告警管理/电流传感器电流值和PCS电流相差太大': `Current Value and PCS Current Difference is Extra Large in Current Sensor `,
  '告警管理/直流接触器故障': `Direct Current Contact Fault`,
  '告警管理/BCS检测到PCS直流电压合不上，报直流接触器故障': `BCS Detect that PCS Direct Current Voltage Close Fail, but Report Direct Contact Fault`,
  '告警管理/直流总压异常': `Direct Current Total Voltage Abnormal`,
  '告警管理/PCS直流总压和电池总压相差太大': `PCS Direct Current Total Voltage and Battery Total Voltage Difference Extra Large`,
  '告警管理/电池总压过压': `Battery Total Voltage Over Voltage`,
  '告警管理/电池总压过高': `Battery Total Voltage Extra High`,
  '告警管理/电池总压欠压': `Battery Total Voltage Under Voltage`,
  '告警管理/电池总压过低': `Battery Total Voltage Extra Low`,
  '告警管理/禁止开机': `Ban Power On`,
  '告警管理/开机旋钮位于禁止开机': `Power On Button is set Ban`,
  '告警管理/急停': `Emergency Stop`,
  '告警管理/柜体急停按下': `Cabinet Emergency Stop is Pressed`,
  '告警管理/MSD故障': `MSD Fault`,
  '告警管理/PACK高压信号故障': `PACK Hight Voltage Signal Fault`,
  '告警管理/水浸故障': `Water Immersion Fault`,
  '告警管理/上水浸被水淹没': `Upper Water Immersion Soaked in Water `,
  '告警管理/可燃气体浓度异常': `VOC Concentration Abnormal`,
  '告警管理/消防气体传感器值超标': `Fire Gas Sensor Over Standard`,
  '告警管理/烟感异常': `Smoke Sensor Abnormal`,
  '告警管理/烟感信号告警': `Smoke Sensor Signal Alarm`,
  '告警管理/门禁异常': `Entrance Guard Abnormal`,
  '告警管理/门禁信号告警': `Entrance Guard Signal Alarm`,
  '告警管理/空调工作异常': `Air Conditioner Working Abnormal`,
  '告警管理/消防水箱缺水': `Fire Water Tank Lack`,
  '告警管理/SOC高': `SOC High`,
  '告警管理/电池充电SOC超过设定上限值': `Battery Charge SOC Over Upper Limit`,
  '告警管理/SOC低': `SOC Low`,
  '告警管理/电池放电SOC超过设定下限值': `Battery Discharge SOC Under Lower Limit`,
  '告警管理/SOE高': `SOE High`,
  '告警管理/电池充电SOE超过设定上限值': `Battery Charge SOE Over Upper Limit`,
  '告警管理/SOE低': `SOE Low`,
  '告警管理/电池放电SOE超过设定下限值': `Battery Discharge SOE Under Lower Limit`,
  '告警管理/柜体温度1': `Cabinet Temperature1`,
  '告警管理/储能柜体温度过高': `Energy Storage Temperature Extra High`,
  '告警管理/柜体湿度1': `Cabinet Humidity1`,
  '告警管理/储能柜体湿度过高': `Energy Storage Humidity Extra High`,
  '告警管理/柜体温度1': `Cabinet Temperature`,
  '告警管理/储能柜体温度过低': `Energy Storage Temperature Extra Low`,
  '告警管理/PCS通信故障': `PCS Communication Fault`,
  '告警管理/P型设备一台PCS与BCS通信故障': `PCS and BCS Communication Fault in One P Type Equipment`,
  '告警管理/水浸故障': `Water Immersion Fault`,
  '告警管理/下水浸被水淹没': `Lower Water Immersion Soaked in Water`,
  '告警管理/水冷机组工作告警': `Water Cooling Unit Working Alarm`,
  '告警管理/0x0001：水冷机组制冷制热告警； 0x0002：水冷机组压力告警； 0x0003：水冷机组制冷制热和压力均告警；': `0x0001：Refrigeration and Heat Alarm in Water Cooling Unit； 0x0002：Pressure Alarm in Water Cooling Unit； 0x0003：Refrigeration, Heat, and Pressure Alarm in Water Cooling Unit；`,
  '告警管理/水冷机组工作故障': `Water Cooling Unit Working Fault`,
  '告警管理/PCS不具备启机条件': `PCS Unsatisfied Start Conditions`,
  '告警管理/PCS交流电压故障。': `PCS Alternating Current Voltage Fault`,
  '告警管理/PACK端子温度过温保护': `PACK Terminal Over Temperature Protection`,
  '告警管理/PACK正/负极母排端子过温故障': `PACK Positive/Negative Bus Terminal Over Temperature Fault`,
  '告警管理/PACK端子温度过温告警': `PACK Terminal Over Temperature Alarm`,
  '告警管理/PACK正/负极母排端子过温告警': `PACK Positive/Negative Bus Terminal Over Temperature Alarm`,
  '告警管理/PACK端子温度过温提示': `PACK Terminal Over Temperature Notice`,
  '告警管理/PACK正/负极母排端子过温提示': `PACK Positive/Negative Bus Terminal Over Temperature Notice`,
  '告警管理/BMU采样故障': `BMU Sampling Fault`,
  '告警管理/0x0001:第一个BMU采样故障； 0x0002:第二个BMU采样故障； 0x0004:第三个BMU采样故障； 0x0007:第一、二、三个BMU均采样故障。': `0x0001:The Fisrt BMU Sampling Fault； 0x0002:The Second BMU Sampling Fault； 0x0004:The Third BMU Sampling Fault； 0x0007:The Fisrt, Second, and Third BMU Sampling Fault。`,
  '告警管理/功率回路故障': `Power Loop Fault`,
  '告警管理/eBlock能量块功率回路故障。': `eBlock Power Loop Fault`,
  '告警管理/BMS初始化故障': `BMS Initialize Fault`,
  '告警管理/BCS初始化故障': `BCS Initialize Fault`,
  '告警管理/门禁故障': `Entrance Guard Fault`,
  '告警管理/门禁故障。（运行模式）': `Entrance Guard Fault(Operation Mode)`,
  '告警管理/空调故障': `Air Conditioner Fault`,
  '告警管理/0x0001：第一台空调故障； 0x0002：第二台空调故障； 0x0003：二台空调均故障；': `0x0001：The First Air Conditioner Fault； 0x0002：The Second Air Conditioner Fault； 0x0003：The First and Second Air Conditioner Fault；`,
  '告警管理/均衡启动提示': `Equalization Start Notice`,
  '告警管理/（1）电池实际衰减和设计控制衰减不一致。默认阈值：3KWh。 （2）启动均衡调整电量差值。': `(1) Battery Actual Degeration is Inconsistent with Designed one. Default Threshold:3kWh。(2) Start Equalization to Regulate Energy Difference`,
  '告警管理/人工补电告警': `Manula Energy Supplement`,
  '告警管理/（1）电池实际衰减和设计控制衰减不一致。默认阈值：3KWh。 （2）均衡调整3天，电量实际衰减仍无法调整至设计值。': `(1) Battery Actual Degeration is Inconsistent with Designed One. Default Threshold:3kWh。(2) Equalization Regulate 3 Days, But Actual Degeration is Sill Inconsistent with Designed One`,
  '告警管理/PCS校准异常': `PCS Calibration Abnormal`,
  '告警管理/（1）小功率时，PCS功率不准，导致电池电压抬升。': `(1) PCS Power Inaccuracy lead to Battery Voltage Rise When Power is SMALL`,
  '告警管理/风机通信告警': `Wind Turbine Communication Alarm`,
  '告警管理/4&1模块通信告警': `4&1 Module Communication Alarm`,
  '告警管理/除湿机通信告警': `Dehumidifier Communication Alarm`,
  '告警管理/消防急停通信告警': `Fire Emergency Stop Communication Alarm`,
  '告警管理/消防中继运行故障': `Fire Relay Operation Fault`,
  '告警管理/1:pack 1级告警 2:pack 2级告警 3:手报按钮按下 4:手动报警': `1:PACK Alarm Level1 2:PACK Alarm Level2 3:Press Button Manully 4:Manual Alarm`,
  '告警管理/4&1运行故障': `4&1 Operation Fault`,
  '告警管理/1:1级告警 2:2级告警 3:3级告警 4:运行故障': `1:Alarm Level1 2:Alarm Level2 3:Alarm Level3 4:Operation Fault`,
  '告警管理/风机故障': `Wind Turbine Fault`,
  '告警管理/电池充满': `Battery Fully Charge`,
  '告警管理/电池单体充电终止过压': `Cell Charge End Over Voltage`,
  '告警管理/电池放空': `Battery Fully Discharge`,
  '告警管理/电池单体充电终止欠压': `Cell Discharge End Under Voltage`,
  '告警管理/电池电压无效': `Battery Voltage Invalid`,
  '告警管理/电池温度无效': `Battery Temperature Invalid`,
  '告警管理/多个电池温度采样值无效': `Multiple Battery Sampling Values Invaid`,
  '告警管理/单体过压保护': `Cell Over Voltage Protection`,
  '告警管理/电池单体保护级欠压': `Cell Under Voltage Protection `,
  '告警管理/单体欠压保护': `Cell Under Voltage Protection `,
  '告警管理/电池单体保护级过压': `Cell Over Voltage Protection`,
  '告警管理/单体过压1': `Cell Over Voltage1`,
  '告警管理/电池单体1级欠压': `Cell Over Voltage Level1`,
  '告警管理/单体欠压1': `Cell Under Voltage1`,
  '告警管理/电池单体1级过压': `Cell Under Voltage Level1`,
  '告警管理/充电高温保护': `Charge High Temperature Protection`,
  '告警管理/电池单体保护级充电高温': `Cell Charge High Temperature Protection`,
  '告警管理/充电低温保护': `Charge Low Temperature Protection`,
  '告警管理/电池单体保护级充电低温': `Cell Charge Low Temperature Protection`,
  '告警管理/放电高温保护': `Discharge High Temperature Protection`,
  '告警管理/电池单体保护级放电高温': `Cell Discharge Temperature Protection`,
  '告警管理/放电低温保护': `Discharge Low Temperature Protection`,
  '告警管理/电池单体保护级放电低温': `Cell Discharge Low Temperature Protection`,
  '告警管理/充电高温告警': `Charge High Temperature Alarm`,
  '告警管理/电池单体1级充电高温': `Cell Charge High Temperature Level1`,
  '告警管理/充电低温告警': `Charge Low Temperature Alarm`,
  '告警管理/电池单体1级充电低温': `Cell Charge Low Temperature Level1`,
  '告警管理/放电高温告警': `Discharge High Temperature Alarm`,
  '告警管理/电池单体1级放电高温': `Cell Discharge High Temperature Level1`,
  '告警管理/放电低温告警': `Discharge Low Temeprature Alarm`,
  '告警管理/电池单体1级放电低温': `Cell Discharge Low Temperature Level1`,
  '告警管理/充电高温终止': `Charge High Temperature End`,
  '告警管理/电池单体充电终止高温': `Cell Charge End High Temperature`,
  '告警管理/充电低温终止': `Charge Low Temperature End`,
  '告警管理/电池单体充电终止低温': `Cell Charge End Low Temperature`,
  '告警管理/放电高温终止': `Discharge High Temperature End`,
  '告警管理/电池单体放电终止高温': `Cell Discharge End High Temperature`,
  '告警管理/放电低温终止': `Discharge Low Temperature End`,
  '告警管理/电池单体放电终止低温': `Cell Discharge End Low Temperature`,
  '告警管理/电芯采样故障': `Cell Sampling Fault`,
  '告警管理/LTC6813采样故障': `LTC6813 Sampling Fault`,
  '告警管理/电池单体电压不平衡': `Cell Voltage Unbalance`,
  '告警管理/电池单体温度不平衡': `Cell Temperature Unbalance`,
  '告警管理/电池温度无效': `Battery Temperature Invalid`,
  '告警管理/一个电池温度采样值无效': `One Battery Temperature Sampling Value Invalid`,
  '告警管理/电池单体P3级过压告警': `Cell Over Voltage Alarm Level3`,
  '告警管理/电池单体P3级过压。': `Cell Over Voltage Level3`,
  '告警管理/电池单体P3级欠压告警': `Cell Under Voltage Alarm Level3`,
  '告警管理/电池单体P3级欠压。': `Cell Under Voltage Level3`,
  '告警管理/模组充电P1级过压': `Module Charge Over Voltage P1`,
  '告警管理/模组充电P2级过压': `Module Charge Over Voltage P2`,
  '告警管理/模组充电P3级过压': `Module Charge Over Voltage P3`,
  '告警管理/模组放电P1级欠压': `Module Discharge Under Voltage P1`,
  '告警管理/模组放电P2级欠压': `Module Discharge Under Voltage P2`,
  '告警管理/模组放电P3级欠压': `Module Discharge Under Voltage P3`,
  '告警管理/模组充电截止': `Module Charge Cutoff`,
  '告警管理/模组放电截止': `Module Discharge Cutoff`,
  '告警管理/电池簇充电P1级过压': `Battery Cluster Charge Over Voltage P1`,
  '告警管理/电池簇充电P2级过压': `Battery Cluster Charge Over Voltage P2`,
  '告警管理/电池簇充电P3级过压': `Battery Cluster Charge Over Voltage P3`,
  '告警管理/电池簇放电P1级欠压': `Battery Cluster Discharge Under Voltage P1`,
  '告警管理/电池簇放电P2级欠压': `Battery Cluster Discharge Under Voltage P2`,
  '告警管理/电池簇放电P3级欠压': `Battery Cluster Discharge Under Voltage P3`,
  '告警管理/电池簇充电截止': `Battery Cluster Charge Cutoff`,
  '告警管理/电池簇放电截止': `Battery Cluster Discharge Cutoff`,
  '告警管理/电池单体充电P3级高温告警': `Cell Charge High Temperature Alarm P3`,
  '告警管理/电池单体充电P3级低温告警': `Cell Charge Low Temperature Alarm P3`,
  '告警管理/电池单体放电P3级高温告警': `Cell Discharge High Temperature Alarm P3`,
  '告警管理/电池单体放电P3级低温告警': `Cell Discharge Low Temperature Alarm P3`,
  '告警管理/电池单体充电电压极差P1级告警': `Cell Charge Voltage Difference Alarm Level P1`,
  '告警管理/电池单体充电电压极差P2级告警': `Cell Charge Voltage Difference Alarm Level P2`,
  '告警管理/电池单体充电电压极差P3级告警': `Cell Charge Voltage Difference Alarm Level P3`,
  '告警管理/电池单体放电电压极差P1级告警': `Cell Discharge Voltage Difference Alarm Level P1`,
  '告警管理/电池单体放电电压极差P2级告警': `Cell Discharge Voltage Difference Alarm Level P2`,
  '告警管理/电池单体放电电压极差P3级告警': `Cell Discharge Voltage Difference Alarm Level P3`,
  '告警管理/电池单体充电电压极差截止': `Cell Charge Difference Cutoff`,
  '告警管理/电池单体放电电压极差截止': `Cell Discharge Difference Cutoff`,
  '告警管理/电池模组充电电压极差P1级告警': `Module Charge Voltage Difference Alarm P1`,
  '告警管理/电池模组充电电压极差P2级告警': `Module Charge Voltage Difference Alarm P2`,
  '告警管理/电池模组充电电压极差P3级告警': `Module Charge Voltage Difference Alarm P3`,
  '告警管理/电池模组放电电压极差P1级告警': `Module Discharge Voltage Difference Alarm P1`,
  '告警管理/电池模组放电电压极差P2级告警': `Module Discharge Voltage Difference Alarm P2`,
  '告警管理/电池模组放电电压极差P3级告警': `Module Discharge Voltage Difference Alarm P3`,
  '告警管理/电池模组充电电压极差截止': `Module Charge Voltage Difference Cutoff`,
  '告警管理/电池模组放电电压极差截止': `Module Discharge Voltage Difference Cutoff`,
  '告警管理/电池单体充电温度极差P1级告警': `Cell Charge Temperature Difference Alarm P1`,
  '告警管理/电池单体充电温度极差P2级告警': `Cell Charge Temperature Difference Alarm P2`,
  '告警管理/电池单体充电温度极差P3级告警': `Cell Charge Temperature Difference Alarm P3`,
  '告警管理/电池单体放电温度极差P1级告警': `Cell Discharge Temperature Difference Alarm P1`,
  '告警管理/电池单体放电温度极差P2级告警': `Cell Discharge Temperature Difference Alarm P2`,
  '告警管理/电池单体放电温度极差P3级告警': `Cell Discharge Temperature Difference Alarm P3`,
  '告警管理/电池单体充电温度极差截止': `Cell Charge Difference Cutoff`,
  '告警管理/电池单体放电温度极差截止': `Cell Discharge Difference Cutoff`,
  '告警管理/电池电压断线': `Battery Voltage Break`,
  '告警管理/电池温度断线': `Battery Temperature Break`,
  '告警管理/电量充满': `Energy Fully Charge`,
  '告警管理/充电过流P1': `Charge Over Current P1`,
  '告警管理/充电过流P2': `Charge Over Current P2`,
  '告警管理/充电过流P3': `Charge Over Current P3`,
  '告警管理/充电过流P4': `Charge Over Current P4`,
  '告警管理/放电过流P1': `Discharge Over Current P1`,
  '告警管理/放电过流P2': `Discharge Over Current P2`,
  '告警管理/放电过流P3': `Discharge Over Current P3`,
  '告警管理/放电过流P4': `Discharge Over Current P4`,
  '告警管理/eBlock降额': `eBlock Derating`,
  '告警管理/eBlock限功率': `eBlock Limit Power`,
  '告警管理/eLink调度关机': `eLink Dispatch Power Off`,
  '告警管理/PCS故障关机': `PCS Fault Power Off`,
  '告警管理/电芯持续一般欠压风险-预警3级': `Cell Continuous Gerneral Under Voltage Risk-Forewarn Level3`,
  '告警管理/最低电芯电压＜2.85V且最低电芯电压≠0，持续5min': `Cell Lowest Voltage < 2.85V and Lowest Cell Voltage ≠0， Duration 5min`,
  '告警管理/电芯持续中度欠压风险-预警2级': `Cell Continuous Medium Under Voltage Risk-Forewarn Level2`,
  '告警管理/最低电芯电压＜2.75V且最低电芯电压≠0，持续5min': `Cell Lowest Voltage < 2.75V and Lowest Cell Voltage ≠0， Duration 5min`,
  '告警管理/电芯持续严重欠压风险-预警1级': `Cell Continuous Serious Under Voltage Risk-Forewarn Level2`,
  '告警管理/最低电芯电压＜2.5V且最低电芯电压≠0，持续5min': `Cell Lowest Voltage < 2.5V and Lowest Cell Voltage ≠0， Duration 5min`,
  '告警管理/电芯持续过压风险-预警1级': `Cell Continuous Over Voltage Riks-Forewarn Level1`,
  '告警管理/最高电芯电压大于3.65V持续5min': `Cell Highest Voltage > 3.65V and Duration 5min`,
  '告警管理/电芯工作区间偏移一般风险-预警3级': `Cell Working Area offset General Risk-Forewarn Level3`,
  '告警管理/eBlock电芯最小容量的96%＜系统容量＜eBlock电芯最小容量的98%': `96% * eBlock Cell Lowest Capacity < System Capacity < 98% * eBlock Cell Lowest Capacity`,
  '告警管理/电芯工作区间偏移恶化风险-预警2级': `Cell Working Area Shift Deteriorate Risk-Forewarn Level2`,
  '告警管理/3004风险未消除的情况下，充电截止时最高电芯电压和平均电压的偏差逐渐拉大': `Highest Cell Voltage and Average Voltage Difference Increase Gradually at Charge End, When 3004 Risk Exists`,
  '告警管理/电芯缺电一般风险-预警3级': `Cell Energy Shortage General Risk-Forewarn Level3`,
  '告警管理/系统容量＜eBlock电芯最小容量的96%': `System Capcity < 96% * eBlock Cell Lowest Capacity`,
  '告警管理/电芯缺电恶化风险-预警2级': `Cell Energy Shortage Deteriorate Risk-Forewarn Level2`,
  '告警管理/3006风险未消除情况下，充电截止时最低电芯电压与平均电压的偏差逐渐拉大': `Lowest Cell Voltage and Average Voltage Difference Increase Gradually at Discharge End, When 3004 Risk Exists`,
  '告警管理/电芯离群一般风险-预警3级': `Cell Outlier General Risk-Forewarn Level3`,
  '告警管理/同时满足下述两个条件：①充电至75%SOC时电芯电压高于平均电压15mV,②放电至30%SOC时电芯电压低于平均电压15mV': `Cell Voltage is 15mV Above Average Voltage when Charge to the 75% of SOC and Cell Voltage is 15mV Below Average Voltage when Discharge to the 30% of SOC `,
  '告警管理/电芯离群恶化风险-预警2级': `Cell Outlier Deteriorate Risk-Forewarn Level2`,
  '告警管理/3008风险未消除的情况下，充电截止平均电压逐渐减小': `Average Voltage Decrease Gradully at Charge End, When 3004 Risk Exists`,
  '告警管理/簇间电压不均衡一般风险-预警3级': `Cluster Between Voltage Unequalization General Riks-Forewarn Level3`,
  '告警管理/5%SOC对应压差（100%与95%SOC的压差）＜目标eBlock与首台满充截止eBlock最高电压偏差＜10%SOC对应压差（100%与90%SOC的压差）': `Voltage Difference Under the 5% of SOC (Voltage Difference between the 100% and 95% of SOC) < Highest Votage Difference Between the Target eBlcok and the First One < Voltage Difference under the 10% of SOC (Voltage Difference between the 100% and 90% of SOC) `,
  '告警管理/簇间电压不均衡严重风险-预警2级': `Cluster Between Voltage Unequalization Serious Risk-Forewarn Level2`,
  '告警管理/目标eBlock与首台满充截止eBlock最高电压偏差＞10%SOC对应压差（100%与90%SOC的压差）': `Highest Voltage Difference Between the Target eBlock and the First One > Voltage Difference Under the 10% of SOC (Voltage Difference between the 100% and 90% of SOC) `,
  '告警管理/电芯跳水/寿命终止风险-预警1级': `Cell Diving/Service Life End Risk-Forewarn Level1`,
  '告警管理/满足下述任意一个条件：①电芯容量低于70%出厂容量；②电芯容量相比上一次存储值降低比例超过50%': `Cell Capacity < 70% * Factory Capacity and Cell Capacity Reduction in the Value Compared to the Last One in the Storage is > 50% `,
  '告警管理/簇内电芯SOC偏离一般风险-预警3级': `Cluster Between Cell SOC Shift General Risk-Forewarn Level3`,
  '告警管理/满足下述任意一个条件：①充电截止时，3%＜SOC跳变量＜6%;②放电截止时，3%＜SOC跳变量＜6%': `One of ① 3% < SOC Jump Value < 6% at Charge End and 3% < SOC Jump Value < 6% at Discharge End`,
  '告警管理/簇内电芯SOC偏离中度风险-预警2级': `Cluster Between Cell SOC Shift Medium Risk-Forewarn Level2`,
  '告警管理/满足下述任意一个条件：①充电截止时，6%＜SOC跳变量＜9%;②放电截止时，6%＜SOC跳变量＜9%': `One of ① 6% < SOC Jump Value < 9% at Charge End and 6% < SOC Jump Value < 9% at Discharge End`,
  '告警管理/簇内电芯SOC偏离严重风险-预警1级': `Cluster Between Cell SOC Shift Serious Risk-Forewarn Level1`,
  '告警管理/满足下述任意一个条件：①充电截止时，SOC跳变量＞9%;②放电截止时，SOC跳变量＞9%': `One of ① SOC Jump Value > 9% at Charge End and SOC Jump Value > 9% at Discharge End`,
  '告警管理/eBlock容量异常衰减一般风险-预警3级': `eBlock Capacity Degeneration Abnormal General Risk-Forewarn Level3`,
  '告警管理/eBlock单次循环容量衰减量＞0.3Ah': `eBlock Single Cycle Capacity Degeneration Value > 0.3Ah`,
  '告警管理/簇间容量离群一般风险-预警3级': `Cluster Between Capacity Outlier General Risk-Forewarn Level3`,
  '告警管理/eBlock容量＜方阵系统容量平均值*90%': `eBlock Capacity < 90% * Matrix Average Capacity`,
  '告警管理/簇内电芯温度离群一般风险-预警3级': `Cluster Between Cell Temperature Outlier General Risk-Forewarn Level3`,
  '告警管理/两次采样的簇内最大温差升高速率大于1.5℃/5min': `Cluster Inner Max Temperature Rise Rate > 1.5℃/5min between two sampling`,
  '告警管理/簇间温度离群一般风险-预警3级': `Cluster Between Temperature Outlier General Risk-Forewarn Level3`,
  '告警管理/在簇间温差大于15℃的前提下，eBlock平均温度超过eBlock簇平均温度分布3/4分位点': `eBlock Average Temperature > eBlock Cluster Average Temperature 0.75 Quantile When Cluster Between Temperature > 15℃`,
  '告警管理/簇内电芯内阻不一致一般风险-预警3级': `Cluster Inner Cell Resistance Inconsistent General Risk-Forewarn Level3`,
  '告警管理/满足下述任意一个条件：①1000μΩ＜最大欧姆内阻＜1200μΩ；②2500μΩ＜最大极化内阻＜3000μΩ': `One of ①1000μΩ＜Max Ohmic Resistance＜1200μΩ；②2500μΩ＜Max Polarization Resistance＜3000μΩ`,
  '告警管理/簇内电芯内阻不一致中度风险-预警2级': `Cluster Inner Cell Resistance Inconsistent Medium Risk-Forewarn Level3`,
  '告警管理/满足下述任意一个条件：①1200μΩ＜最大欧姆内阻＜1500μΩ；②3000μΩ＜最大极化内阻＜3750μΩ': `One of ①1200μΩ＜Max Ohmic Resistance＜1500μΩ；②3000μΩ＜Max Polarization Resistance＜3750μΩ`,
  '告警管理/簇内电芯内阻不一致严重风险-预警1级': `Cluster Inner Cell Resistance Inconsistent Serious Risk-Forewarn Level3`,
  '告警管理/满足下述任意一个条件：①最大欧姆内阻＞1500μΩ；②最大极化内阻＞3750μΩ': `One of ① Max Ohmic Resistance> 1500μΩ；② Max Polarization Resistance＜375μΩ`,
  '告警管理/簇间内阻不一致一般风险-预警3级': `Cluster Between Resistance Inconsistance General Risk-Forewarn Level3`,
  '告警管理/满足下述任意一个条件：①eBlock最大欧姆内阻＞eBlock间欧姆内阻最大值的平均值*1.5；②eBlock最大极化内阻＞eBlock间极化内阻最大值的平均值*1.5': `One of ①eBlock Max Ohmic Resistance＞Averge of eBlocks' Max Ohmic Resistance*1.5；②eBlockMax Polarization Resistance＞Average of eBlocks' Max Polarization Resistance*1.5`,
  '告警管理/急停': `Emergency Stop`,
  '告警管理/控制柜急停按下': `Control Cabinet Press Emergency Stop`,
  '告警管理/跳闸': `Trip`,
  '告警管理/支路断路器部分跳闸': `Partial Branch Circuit Breaker Trip`,
  '告警管理/支路断路器全部跳闸': `All Branch Circuit Breaker Trip`,
  '告警管理/主断路器跳闸': `Main Circuit Breaker Trip`,
  '告警管理/雷击': `Lightning`,
  '告警管理/防雷触发，防雷模块击穿': `Lightning Protection Trigger, Lightning Protection Module Breakdown`,
  '告警管理/eBlock通信故障': `eBlock Communication Fault`,
  '告警管理/部分eBlock通信故障': `Partial eBlock Communication Fault`,
  '告警管理/eBlock通信故障': `eBlock Communication Fault`,
  '告警管理/全部eBlock通信故障': `All eBlock Communication Fault`,
  '告警管理/电表通信故障（连接异常）': `Meter Communication Fault (Connection Abnormal)`,
  '告警管理/某一类型电表中部分或全部电表连续10次未收到数据': `Partial or All Meters of the Same Type Consecutive 10 Missing Data`,
  '告警管理/电表通信故障（数据异常）': `Meter Communication Fault (Data Abnormal)`,
  '告警管理/某一类型电表中部分或者全部电表连续10次数据异常（有数据但数据异常）': `Partial or All Meters of the Same Type Consecutive 10 Data Abnormal(Data Exist But Abnormal)`,
  '告警管理/并网点电表通信故障 （通讯异常）': `GCP Meter Communication Fault (Communication Abnormal)`,
  '告警管理/部分或者全部并网点电表连续10次未收到数据': `Partial or All GCP Meters Consecutive 10 Missing Data`,
  '告警管理/并网点电表通信故障 （数据异常）': `GCP Meter Communication Fault (Data Abnormal)`,
  '告警管理/部分或者全部并网点电表连续10次数据异常': `Partial or All GCP Meters Consecutive 10 Data Abnormal`,
  '告警管理/计量电表通信故障': `Measure Meter Communication Fault`,
  '告警管理/客户并网点计量电表连续10次未收到数据': `Customer GCP Measure Meter Consecutive 10 Missing Data`,
  '告警管理/客户并网点计量电表连续10次数据异常': `Customer GCP Measure Meter Consecutive 10 Data Abnormal`,
  '告警管理/辅源计量电表连续10次未收到数据': `Auxiliary Measure Meter Consecutive 10 Missing Data`,
  '告警管理/辅源计量电表连续10次数据异常': `Auxiliary Measure Meter Consecutive 10 Data Abnormal`,
  '告警管理/空调计量电表连续10次未收到数据': `Air Conditioner Measure Meter Consecutive 10 Missing Data`,
  '告警管理/空调计量电表连续10次数据异常': `Air Conditioner Measure Meter Consecutive 10 Data Abnormal`,
  '告警管理/空调通信故障': `Air Conditioner Communication Fault`,
  '告警管理/柜内空调连续10次未收到数据': `Cabinet Inner Consecutive 10 Missing Data`,
  '告警管理/柜内空调连续10次数据异常': `Cabinet Inner Consecutive 10 Data Abnormal`,
  '告警管理/ups通信故障': `UPS Communication Fault`,
  '告警管理/柜内ups连续10次未收到数据': `Cabinet Inner Consecutive 10 Missing Data`,
  '告警管理/柜内ups连续10次数据异常': `Cabinet Inner Consecutive 10 Data Abnormal`,
  '告警管理/IO模块通信故障': `IO Module Communication Fault`,
  '告警管理/IO模块连续10次未收到数据': `IO Module Consecutive 10 Missing Data`,
  '告警管理/IO模块连续10次数据异常': `IO Module Consecutive 10 Data Abnormal`,
  '告警管理/CAN模块通信故障': `CAN Module Communication Fault`,
  '告警管理/CAN转网络模块连续10次未收到数据': `CAN Switch Network Module Consecutive 10 Missing Data`,
  '告警管理/消防系统通信故障': `Fire System Communication Fault`,
  '告警管理/消防系统连续10次未收到数据': `Fire System Consecutive 10 Missing Data`,
  '告警管理/消防系统通信故障': `Fire System Communication Fault`,
  '告警管理/消防系统连续10次数据异常': `Fire System Consecutive 10 Data Abnormal`,
  '告警管理/串口服务器通信故障': `COM Server Communication Fault`,
  '告警管理/串口服务器连续10次未收到数据': `COM Server Consecutive 10 Missing Data`,
  '告警管理/消防触发': `Fire Trigger`,
  '告警管理/eBlock触发消防信息': `eBlock Fire Message Trigger`,
  '告警管理/独立消防系统3触发': `Independent Fire System3 Trigger`,
  '告警管理/消防1': `Fire1`,
  '告警管理/独立消防系统1触发': `Independent Fire System1 Trigger`,
  '告警管理/消防0': `Fire0`,
  '告警管理/独立消防系统0触发': `Independent Fire System0 Trigger`,
  '告警管理/消防传感器故障': `Fire Sensor Fault`,
  '告警管理/独立消防系统传感器故障': `Independent Fire System Sensor Fault`,
  '告警管理/UPS故障': `UPS Fault `,
  '告警管理/UPS未启用条件下故障(取自UPS数据)': `UPS Fault When UPS Sotp (Data From UPS)`,
  '告警管理/交流电压异常': `Alternating Current Voltage Abnormal`,
  '告警管理/交流供电异常，UPS启用': `Alternating Current Power Supply Abnormal, UPS Start`,
  '告警管理/UPS电池电压低': `UPS Battery Voltage Low`,
  '告警管理/UPS启用条件下电池电压过低': `Battery Voltage Extra Low When UPS Start`,
  '告警管理/UPS未启用，交流供电正常条件下，UPS电池电压低': `UPS Battery Voltage Low When UPS Stop and Alternating Current Power Supply Normal`,
  '告警管理/空调制冷': `Air Conditioner Refrigerate`,
  '告警管理/空调制冷开启': `Air Conditioner Refrigeration Start`,
  '告警管理/空调制热': `Air Conditioner Heat`,
  '告警管理/空调制热开启': `Air Conditioner Heat Start`,
  '告警管理/空调故障': `Air Conditioner Fault`,
  '告警管理/空调任意告警或者故障触发': `Any Air Conditioner Alarm or Fault Trigger`,
  '告警管理/网络异常': `Network Abnormal`,
  '告警管理/对外通信网络异常（4G异常或者网线异常，异常时记录，恢复时上报）': `External Communication Network (4G Abnormal or Cable Normal, Record Abnormal, Report Recovery)`,
  '告警管理/运行模式异常': `Operation Mode Abnormal`,
  '告警管理/方阵eBlock运行模式不一致': `Matrix eBlock Operation Mode Inconsistent`,
  '告警管理/eLink 内存资源异常': `eLink Memory Resource Abnormal`,
  '告警管理/eLink 内存资源异常超限': `eLink Memory Resource Abnormal Over Limit`,
  '告警管理/eLink CPU资源异常': `eLink CPU Resource Abnormal`,
  '告警管理/eLink CPU资源异常超限': `eLink CPU Resource Abnormal Over Limit`,
  '告警管理/空调制冷异常': `Air Conditoner Refrigeration Abnormal`,
  '告警管理/柜体达到制冷温度未制冷': `Cabinet Refrigeration Disable When Temperature Met`,
  '告警管理/空调制热异常': `Air Conditioner Heat Abnormal`,
  '告警管理/柜体达到制冷热度未制热': `Cabient Heat Disable When Temperature Met`,
  '告警管理/消防设备告警': `Fire Equipment Alarm`,
  '告警管理/告警码删除提示': (code) => `Are you sure you want to delete the alarm code ${code}?`,
  '告警管理/请选择故障等级': `Please Select Alarm Level`,
  '告警管理/请选择设备类型': `Please Select Equipment Model`,
  '告警管理/请输入故障描述': `Please Input Alarm Description`,
  '告警管理/请输入故障详情': `Please Input Alarm Details`,
  '告警管理/消防': `Fire`,
  '告警管理/删除成功': `Delete Success`,
  '告警管理/开始': `Start Time`,
  '告警管理/结束': `End Time`,
  '告警管理/未审校': `Unverified`,
  '告警管理/已审校': `Verified`,
  '告警管理/确认': `Confirm`,
  '告警管理/告警确认': `Confirm Alarm`,
  '告警管理/请输入备注': `Please Input Remark`,
  '告警管理/故障描述_英文': `Description (English)`,
  '告警管理/故障详情_英文': `Details (English)`,
  '告警管理/故障描述_意大利语': `Description (Italian)`,
  '告警管理/故障详情_意大利语': `Details (Italian)`,
  '告警管理/100C设备故障编码': `Alarm Code For eBlock100C`,
  '告警管理/非100C设备故障编码': `Alarm Code For Other Equipment`,
  '告警管理/在eMind中展示': `Show in eMind`,
  '告警管理/给客户展示': `Show to Customer`,


  /* 运行策略 */
  
  '运行策略/能量链': `eLink`,
  '运行策略/当前模式': `Current Mode`,
  '运行策略/削峰填谷模式': `Peak-Clipping and Valley-Filling Mode`,
  '运行策略/切换模式': `Switch Mode`,
  '运行策略/刷新': `Refresh`,
  '运行策略/定时设置': `Schedule Settings`,
  '运行策略/各项参数以及运行策略将会在指定日期之后生效': `All parameters and operation strategies will take effect after the customized date`,
  '运行策略/新增': `New`,
  '运行策略/取消': `Cancel`,
  '运行策略/生效日期': `Effective Date`,
  '运行策略/策略模式': `Strategy Mode`,
  '运行策略/需量': `Demand`,
  '运行策略/充放电模式': `Charge and Discharge Mode`,
  '运行策略/无休': `No Day Off`,
  '运行策略/单休': `One Day Off`,
  '运行策略/双休': `Two Day Off`,
  '运行策略/虚拟电厂调度': `Virtual Power Plant Dispatch`,
  '运行策略/禁止': `Ban`,
  '运行策略/允许': `Permitted`,
  '运行策略/运行策略': `Operation Strategy`,
  '运行策略/复制': `Copy`,
  '运行策略/粘贴': `Paste`,
  '运行策略/清空': `Clearance`,
  '运行策略/开始时间': `Start Time`,
  '运行策略/结束时间': `End Time`,
  '运行策略/功率': `Power`,
  '运行策略/充电上限': `Charge Upper Limit`,
  '运行策略/放电下限': `Discharge Lower Limit`,
  '运行策略/操作': `Operation`,
  '运行策略/暂无数据': `No Data`,
  '运行策略/推送': `Push`,
  '运行策略/取消对比': `Cancel`,
  '运行策略/已同步': `Synchronized`,
  '运行策略/未同步': `Unsynchronized`,
  '运行策略/同步中': `Synchronizing`,
  '运行策略/同步时间': `Synchronized Time`,
  '运行策略/策略': `Strategy`,
  '运行策略/允许虚拟电厂调度': `Permitted Virtual Power Plant to Dispatch`,
  '运行策略/否': `No`,
  '运行策略/策略信息': `Strategy Information`,
  '运行策略/本月最大需量': `Current Month Max Demand`,
  '运行策略/修改': `Modify`,
  '运行策略/确定': `Confirm`,
  '运行策略/当前充放电模式': `Current Charge and Discharge Mode`,
  '运行策略/所有日期都执行工作日策略': `Weekday Strategy for all days`,
  '运行策略/日历视图': `Calendar View`,
  '运行策略/本月最大需量由关口电表的历史数据而来，请在设置需量时根据实际情况酌情设置': `Current month reference demand based on the prediction of the PCC meter's history data, Please set demand according to the actual situation`,
  '运行策略/上个月': `Last Month`,
  '运行策略/今天': `Today`,
  '运行策略/下个月': `Next Month`,
  '运行策略/切换': `Switch`,
  '运行策略/对比': `Comparison`,
  '运行策略/请先设置需量': `Please Set the Demand First`,
  '运行策略/自定义策略的名称不能为空': `The name of the custom strategy cannot be empty`,


  '运行策略/动作': 'Action',
  '运行策略/请选择': 'Please Select',
  '运行策略/SOC上限': 'SOC Upper Limit',
  '运行策略/SOC下限': 'SOC Lower Limit',
  '运行策略/变压器容量上限': 'Transformer Capacity Upper Limit',
  '运行策略/变压器容量下限': 'Transformer Capacity Lower Limit',
  '运行策略/持续时间': 'Duration',
  '运行策略/功率模式': 'Power Mode',
  '运行策略/零功率且关机': 'Zero Power and Stop',
  '运行策略/零功率且待机': 'Zero Power and Idle',
  '运行策略/按照设定功率运行': 'Operate Under the Set Power',
  '运行策略/范围为': 'Range',
  '运行策略/按照额定功率运行': 'Operate Under the Rated Power',
  '运行策略/按照变压器负载率上限为目标': 'Target with Transformer Load Factor Upper Limit',
  '运行策略/按照变压器负载率下限为目标': 'Target with Transformer Load Factor Lower Limit',
  '运行策略/若策略模式未切换成功，请点击此按钮刷新。': 'Please Press this Refresh Button When the Strategy Mode Switch Fail',
  '运行策略/若长时间后仍未成功，请联系管理员！': 'Please Contact the Administrator When the Operation Still Fail After a Long Time',
  '运行策略/当前生效': 'Current Effectiveness',
  '运行策略/同步结果': 'Synchronous Result',
  '运行策略/请输入需量': 'Please Input the Demand',
  '运行策略/运行策略管理': 'Operation Strategy Management',
  '运行策略/关闭': 'Close',
  '运行策略/打开': 'Open',
  '运行策略/请选择一种模式': 'Please Select a Mode',
  '运行策略/时段与运行功率': 'Time Periods and Operation Power',
  '运行策略/变压器扩容': 'Transformer Capacity Expansion',
  '运行策略/提示': 'Notice',
  '运行策略/停机切换为其他模式时，时间有延迟': 'There is a Delay When the Stop Mode Switch to the Other One',
  '运行策略/请输入时段名称': 'Input Period Name',
  '运行策略/时段名称不能为空': 'The Time Period Name Can not be Empty',
  '运行策略/增加规则': 'New Rules',
  '运行策略/增加时段': 'New Periods',
  '运行策略/需量必须大于0': 'The Demand Must be Larger than 0',
  '运行策略/需量修改成功': 'Modify The Demand Successfully',
  '运行策略/推送失败': 'Push Failed',
  '运行策略/确定切换': 'Switch Confirmed',
  '运行策略/您未设置休息日策略，请先点击下方“运行策略”按钮进行设置': 'You have not set Weekend Strategy and therefore Please Press the "Operation Strategy" Button Below to Set ',
  '运行策略/计划修改成功': 'Modify the Plan Successfully',
  '运行策略/切换成功': 'Switch Successfully',
  '运行策略/工作日策略不能为空': 'Weekday Strategy Can not be Empty',
  '运行策略/周日执行休息日策略，其他时间执行工作日策略': 'Weekend Strategy for Sundays and Weekday Strategy for the Other Time',
  '运行策略/周六和周日执行休息日策略，其他时间执行工作日策略': 'Weekend Strategy for Saturdays and Sundays and Weekday Strategy for the Other Time',
  '运行策略/新建变压器保护策略': 'New transformer protection strategy ',
  '运行策略/工作日策略中充电上限不能小于放电下限': 'The Charge Upper Limit of the Weekday Strategy Can not be Less than the Discharge Lower Limit',
  '运行策略/休息日策略中充电上限不能小于放电下限': 'The Charge Upper Limit of the Rest Day Strategy Can not be Less than the Discharge Lower Limit',


  '运行策略/尖': 'Sharp',
  '运行策略/峰': 'Peak',
  '运行策略/平': 'Flat',
  '运行策略/谷': 'Valley',
  '运行策略/放电': 'Discharge',
  '运行策略/充电': 'Charge',
  '运行策略/关机': 'Power Off',
  '运行策略/待机': 'Idle',
  '运行策略/额定': 'Rated',
  '运行策略/扩容': 'Expansion',
  '运行策略/设定': 'Setting',
  '运行策略/变压器保护策略': 'Transformer Protection Strategy',
  '运行策略/时段不能为空': 'Time Period Can not be Empty',
  '运行策略/SOC上限不能小于SOC下限': 'SOC Upper Limit Can not be Less than SOC Lower Limit',
  '运行策略/变压器容量上限不能小于变压器容量下限': 'Transformer Capacity Upper Limit Can not be Less than Transformer Capacity Lower Limit',
  '运行策略/功率模式设定值不能为空': 'Power Mode Setting Value Can not be Empty',
  '运行策略/功率模式不能为空': 'Power Mode Can not be Empty',
  '运行策略/功率模式设定值不能超过': 'Power Mode Setting Value Can not be Larger than',
  '运行策略/或小于0': 'or Less than 0',
  '运行策略/持续时间不能为空': 'Duration Can not be Empty',
  '运行策略/动作不能为空': 'Action Can not be Empty',
  '运行策略/SOC不能为空': 'SOC Can not be Empty',
  '运行策略/变压器容量不能为空': 'Transformer Capacity Can not be Empty',
  '运行策略/时段内的规则存在交集': 'The Time Period Rules Exist Overlapping',
  '运行策略/时段内的规则未覆盖全部区域': 'The Time Period Rules Do not Cover All Areas',
  '运行策略/以下时间存在交集，请修改': 'The Following Time Periods Exist Overlapping, Please Modify',
  '运行策略/策略时间槽不正确，请设置连续的时段，且范围覆盖 00:00-23:59': 'The Strategy Time Slot is Incorrect, Please Set Continuous Time Periods and Cover 00:00-23:59',
  '运行策略/更新成功': 'Update Success',
  '运行策略/复制成功': 'Copy Success',
  '运行策略/粘贴成功': 'Paste Success',
  '运行策略/剪切板数据格式错误': 'Clipboard Data Format Error',
  '运行策略/请先开启浏览器读取剪贴板的权限': 'Please Enable the Browser to Read the Clipboard Permission First',
  '运行策略/时段': 'Time Period',
  '运行策略/推送': 'Push',
  '运行策略/编辑': 'Edit',
  '运行策略/确认': 'Confirm',
  '运行策略/变压器保护模式': 'Transformer Protection Mode',

  '运行策略/生效日期': 'Effective Date',
  '运行策略/策略模式': 'Strategy Mode',
  '运行策略/削峰填谷模式': 'Peak Shaving Mode',
  '运行策略/需量': 'Demand',
  '运行策略/充放电模式': 'Charge/Discharge Mode',
  '运行策略/虚拟电厂调度': 'Virtual Power Plant Dispatch',
  '运行策略/运行策略': 'Operation Strategy',
  '运行策略/预约运行策略管理': 'Scheduled Operation Strategy Management',
  '运行策略/关闭': 'Close',
  '运行策略/保存': 'Save',
  '运行策略/生效日期不能为空': 'Effective date cannot be empty',
  '运行策略/需量不能为空': 'Demand cannot be empty',
  '运行策略/需量必须大于0': 'Demand must be greater than 0',
  '运行策略/充放电模式不能为空': 'Charge/Discharge mode cannot be empty',
  '运行策略/策略模式不能为空': 'Strategy mode cannot be empty',
  '运行策略/未执行': 'Not Executed',
  '运行策略/已执行': 'Executed',
  '运行策略/执行中': 'Executing',
  '运行策略/工作日策略不能为空': 'Work day strategy cannot be empty',
  '运行策略/休息日策略不能为空': 'Rest day strategy cannot be empty',
  '运行策略/需量不能为0': 'Demand cannot be 0',
  '运行策略/修改成功!': 'Modified successfully!',
  '运行策略/新增成功!': 'Added successfully!',
  '运行策略/确定要删除吗?': 'Are you sure you want to delete?',
  '运行策略/生效日期重复提示': (s) => `Effective date conflicts with ${s}`,
  '运行策略/策略模式切换': 'Strategy Mode Switch',
  '运行策略/休息日策略': 'Rest Day Strategy',
  '运行策略/工作日策略': 'Work Day Strategy',
  '运行策略/预约策略生效日期': 'Appointment Strategy Effective Date',
  '运行策略/策略切换成功': 'Strategy switched successfully',
  '运行策略/eLink策略': 'eLink Strategy',
  '运行策略/eMind策略': 'eMind Strategy',
  '运行策略/需量': 'Demand',
  '运行策略/允许虚拟电厂调度': 'Allow Virtual Power Plant Dispatch',

  '运行策略/是': 'Yes',
  '运行策略/否': 'No',
  '运行策略/策略满足条件': 'Strategy meets conditions',
  '运行策略/策略未覆盖24小时': 'Strategy does not cover 24 hours',
  '运行策略/控制模式为本地控制': 'Control mode is local control',
  '运行策略/控制源为非eMind控制': 'Control source is not eMind control',
  '运行策略/eLink策略': 'eLink Strategy',
  '运行策略/eMind策略': 'eMind Strategy',
  '运行策略/预约策略': 'Appointment Strategy',


  '运行策略/新增一行': 'Add Row',
  '运行策略/策略文本': 'Strategy Text',
  '运行策略/请将策略文本粘贴到这里': 'Please paste the strategy text here',
  '运行策略/已经存在策略，确定要替换吗？': 'Strategy already exists, are you sure to replace it?',
  '运行策略/策略格式不正确': 'Invalid strategy format',
  '运行策略/粘贴失败': 'Paste failed',
  '运行策略/请输入正确的': 'Please input the correct ',
  '运行策略/工作日': 'Work Day',
  '运行策略/休息日': 'Rest Day',
  '运行策略/推送成功': 'Push successfully',
  '运行策略/预约策略保存提示': (s) => `Please save the "${s}" first`,
  '运行策略/预约策略生效提示': (s, d) => `Distance to the effective date of "${s}" is ${d} days`,
  '运行策略/删除': 'Delete',
  '运行策略/eLink最后一次上报的需量和策略数据与eMind不一致': 'eLink last reported demand and strategy data are inconsistent with eMind',

  '运行策略/操作者': 'Operator',
  '运行策略/操作类型': 'Operation Type',
  '运行策略/修改时间': 'Modify Time',
  '运行策略/操作内容': 'Operation Content',
  '运行策略/策略模式更改': 'Strategy Mode Changed',
  '运行策略/策略内容变更': 'Strategy Content Changed',
  '运行策略/需量变更': 'Demand Changed',
  '运行策略/计划变更': 'Plan Changed',
  '运行策略/策略类型变更': 'Strategy Type Changed',
  '运行策略/虚拟电厂调度更改': 'Virtual Power Plant Dispatch Changed',
  '运行策略/自定义策略': 'Custom Strategy',

  '运行策略/修改了自定义策略': 'Modified Custom Strategy',
  '运行策略/删除了自定义策略': 'Deleted Custom Strategy',
  '运行策略/增加了自定义策略': 'Added Custom Strategy',
  '运行策略/了虚拟电厂调度选项': ' the virtual power plant scheduling option',
  '运行策略/修改了工作日策略': 'Modified Work Day Strategy',
  '运行策略/修改了休息日策略': 'Modified Rest Day  Strategy',
  '运行策略/策略类型修改记录': (d, t) => `Modified the strategy for ${d} to a "${t} strategy"`,
  '运行策略/充放电计划修改记录': (o, n) => `Changed the charge/discharge plan from "${o}" to "${n}"`,
  '运行策略/需量变更记录': (o, n) => `Changed the demand from "${o}" to "${n}"`,
  '运行策略/修改了变压器保护策略': 'Modified Transformer Protection Strategy',
  '运行策略/模式修改记录': (m) => `Changed the mode to "${m}"`,
  '运行策略/查看详情': 'View Details',
  '运行策略/策略详情': 'Strategy Details',
  '运行策略/表格': 'Table',
  '运行策略/差异': 'Difference',
  '运行策略/修改前策略数据': 'Previous Strategy',
  '运行策略/修改后策略数据': 'New Strategy',
  '运行策略/自定义策略详情': 'Custom Strategy Details',
  '运行策略/修改前': 'Previous',
  '运行策略/修改后': 'New',
  '运行策略/策略名称': 'Strategy Name',
  '运行策略/策略修改详情': 'Strategy Modification Details',
  '运行策略/模式切换成功': 'Mode switched successfully',

  /* 抄表结算 */
  '抄表结算/日期': 'Data',
  '抄表结算/至': 'To',
  '抄表结算/查询': 'Search',
  '抄表结算/抄表详情': 'Meter Reading Details',
  '抄表结算/收益类别': 'Earning Type',
  '抄表结算/电价类型': 'Tariff Type',
  '抄表结算/天数': 'Days',
  '抄表结算/时段': 'Periods',
  '抄表结算/尖峰时段': 'Sharp Period',
  '抄表结算/高峰时段': 'Peak Period',
  '抄表结算/平时段': 'Flat Period',
  '抄表结算/低谷时段': 'Vally Period',
  '抄表结算/深谷时段': 'Deep Valley Period',
  '抄表结算/市电单价': 'City Power Price',
  '抄表结算/计量方向': 'Measure Type',
  '抄表结算/电量': 'Energy',
  '抄表结算/电费': 'Charge',
  '抄表结算/合计': 'Total',
  '抄表结算/峰谷价差收益': 'Earning by Peak-Valley Price Spread ',
  '抄表结算/峰谷价差总收益-合计': 'Total Earning by Peak-Valley Price Spread ',
  '抄表结算/电表数据详情': 'Meta Data Details',
  '抄表结算/并网点电表': 'GCP Meter',
  '抄表结算/抄表时间': 'Meter Reading Date',
  '抄表结算/正向有功': 'Positive Active',
  '抄表结算/反向有功': 'Negative Active',
  '抄表结算/修复': 'Recovery',
  '抄表结算/换表': 'Change Meter',
  '抄表结算/换标详情': 'Change Meter Details',
  '抄表结算/复制': 'Copy',
  '抄表结算/打印': 'Print',
  '抄表结算/导出': 'Download',
  '抄表结算/确认导出': 'Are you sure to Download the meter reading settlement data?',
  '抄表结算/确定修复': 'Are you sure to repair?',
  '抄表结算/暂无数据': 'No data available',
  '抄表结算/充电': 'Charging',
  '抄表结算/放电': 'Discharging',
  '抄表结算/注': 'Note',
  '抄表结算/注说明': `Note: The monthly energy storage service fee paid by Party A to Party B is the sum of peak-valley price difference revenue. The electricity measurement is based on the total meter measurement at the grid connection point of the energy storage power station,\n and the corresponding period electricity price is based on the actual electricity price implemented by the local power supply department. The specific calculation formula is as follows:\n1. Discharging fee = ∑(Discharging electricity × corresponding period electricity price)\n2. Charging fee = ∑(Charging electricity × corresponding period electricity price)\n3. Peak-valley price difference revenue = Discharging fee - Charging fee\n4. Energy storage power station revenue = Peak-valley price difference revenue`,
  '抄表结算/尖峰时段': 'Sharp Period',
  '抄表结算/高峰时段': 'Peak Period',
  '抄表结算/平时段': 'Flat Period',
  '抄表结算/低谷时段': 'Valley Period',
  '抄表结算/深谷时段': 'Deep Valley Period',

  '抄表结算/收益修复': 'Earning Repair',
  '抄表结算/修复': 'Repair',
  '抄表结算/换表': 'Change Meter',
  '抄表结算/换表详情': 'Meter Change Details',
  '抄表结算/复制': 'Copy',
  '抄表结算/选择': 'Select',
  '抄表结算/复制成功': 'Copy Success',
  '抄表结算/尖峰': 'Sharp',
  '抄表结算/高峰': 'Peak',
  '抄表结算/平': 'Flat',
  '抄表结算/低谷': 'Valley',
  '抄表结算/深谷': 'Deep Valley',
  '抄表结算/总': 'Total',
  '抄表结算/尖': 'Sharp',
  '抄表结算/峰': 'Peak',
  '抄表结算/谷': 'Valley',
  '抄表结算/更换电表': 'Change Meter',
  '抄表结算/换表详情': 'Meter Change Details',
  '抄表结算/取消': 'Cancel',
  '抄表结算/确定': 'Confirm',
  '抄表结算/电表名称': 'Meter Name',
  '抄表结算/电表UUID': 'Meter UUID',
  '抄表结算/旧表开始值': 'Old Meter Start Value',
  '抄表结算/旧表结束值': 'Old Meter End Value',
  '抄表结算/新表开始值': 'New Meter Start Value',
  '抄表结算/新表结束值': 'New Meter End Value',
  '抄表结算/选择': 'Select',
  '抄表结算/请选择': 'Please Select',
  '抄表结算/暂无数据': 'No Data Available',
  '抄表结算/旧表结束值和新表开始值必须要选': 'Old meter end value and new meter start value must be selected',
  '抄表结算/选择电表数据': 'Select Meter Data',
  '抄表结算/修复电表数据': 'Repair Meter Data',
  '抄表结算/查询': 'Search',
  '抄表结算/取消': 'Cancel',
  '抄表结算/确定': 'Confirm',
  '抄表结算/电表名称': 'Meter Name',
  '抄表结算/电表UUID': 'Meter UUID',
  '抄表结算/请选择一条电表数据': 'Please select a meter data',

  /* 参数设置 */
  '参数设置/命令记录': 'Command Record',
  '参数设置/参数设置': 'Parameter Settings',
  '参数设置/箱变容量配比': 'Transformer Capacity Ratio',
  '参数设置/最小需量': 'Min Demand',
  '参数设置/最大需量': 'Max Demand',
  '参数设置/无功工作模式': 'Reactive Working Mode',
  '参数设置/修改': 'Modify',
  '参数设置/不出无功': 'No Reactive Power',
  '参数设置/优先出无功': 'Priority Reactive Power',
  '参数设置/优先出有功': 'Priority Active Power',
  '参数设置/实时控制': 'Real-Time Control',
  '参数设置/启停': 'On-Off',
  '参数设置/启用': 'Start',
  '参数设置/停用': 'Stop',
  '参数设置/设置协议帧': 'Set Protocol Frame',
  '参数设置/请输入协议帧': 'Please Input Protocol Frame',
  '参数设置/发送': 'Send',
  '参数设置/发送内容': 'Sent Content',
  '参数设置/发送时间': 'Sent Time',
  '参数设置/eBlock启用': 'eBlock Enable',
  '参数设置/eBlock停用': 'eBlock Disable',
  '参数设置/协议帧': 'Protocol Frame',
  '参数设置/接收内容': 'Receive Content',
  '参数设置/接收时间': 'Receive Time',
  '参数设置/EMS控制参数': 'EMS Control ',
  '参数设置/水机控制参数': 'Water Machine Control ',
  '参数设置/消防控制参数': 'Fire Contorl ',
  '参数设置/BMS控制参数': 'BMS Control ',
  '参数设置/PCS控制参数': 'PCS Contorl ',
  '参数设置/BCS控制参数': 'BCS Control ',
  '参数设置/开始时间': 'Start Time',
  '参数设置/结束时间': 'End Time',
  '参数设置/功率': 'Power',
  '参数设置/操作': 'Operation',
  '参数设置/暂无数据': 'No Data',
  '参数设置/新增': 'New',
  '参数设置/读取': 'Read',
  '参数设置/设置': 'Set',
  '参数设置/正在设置，请稍后': 'Setting Up, Please Wait',
  '参数设置/请选择': 'Select',
  '参数设置/EMS工作模式': 'EMS Working Mode',
  '参数设置/最大充电功率': 'Max Charge Power',
  '参数设置/最大放电功率': 'Max Discharge Power',
  '参数设置/余电上网功率限值': 'Residual Energy Feed-in Grid Limit',
  '参数设置/电网买电功率限值': 'Power Limit',
  '参数设置/系统开关机命令': 'System Power on-off Command',
  '参数设置/备电截止SOC': 'Backup power Cutoff SOC',
  '参数设置/充电截止SOC': 'Charge Cutoff SOC',
  '参数设置/放电截止SOC': 'Discharge Cutoff SOC',
  '参数设置/余电上网使能开关': 'Residual Energy Feed-in Grid Enable Switch',
  '参数设置/AC充电使能开关': 'AC Charge Enable Switch',
  '参数设置/非重要负载关闭': 'Unimportant Load Close',
  '参数设置/DRM需求响应开关': 'DRM Response Switch',
  '参数设置/干节点输出模式': 'Dry Contact Output Mode',
  '参数设置/手动控制开关使能': 'Manual Control Switch Enable',
  '参数设置/干节点时间控制开始时间：周时': 'Dry Contact Control Start Time: WeekHour',
  '参数设置/干节点时间控制开始时间：分秒': 'Dry Contact Control Start Time: MinuteSecond',
  '参数设置/干节点时间控制结束时间：周时': 'Dry Contact Control End Time: WeekHour',
  '参数设置/干节点时间控制结束时间：分秒': 'Dry Contact Control End Time: MinuteSecond',
  '参数设置/并机模式使能': 'Parallen Mode Enable',
  '参数设置/并机通信地址': 'Parallel Communication Address',
  '参数设置/系统时钟：年月': 'System Clock: YearMonth',
  '参数设置/系统时钟：日时': 'System Clock: DayHour',
  '参数设置/系统时钟：分秒': 'System Clock: MinuteSecond',
  '参数设置/清除电能记录': 'Clear Energy Record',
  '参数设置/电表数据清零': 'Clear Meter Data',
  '参数设置/恢复出厂设置': 'Recovery Factory Setting',
  '参数设置/故障复位': 'Fault Reset',
  '参数设置/重启命令': 'Restart Command',
  '参数设置/清除故障记录': 'Clear Fault Record',
  '参数设置/强制充电': 'Force Charge',
  '参数设置/强充功率门限': 'Force Charge Power Limit',
  '参数设置/ARM装备控制': 'ARM Control',
  '参数设置/柜体1手动设置无功功率': 'Cabinet1 Manual Set Reactive Power',
  '参数设置/柜体1手动设置PV功率': 'Cabinet1 Manual Set PV Power',
  '参数设置/柜体1手动设置DCDC功率': 'Cabinet1 Manual Set DCDC Power',
  '参数设置/禁能': 'Disable',
  '参数设置/时间控制': 'Time Control',
  '参数设置/手动开关控制': 'Manual Control Switch',
  '参数设置/backup负载控制': 'Backup Load Control',
  '参数设置/干节点输出模式为手动开关控制模式可见': 'Dry Contact Output Mode for Visible Manual Switch Control Mode ',
  '参数设置/负载优先': 'Load Priority',
  '参数设置/备电优先': 'Backup Power Priority',
  '参数设置/电网优先': 'Grid Priority',
  '参数设置/经济模式': 'Ecnomic Mode',
  '参数设置/纯离网': 'Off-Grid',
  '参数设置/开机': 'Power On',
  '参数设置/关机': 'Power Off',
  '参数设置/存储': 'Save',
  '参数设置/默认禁能': 'Default: Disable',
  '参数设置/控制模式': 'Control Mode',
  '参数设置/运行模式': 'Operation Mode',
  '参数设置/制冷设定温度': 'Refrigeration Set Temperature',
  '参数设置/制热设定温度': 'Heat Set Temperature',
  '参数设置/手动控制': 'Manual Control',
  '参数设置/自动控制': 'Automatic Control',
  '参数设置/休眠模式': 'Sleep Mode',
  '参数设置/制冷模式': 'Refrigeration Mode',
  '参数设置/加热模式': 'Heat Mode',
  '参数设置/自循环模式': 'Self Circulation Mode',
  '参数设置/电池火灾VOC浓度限值': 'Battery Fire VOC Concentration Limit',
  '参数设置/柜体火灾温度上限值': 'Cabinet Fire Temperature Limit',
  '参数设置/柜体高温门限值': 'Cabinet High Temperature Limit',
  '参数设置/柜体烟雾门限值': 'Cabinet Smoke Limit',
  '参数设置/eBlock总容量': 'eBlock Total Capacity',
  '参数设置/eBlock总电量': 'eBlock Total Energy',
  '参数设置/ACSOE设置': 'AC SOE Set',
  '参数设置/DCSOE设置': 'DC SOE Set',
  '参数设置/eBlock运行模式': 'eBlock Operation Mode',
  '参数设置/SOP控制模式': 'SOP Control Mode',
  '参数设置/手动ocv开关': 'Manual OCV Switch',
  '参数设置/柜体累积充电量': 'Cabinet Accumulated Charge Energy',
  '参数设置/小斜坡修正': 'Small Slope Modify',
  '参数设置/小斜坡容量修正触发开关': 'Small Slope Capacity Modify Trigger Switch',
  '参数设置/小斜坡计算过程的容量步长': 'Small Slope Calculation Capacity Step',
  '参数设置/小斜坡触发的电流偏差阈值': 'Small Slope Trigger by Current Bias Limit',
  '参数设置/标准额定容量': 'Standard Rated Capacity',
  '参数设置/电池能量计量模式': 'Battery Energy Measure Mode',
  '参数设置/满充满放次数': 'Fully Charge-Discharge Number',
  '参数设置/充放电截止次数': 'Charge-Discharge Cutoff Number',
  '参数设置/电池内阻测量开关': 'Battery Resistance Measure Switch',
  '参数设置/均衡时间占空比': 'Equalization Time Duty Factor',
  '参数设置/均衡类型': 'Equalization Type',
  '参数设置/均衡应用工况': 'Equalization Application Conditions',
  '参数设置/均衡触发模式': 'Equalization Trigger Mode',
  '参数设置/SOP算法开关': 'SOP Algorithm Switch',
  '参数设置/SOP充电限制系数': 'SOP Charge Limit Coefficient',
  '参数设置/SOP放电限制系数': 'SOP Discharge Limit Coefficient',
  '参数设置/SOP保护时间': 'SOP Protection Time',
  '参数设置/SOP阶梯功率': 'SOP Tiered Power',
  '参数设置/主动均衡开关': 'Active Equalization Switch',
  '参数设置/电压偏差门限': 'Voltage Bias Limit',
  '参数设置/电压差值区间': 'Voltage Difference Range',
  '参数设置/SOC偏差门限': 'SOC Bias Limit',
  '参数设置/SOC差值区间': 'SOC Difference Range',
  '参数设置/算法调用频率': 'Algorithm Invoke Frequency',
  '参数设置/单次均衡调节量': 'Single Equalization Regulated Quantity',
  '参数设置/均衡最大调节量': 'Equalization Max Regulated Quantity',
  '参数设置/均衡柜体数量': 'Equalization Cabinet Number',
  '参数设置/均衡功率占比': 'Equalization Power Ratio',
  '参数设置/分配总功率': 'Allocated Total Power',
  '参数设置/柜体可用状态': 'Cabinet Available State',
  '参数设置/SOC均衡开启的电压阈值': 'SOC Equalization Start by Voltage Limit',
  '参数设置/输出值更新的延迟倍数': 'Output Update Delay Multiple',
  '参数设置/分配系数的最大变化范围': 'Allocate Coefficient Max Range',
  '参数设置/生产老化': 'Production Ageing',
  '参数设置/现场运行': 'Site Operation',
  '参数设置/关闭': 'Close',
  '参数设置/打开': 'Open',
  '参数设置/不可分配': 'Unallocated',
  '参数设置/可以分配': 'Allocated',
  '参数设置/远程开关机指令': 'Remote Power on-off Command',
  '参数设置/运行模式': 'Operation Mode',
  '参数设置/清除故障': 'Fault Clearance',
  '参数设置/EMS模式': 'EMS Mode',
  '参数设置/硬件故障屏蔽': 'Hardware Fault Shield',
  '参数设置/标准设置': 'Standard Set',
  '参数设置/无功功率变化率设置': 'Reactive Power Changing Rate Set',
  '参数设置/有功功率变化率设置': 'Active Power Changing Rate Set',
  '参数设置/电网代码': 'Grid Code',
  '参数设置/装备控制字': 'Equipment Control Word',
  '参数设置/额定电压设置': 'Rated Voltage Set',
  '参数设置/额定频率设置': 'Rated Frequency Set',
  '参数设置/额定功率设置': 'Rated Power Set',
  '参数设置/过载系数设置': 'Over Load Coefficient Set',
  '参数设置/AFCI使能设置': 'AFCI Enable Set',
  '参数设置/AFCI阈值设置': 'AFCI Threshold Set',
  '参数设置/绝缘阻抗告警阈值设置': 'Insulation Impedance Alarm Threshold Set',
  '参数设置/电网一级过压阈值设置': 'Grid Over Voltage Level1 Threshold Set',
  '参数设置/电网一级过压时间设置': 'Grid Over Voltage Time Level1 Threshold Set',
  '参数设置/电网二级过压阈值设置': 'Grid Over Voltage Level2 Threshold Set',
  '参数设置/电网二级过压时间设置': 'Grid Over Voltage Time Level2 Threshold Set',
  '参数设置/电网一级欠压阈值设置': 'Grid Under Voltage Level1 Threshold Set',
  '参数设置/电网一级欠压时间设置': 'Grid Under Voltage Time Level1 Threshold Set',
  '参数设置/电网二级欠压阈值设置': 'Grid Under Voltage Level2 Threshold Set',
  '参数设置/电网二级欠压时间设置': 'Grid Under Voltage Time Level2 Threshold Set',
  '参数设置/电网一级过频阈值设置': 'Grid Over Frequency Level1 Threshold Set',
  '参数设置/电网一级过频时间设置': 'Grid Over Frequency Time Level1 Threshold Set',
  '参数设置/电网二级过频阈值设置': 'Grid Over Frequency Level2 Threshold Set',
  '参数设置/电网二级过频时间设置': 'Grid Over Frequency Time Level2 Threshold Set',
  '参数设置/电网一级欠频阈值设置': 'Grid Uner Frequency Level1 Threshold Set',
  '参数设置/电网一级欠频时间设置': 'Grid Under Frequency Time Level1 Threshold Set',
  '参数设置/电网二级欠频阈值设置': 'Grid Under Frequency Level2 Threhold Set',
  '参数设置/电网二级欠频时间设置': 'Grid Under Frequency Time Level2 Threshold Set',
  '参数设置/程序默认值(只读)': 'Default Value(Read Only)',
  '参数设置/事件记录存储地址(只读)': 'Event Record Saving Address(Read Only)',
  '参数设置/历史事件记录数量(只读)': 'History Event Record Number(Read Only)',
  '参数设置/PV侧电流给定': 'PV Current Set',
  '参数设置/非标设置字': 'Non-Standard Set Word',
  '参数设置/PV并联模式使能': 'PV Parallel Connection Mode Enable',
  '参数设置/孤岛保护使能': 'Isolated Island Protection Enable',
  '参数设置/总母线电压环Kp': 'Main Bus Voltage Loop Kp',
  '参数设置/总母线电压环Ki': 'Main Bus Voltage Loop Ki',
  '参数设置/并网电感电流环 Kp': 'Grid-Connected Inductance Current Loop Kp',
  '参数设置/并网电感电流环 Ki': 'Grid-Connected Inductance Current Loop Ki',
  '参数设置/离网逆变电压环 Kp': 'Off-Grid Inverter Voltage Loop Kp',
  '参数设置/离网逆变电压环 Ki': 'Off-Grid Inverter Voltage Loop Ki',
  '参数设置/离网逆变电流环 Kp': 'Off-Grid Inverter Current Loop Kp',
  '参数设置/离网逆变电流环 Ki': 'Off-Grid Inverter Current Loop Ki',
  '参数设置/平衡桥电压环 Kp': 'Balance Bridge Voltage Loop Kp',
  '参数设置/平衡桥电压环 Ki': 'Balance Bridege Voltage Loop Ki',
  '参数设置/平衡桥电流环 Kp': 'Balance Bridge Current Loop Kp',
  '参数设置/平衡桥电流环 Ki': 'Balance Bridge Current Loop Ki',
  '参数设置/离网逆变直流电压分量环 Kp': 'Off-Grid Inverter DC Voltage Component Loop Kp',
  '参数设置/离网逆变直流电压分量环 Ki': 'Off-Grid Inverter DC Voltage Component Loop Ki',
  '参数设置/A相电网电压校准系数K': 'A Phase Grid Voltage Calibration Coefficient K',
  '参数设置/A相电网电压偏置系数B': 'A Phase Grid Voltage Bias Coefficient B',
  '参数设置/B相电网电压校准系数K': 'B Phase Grid Voltage Calibration Coefficient K',
  '参数设置/B相电网电压偏置系数B': 'B Phase Grid Voltage Bias Coefficient B',
  '参数设置/C相电网电压校准系数K': 'C Phase Grid Voltage Calibration Coefficient K',
  '参数设置/C相电网电压偏置系数B': 'C Phase Grid Voltage Bias Coefficient B',
  '参数设置/A相电感电流校准系数K': 'A Phase Inductance Current Calibration Coefficient K',
  '参数设置/A相电感电流偏置系数B': 'A Phase Inductance Current Bias Coefficient B',
  '参数设置/B相电感电流校准系数K': 'B Phase Inductance Current Calibration Coefficient K',
  '参数设置/B相电感电流偏置系数B': 'B Phase Inductance Current Bias Coefficient B',
  '参数设置/C相电感电流校准系数K': 'C Phase Inductance Current Calibration Coefficient K',
  '参数设置/C相电感电流偏置系数B': 'C Phase Inductance Current Bias Coefficient B',
  '参数设置/PV1电压校准系数K': 'PV1 Voltage Calibration Coefficient K',
  '参数设置/PV1电压校准系数B': 'PV1 Voltage Calibration Coefficient B',
  '参数设置/PV2电压校准系数K': 'PV2 Voltage Calibration Coefficient K',
  '参数设置/PV2电压校准系数B': 'PV2 Voltage Calibration Coefficient B',
  '参数设置/PV3电压校准系数K': 'PV3 Voltage Calibration Coefficient K',
  '参数设置/PV3电压校准系数B': 'PV3 Voltage Calibration Coefficient B',
  '参数设置/PV4电压校准系数K': 'PV4 Voltage Calibration Coefficient K',
  '参数设置/PV4电压校准系数B': 'PV4 Voltage Calibration Coefficient B',
  '参数设置/PV1电流校准系数K': 'PV1 Current Calibration Coefficient K',
  '参数设置/PV1电流校准系数B': 'PV1 Current Calibration Coefficient B',
  '参数设置/PV2电流校准系数K': 'PV2 Current Calibration Coefficient K',
  '参数设置/PV2电流校准系数B': 'PV2 Current Calibration Coefficient B',
  '参数设置/PV3电流校准系数K': 'PV3 Current Calibration Coefficient K',
  '参数设置/PV3电流校准系数B': 'PV3 Current Calibration Coefficient B',
  '参数设置/PV4电流校准系数K': 'PV4 Current Calibration Coefficient K',
  '参数设置/PV4电流校准系数B': 'PV4 Current Calibration Coefficient B',
  '参数设置/DCDC1电流校准系数K': 'DCDC1 Current Calibration Coefficient K',
  '参数设置/DCDC1电流校准系数B': 'DCDC1 Current Calibration Coefficient B',
  '参数设置/DCDC2电流校准系数K': 'DCDC2 Current Calibration Coefficient K',
  '参数设置/DCDC2电流校准系数B': 'DCDC2 Current Calibration Coefficient B',
  '参数设置/DCDC3电流校准系数K': 'DCDC3 Current Calibration Coefficient K',
  '参数设置/DCDC3电流校准系数B': 'DCDC3 Current Calibration Coefficient B',
  '参数设置/DCDC4电流校准系数K': 'DCDC4 Current Calibration Coefficient K',
  '参数设置/DCDC4电流校准系数B': 'DCDC4 Current Calibration Coefficient B',
  '参数设置/DCDC低压侧电压校准系数K': 'DCDC Voltage Calibration Coefficient K at Low Voltage Side',
  '参数设置/DCDC低压侧电压校准系数B': 'DCDC Voltage Calibration Coefficient B at Low Voltage Side',
  '参数设置/电池电压校准系数K': 'Battery Voltage Calibration Coefficient K',
  '参数设置/电池电压校准系数B': 'Battery Voltage Calibration Coefficient B',
  '参数设置/电池电流校准系数K': 'Battery Current Calibration Coefficient K',
  '参数设置/电池电流校准系数B': 'Battery Current Calibration Coefficient B',
  '参数设置/直流母线准校系数K': 'DC Bus Calibration Coefficient K',
  '参数设置/直流母线准校系数B': 'DC Bus Voltage Calibration Coefficient B',
  '参数设置/直流正半母线校准系数K': 'DC Positive Semi-Bus Voltage Calibration Coefficient K',
  '参数设置/直流正半母线校准系数B': 'DC Positive Semi-Bus Calibration Coefficient B',
  '参数设置/直流负半母线校准系数K': 'DC Negative Semi-Bus Calibration Coefficient K',
  '参数设置/直流负半母线校准系数B': 'DC Negative Semi-Bus Calibration Coefficient B',
  '参数设置/离网电流A相校准系数K': 'Off-Grid Current A Phase Calibration Coefficient K',
  '参数设置/离网电流A相校准系数B': 'Off-Grid Current A Phase Calibration Coefficient B',
  '参数设置/离网电流B相校准系数K': 'Off-Grid Current B Phase Calibration Coefficient K',
  '参数设置/离网电流B相校准系数B': 'Off-Grid Current B Phase Calibration Coefficient B',
  '参数设置/离网电流C相校准系数K': 'Off-Grid Current C Phase Calibration Coefficient K',
  '参数设置/离网电流C相校准系数B': 'Off-Grid Current C Phase Calibration Coefficient B',
  '参数设置/并网': 'Grid Connection',
  '参数设置/离网': 'Off-Grid',
  '参数设置/不清除': 'Not Clear',
  '参数设置/故障清除': 'Clear',
  '参数设置/不屏蔽': 'Not Shield',
  '参数设置/屏蔽': 'Shield',
  '参数设置/意大利标准': 'Italy Standard',
  '参数设置/eBlock解锁开关': 'eBlock Unlock Switch',
  '参数设置/均衡算法开关': 'Equalization Algorithm Switch',
  '参数设置/电池电压充电P1级过压': 'Battery Charge Over Voltage P1',
  '参数设置/电池电压充电P2级过压': 'Battery Charge Over Voltage P2',
  '参数设置/电池电压充电P3级过压': 'Battery Charge Over Voltage P3',
  '参数设置/电池电压充电过压截止': 'Battery Charge Over Voltage Cutoff',
  '参数设置/电池电压放电P1级欠压': 'Battery Discharge Under Voltage P1',
  '参数设置/电池电压放电P2级欠压': 'Battery Discharge Under Voltage P2',
  '参数设置/电池电压放电P3级欠压': 'Battery Discharge Under Voltage P3',
  '参数设置/电池电压放电欠压截止': 'Battery Discharge Under Voltage Cutoff',
  '参数设置/电池温度充电P1级过温': 'Battery Charge Over Temperature P1',
  '参数设置/电池温度充电P2级过温': 'Battery Charge Over Temperature P2',
  '参数设置/电池温度充电P3级过温': 'Battery Charge Over Temperature P3',
  '参数设置/电池温度充电过温截止': 'Battery Charge Over Temperature Cutoff',
  '参数设置/电池温度充电P1级欠温': 'Battery Charge Under Temperature P1',
  '参数设置/电池温度充电P2级欠温': 'Battery Charge Under Temperature P2',
  '参数设置/电池温度充电P3级欠温': 'Battery Charge Under Temperature P3',
  '参数设置/电池温度充电欠温截止': 'Battery Charge Under Temperature Cutoff',
  '参数设置/电池温度放电P1级过温': 'Battery Discharge Over Temperature P1',
  '参数设置/电池温度放电P2级过温': 'Battery Discharge Over Temperature P2',
  '参数设置/电池温度放电P3级过温': 'Battery Discharge Over Temperature P3',
  '参数设置/电池温度放电过温截止': 'Battery Discharge Over Temperature Cutoff',
  '参数设置/电池温度放电P1级欠温': 'Battery Discharge Under Temperature P1',
  '参数设置/电池温度放电P2级欠温': 'Battery Discharge Under Temperature P2',
  '参数设置/电池温度放电P3级欠温': 'Battery Discharge Under Temperature P3',
  '参数设置/电池温度放电欠温截止': 'Battery Discharge Under Temperature Cutoff',
  '参数设置/电池总压1级过压': 'Battery Total Over Voltage P1',
  '参数设置/电池总压2级过压': 'Battery Total Over Voltage P2',
  '参数设置/电池总压3级过压': 'Battery Total Over Voltage P3',
  '参数设置/电池总压过压截止': 'Battery Total Over Voltage Cutoff',
  '参数设置/电池总压1级欠压': 'Battery Total Under Voltage P1',
  '参数设置/电池总压2级欠压': 'Battery Total Under Voltage P2',
  '参数设置/电池总压3级欠压': 'Battery Total Under Voltage P3',
  '参数设置/电池总压欠压截止': 'Battery Total Under Voltage Cutoff',
  '参数设置/电池电流充电P1级过流': 'Cell Charge Over Current P1',
  '参数设置/电池电流充电P2级过流': 'Cell Charge Over Current P2',
  '参数设置/电池电流充电P3级过流': 'Cell Charge Over Current P3',
  '参数设置/电池电流充电过流截止': 'Cell Charge Over Current Cutoff',
  '参数设置/电池电流放电P1级过流': 'Cell Discharge Over Current P1',
  '参数设置/电池电流放电P2级过流': 'Cell Discharge Over Current P2',
  '参数设置/电池电流放电P3级过流': 'Cell Discharge Over Current P3',
  '参数设置/电池电流放电过流截止': 'Cell Discharge Over Current Cutoff',
  '参数设置/电池电压充电P1级极差': 'Battery Charge Voltage Difference P1',
  '参数设置/电池电压充电P2级极差': 'Battery Charge Voltage Difference P2',
  '参数设置/电池电压充电P3级极差': 'Battery Charge Voltage Difference P3',
  '参数设置/电池电压充电极差截止': 'Battery Charge Voltage Difference Cutoff',
  '参数设置/电池电压放电P1级极差': 'Battery Discharge Voltage Difference P1',
  '参数设置/电池电压放电P2级极差': 'Battery Discharge Voltage Difference P2',
  '参数设置/电池电压放电P3级极差': 'Battery Discharge Voltage Difference P3',
  '参数设置/电池电压放电极差截止': 'Battery Discharge Voltage Difference Cutoff',
  '参数设置/电池温度充电P1级极差': 'Battery Charge Temperature Difference P1',
  '参数设置/电池温度充电P2级极差': 'Battery Charge Temperature Difference P2',
  '参数设置/电池温度充电P3级极差': 'Battery Charge Temperature Difference P3',
  '参数设置/电池温度充电极差截止': 'Battery Charge Temperature Difference Cutoff',
  '参数设置/电池温度放电P1级极差': 'Battery Discharge Temperature Difference P1',
  '参数设置/电池温度放电P2级极差': 'Battery Discharge Temperature Difference P2',
  '参数设置/电池温度放电P3级极差': 'Battery Discharge Temperature Difference P3',
  '参数设置/电池温度放电极差截止': 'Battery Discharge Temperature Difference Cutoff',
  '参数设置/被动均衡模式': 'Passive Equalization Mode',
  '参数设置/电压过欠压解锁开关': 'Over-Under Voltage Unlock Switch',
  '参数设置/电气火灾解锁开关': 'Electrical Fire Unlock Switch',
  '参数设置/手动均衡电压': 'Manual Equalization Voltage',
  '参数设置/自动模式': 'Automatic Mode',
  '参数设置/手动模式': 'Manual Mode',
  '参数设置/无效': 'Ineffective',
  '参数设置/解锁': 'Unlock',
  '参数设置/开启电压平均值均衡': 'Start Average Voltage Equalization Algorithm',
  '参数设置/开启电量均衡算法': 'Start Energy Equalization Algorithm',
  '参数设置/关闭均衡算法': 'Close Equalization Algorithm',
  '参数设置/确定': 'Confirm',
  '参数设置/取消': 'Cancel',
  '参数设置/新增策略': 'Add Strategy',
  '参数设置/编辑策略': 'Edit Strategy',
  '参数设置/编辑': 'Edit',
  '参数设置/删除': 'Delete',
  '参数设置/策略删除成功': 'Strategy Delete Success',
  '参数设置/最后一条策略的结束时间已经为23:59，不能再新增策略': 'The end time of the last strategy is 23:59, and no new strategy can be added',
  '参数设置/设置成功': 'Set Success',
  '参数设置/设置失败': 'Set Failed',
  '参数设置/正在设置，请稍等...': 'Setting, please wait...',
  '参数设置/单个设备设置后，同一个组内的其他设备会自动同步设置': 'After setting a single device, the other devices in the same group will automatically synchronize the setting',
  '参数设置/读取成功': 'Read Success',

  '参数设置/协议帧格式有误': 'Protocol Frame Format Error',
  '参数设置/的dev_id不存在': 'The dev_id does not exist',
  '参数设置/确定下发?': 'Confirm Send?',
  '参数设置/系统提示': 'System Prompt',
  '参数设置/设置箱变容量配比': 'Set Transformer Capacity Ratio',
  '参数设置/eBlock启停': 'eBlock Start-Stop',
  '参数设置/操作成功': 'Operation Success',
  '参数设置/能量链': 'eLink',
  '参数设置/正在读取，请稍等...': 'Reading, please wait...',
  '参数设置/读取失败': 'Read Failed',
  '参数设置/是否更新缓存': 'Update Cache?',
  '参数设置/请输入功率': 'Please Input Power',
  '参数设置/请选择开始时间': 'Please Select Start Time',
  '参数设置/请选择结束时间': 'Please Select End Time',  
  '参数设置/BMU控制参数': 'BMU Control Parameters',
  '参数设置/请设置参数值': 'Please Set Parameter Value',
  '参数设置/操作者': 'Operator',


  /* 空调运行参数设定 */
  '空调运行参数设定/历史记录': 'History Record',
  '空调运行参数设定/空调参数': 'Air Conditioner Parameters',
  '空调运行参数设定/设置结果': 'Setting Result',
  '空调运行参数设定/未同步': 'Unsynchronized',
  '空调运行参数设定/同步': 'Synchronized',
  '空调运行参数设定/上报时间': 'Report Date',
  '空调运行参数设定/查看上报数据': 'View Report Data',
  '空调运行参数设定/当前数据': 'Current Data',
  '空调运行参数设定/设置': 'Set',
  '空调运行参数设定/无上报数据': 'No Report Data',
  '空调运行参数设定/删除': 'Delete',
  '空调运行参数设定/新增': 'New',
  '空调运行参数设定/取消': 'Cancel',
  '空调运行参数设定/确定': 'Confirm',
  '空调运行参数设定/空调参数设置历史': 'Air Conditioner Paramters Setting History',
  '空调运行参数设定/eBlock空调参数': 'eBlock Air Conditioner Parameters',
  '空调运行参数设定/eLink空调参数': 'eLink Air Conditioner Parameters',
  '空调运行参数设定/开始时间': 'Start Time',
  '空调运行参数设定/结束时间': 'End Time',
  '空调运行参数设定/起始工作功率': 'Start Power',
  '空调运行参数设定/结束工作功率': 'End Power',
  '空调运行参数设定/制冷开始温度': 'Cool Start Temperature',
  '空调运行参数设定/制冷结束温度': 'Cool End Temperature',
  '空调运行参数设定/制热开始温度': 'Heat Start Temperature',
  '空调运行参数设定/制热结束温度': 'Heat End Temperature',
  '空调运行参数设定/操作时间': 'Operation Time',
  '空调运行参数设定/操作者': 'Operator',
  '空调运行参数设定/关闭': 'Close',
  '空调运行参数设定/上报数据': 'Report Data',
  '空调运行参数设定/eBlock空调': 'eBlock Air Conditioner',
  '空调运行参数设定/eLink空调': 'eLink Air Conditioner',
  '空调运行参数设定/删除最后一行': 'Delete Last Row',
  '空调运行参数设定/新增一行': 'Add New Row',
  '空调运行参数设定/空调参数设置': 'Air Conditioner Parameters Setting',
  '空调运行参数设定/时间区间未覆盖0-24h': 'Time Interval Not Cover 0-24h',
  '空调运行参数设定/结束时间已经是23:59, 请修改结束时间后再添加': 'The end time is 23:59, please modify the end time and then add',
  '空调运行参数设定/最后一条不允许删除': 'The last row cannot be deleted',



  /* 故障录波 */
  '故障录波/故障录波': 'Fault Recorder',
  '故障录波/全部': 'Total',
  '故障录波/搜索': 'Search',
  '故障录波/输入文件名搜索': 'Input File Name to Search',
  '故障录波/重置': 'Reset',
  '故障录波/文件名': 'File Name',
  '故障录波/文件大小': 'File Size',
  '故障录波/上传时间': 'Upload Time',
  '故障录波/操作': 'Operation',
  '故障录波/暂无数据': 'No Data',
  '故障录波/名称': 'Name',
  '故障录波/下载': 'Download',

  /*  功率跟踪  */
  '功率跟踪/时间': 'Time',
  '功率跟踪/至': 'To',
  '功率跟踪/能量链': 'eLink',
  '功率跟踪/能量块': 'eBlock',
  '功率跟踪/全部': 'Total',
  '功率跟踪/查询': 'Search',
  '功率跟踪/重置': 'Reset',
  '功率跟踪/变压器容量': 'Transformer Capacity',
  '功率跟踪/2号': '2#',
  '功率跟踪/储能单元SOC-功率跟踪分析曲线': 'Energy Storage Unit SOC - Power Tracking Analysis Curve',
  '功率跟踪/功率': 'Power',
  '功率跟踪/策略': 'Strategy',
  '功率跟踪/最大需量': 'Max Demand',
  '功率跟踪/数据间隔': 'Data Interval',
  '功率跟踪/分钟': 'Minute',
  '功率跟踪/小时': 'Hour',
  '功率跟踪/天': 'Day',
  '功率跟踪/月': 'Month',
  '功率跟踪/选择时间': 'Select Date',
  '功率跟踪/选择设备': 'Select Equipment',
  '功率跟踪/全部': 'Total',
  '功率跟踪/选择类型': 'Select Type',
  '功率跟踪/SOC-功率曲线': 'SOC-Power Curve',
  '功率跟踪/电能来源曲线': 'Energy Source Curve',
  '功率跟踪/充放电数据': 'Charge-Discharge Data',
  '功率跟踪/负载曲线': 'Load Curve',
  '功率跟踪/电池功率': 'Battery Power',
  '功率跟踪/PV功率': 'PV Power',
  '功率跟踪/电网': 'Grid',
  '功率跟踪/光伏': 'PV',
  '功率跟踪/重要负载': 'Important Load',
  '功率跟踪/非重要负载': 'Unimportant Load',


  /* 负荷跟踪 */
  '负荷跟踪/负荷跟踪': 'Load Tracking',
  '负荷跟踪/时间': 'Date',
  '负荷跟踪/刷新': 'Refresh',
  '负荷跟踪/导出': 'Download',
  '负荷跟踪/功率': 'Power',
  '负荷跟踪/全选': 'Select All',
  '负荷跟踪/收起': 'Unfold',
  '负荷跟踪/展开': 'Fold',
  '负荷跟踪/实体电表': 'Entity Meter',
  '负荷跟踪/虚拟电表': 'Virtual Meter',
  '负荷跟踪/暂无': 'No Data',
  '负荷跟踪/填加虚拟电表': 'New Virtual Meter',
  '负荷跟踪/虚拟电表名称': 'Virtual Meter Name',
  '负荷跟踪/请输入虚拟电表名称': 'Please Input  Virtual Meter Name',
  '负荷跟踪/虚拟电表取值': 'Virtual Meter Value',
  '负荷跟踪/请选择电表': 'Please Select Meter',
  '负荷跟踪/加': 'Add',
  '负荷跟踪/减': 'Subtract',
  '负荷跟踪/取消': 'Cancel',
  '负荷跟踪/确定': 'Confirm',
  '负荷跟踪/时间范围超过31天，请重新选择': 'The time range exceeds 31 days, please select again',

  '负荷跟踪/母线': 'Bus',
  '负荷跟踪/负载': 'Load',
  '负荷跟踪/光伏': 'PV',
  '负荷跟踪/储能系统': 'Energy Storage System',
  '负荷跟踪/充电桩': 'Charging Station',
  '负荷跟踪/变压器': 'Transformer',
  '负荷跟踪/总需量': 'Total Demand',

  '负荷跟踪/删除提示': (s) => `Are you sure you want to delete ${s}?`,
  '负荷跟踪/删除成功': 'Delete Success',
  '负荷跟踪/添加成功': 'Add Success',
  '负荷跟踪/更新成功': 'Update Success',
  '负荷跟踪/运行需量曲线': 'Running Demand Curve',

  '负荷跟踪/并网点功率': 'Grid-Connected Meter Power',
  '负荷跟踪/关口表功率': 'PCC Meter Power',
  '负荷跟踪/负载功率': 'Load Power',
  '负荷跟踪/需量': 'Demand',
  '负荷跟踪/全部': 'All',
  '负荷跟踪/查询': 'Search',
  '负荷跟踪/重置': 'Reset',




  /* 充放电记录 */
  '充放电记录/时间': 'Time',
  '充放电记录/至': 'To',
  '充放电记录/能量链': 'eLink',
  '充放电记录/查询': 'Search',
  '充放电记录/导出': 'Download',
  '充放电记录/重置': 'Reset',
  '充放电记录/充放电记录': 'Charge-Discharge Record',
  '充放电记录/设备名称': 'Equipment Name',
  '充放电记录/充放电类型': 'Charge-Discharge Type',
  '充放电记录/平均功率': 'Average Power',
  '充放电记录/累计电能': 'Accumulated Energy',
  '充放电记录/起始时间': 'Start Time',
  '充放电记录/结束时间': 'End Time',
  '充放电记录/起始soc': 'Start SOC',
  '充放电记录/结束soc': 'End SOC',
  '充放电记录/起始电表读数': 'Initial Meter Reading',
  '充放电记录/结束电表读数': 'Final Meter Reading',
  '充放电记录/充电': 'Charge',
  '充放电记录/放电': 'Discharge',
  '充放电记录/充放电时长': 'Charge-Discharge Duration',
  '充放电记录/能量块': 'eBlock',
  '充放电记录/开始日期': 'Start Date',
  '充放电记录/结束日期': 'End Date',
  '充放电记录/请选择能量链': 'Please Select eLink',
  '充放电记录/请选择能量块': 'Please Select eBlock',
  '充放电记录/加载中...': 'Loading...',
  '充放电记录/正在导出...': 'Downloading...',
  '充放电记录/导出成功': 'Download Success',
  '充放电记录/请选择时间': 'Please Select Time',
  '充放电记录/请选择设备': 'Please Select Equipment',
  '充放电记录/请选择类型': 'Please Select Type',
  '充放电记录/全部': 'All',



  /* 满充容量统计 */
  '满充容量统计/请选择月份': 'Please Select Month',
  '满充容量统计/查询': 'Search',
  '满充容量统计/重置': 'Reset',
  '满充容量统计/满充容量统计': 'Fully Charge Capacity Statistics',
  '满充容量统计/日期': 'Date',


  /* 需量分析 */
  '需量分析/时间': 'Date',
  '需量分析/查询': 'Search',
  '需量分析/重置': 'Reset',
  '需量分析/需量跟踪曲线': 'Demand Tracking Curve',
  '需量分析/需量': 'Demand',
  '需量分析/实际需量': 'Actual Demand',
  '需量分析/负荷需量': 'Load Demand',
  '需量分析/储能需量': 'Energy Storage Demand',
  '需量分析/暂无数据': 'No Data',
  '需量分析/加载中': 'Loading',
  '需量分析/最大值': 'Max',

  /* 电压数据分析 */
  '电压数据分析/电芯电压变化趋势': 'Cell Voltage  Variation Trend',
  '电压数据分析/单体电芯健康度量化分析': 'Cell State Of Health Quantitative Analysis',
  '电压数据分析/电芯单日电压变化': 'Cell Voltage Variation Daily',
  '电压数据分析/时间': 'Date',
  '电压数据分析/查询': 'Search',
  '电压数据分析/重置': 'Reset',
  '电压数据分析/标准差': 'Standard Deviation',
  '电压数据分析/标准差单日值': 'Daily Standard Deviation',
  '电压数据分析/电压': 'Voltage',
  '电压数据分析/电压累计差': 'Voltage Accumulated Difference',
  '电压数据分析/电芯位置': 'Cell Index',
  '电压数据分析/请选择Pack': 'Please Select Pack',
  '电压数据分析/请选择能量块': 'Please Select eBlock',
  '电压数据分析/请选择能量链': 'Please Select eLink',
  '电压数据分析/开始日期': 'Start Date',
  '电压数据分析/结束日期': 'End Date',
  '电压数据分析/请选择时间': 'Please Select Time',
  '电压数据分析/请选择设备': 'Please Select Equipment',
  '电压数据分析/至': 'To',
  '电压数据分析/能量块': 'eBlock',
  '电压数据分析/能量链': 'eLink',
  '电压数据分析/最大值': 'Max',
  '电压数据分析/电芯电压': 'Cell Voltage',
  '电压数据分析/电芯编号': 'Cell Index',
  '电压数据分析/请选择电芯': 'Please Select Cell',

  /* 电压一致性 */
  '电压一致性/电压一致性': 'Voltage Consistency',
  '电压一致性/压差': 'Voltage Difference',
  '电压一致性/压差对比': 'Voltage Difference Comparison',
  '电压一致性/电芯电压对比': 'Cell Voltage Comparison',
  '电压一致性/方阵三相电压对比': 'Matrix Three Phase Voltage Comparison',
  '电压一致性/时间': 'Date',
  '电压一致性/至': 'To',
  '电压一致性/能量链': 'eLink',
  '电压一致性/能量块': 'eBlock',
  '电压一致性/请选择能量链': 'Please Select eLink',
  '电压一致性/请选择能量块': 'Please Select eBlock',
  '电压一致性/开始日期': 'Start Date',
  '电压一致性/结束日期': 'End Date',
  '电压一致性/全部': 'All',
  '电压一致性/查询': 'Search',
  '电压一致性/重置': 'Reset',
  '电压一致性/电压': 'Voltage',
  '电压一致性/最高电压': 'Highest Voltage',
  '电压一致性/最低电压': 'Lowest Voltage',
  '电压一致性/电芯电压标准差': 'Cell Voltage Standard Deviation',
  '电压一致性/最大压差': 'Highest Voltage Difference',
  '电压一致性/正常电压范围': 'Normal Voltage Range',
  '电压一致性/最大值': 'Max Value',
  '电压一致性/最大值电芯': 'Max Value Cell Index',
  '电压一致性/AB线电压': 'AB Line Voltage',
  '电压一致性/BC线电压': 'BC Line Voltage',
  '电压一致性/CA线电压': 'CA Line Voltage',
  '电压一致性/暂无数据': `No Data`,
  '电压一致性/最小值电芯': 'Min Value Cell Index',
  '电压一致性/最小值': 'Min Value',
  '电压一致性/时间': 'Date',

  /* 热管理分析 */
  '热管理分析/热管理分析': 'Thermal Management Analysis',
  '热管理分析/Pack 电芯温度变化趋势': 'Pack Cell Temperature Variation Trend',
  '热管理分析/PCS 温度变化趋势': 'PCS Temperature Variation Trend',
  '热管理分析/电芯温度变化趋势': 'Cell Temperature Variation Trend',
  '热管理分析/母排温度正负极历史曲线': 'Bus Temperature Positive and Negative History Curve',
  '热管理分析/时间': 'Date',
  '热管理分析/至': 'To',
  '热管理分析/能量链': 'eLink',
  '热管理分析/能量块': 'eBlock',
  '热管理分析/请选择能量链': 'Please Select eLink',
  '热管理分析/请选择能量块': 'Please Select eBlock',
  '热管理分析/开始日期': 'Start Date',
  '热管理分析/结束日期': 'End Date',
  '热管理分析/全部': 'All',
  '热管理分析/查询': 'Search',
  '热管理分析/重置': 'Reset',
  '热管理分析/电芯最高温度': 'Cell Highest Temperature',
  '热管理分析/电芯最低温度': 'Cell Lowest Temperature',
  '热管理分析/柜体温度': 'Cabinet Temperature',
  '热管理分析/电芯温度标准差': 'Cell Temperature Standard Deviation',
  '热管理分析/电芯温度25℃标准差': `Cell Temperature Standard Deviation(mean=25℃)`,
  '热管理分析/PCS直流侧功率': 'PCS Direct Current Power',
  '热管理分析/柜体湿度': 'Cabinet Humidity',
  '热管理分析/空调状态': 'Air Conditioner State',
  '热管理分析/制冷': 'Refrigerate',
  '热管理分析/制热': 'Heat',
  '热管理分析/故障': 'Fault',
  '热管理分析/除湿': 'Dehumidification',
  '热管理分析/自循环': 'Self-Cycle',
  '热管理分析/温度': 'Temperature',
  '热管理分析/温度标准差': 'Temperature Standard Deviation',
  '热管理分析/功率': 'Power',
  '热管理分析/湿度': 'Humidity',
  '热管理分析/曲线选择': 'Select Curve Type',
  '热管理分析/最高': 'Highest Temperature',
  '热管理分析/最低': 'Lowest Temperature',
  '热管理分析/PCS机箱温度': 'PCS Chassis Temperature',
  '热管理分析/A相IGBT温度': 'A Phase IGBT Temperature',
  '热管理分析/B相IGBT温度': 'B Phase IGBT Temperature',
  '热管理分析/C相IGBT温度': 'C Phase IGBT Temperature',
  '热管理分析/最大值': 'Highest Cell Temperature',
  '热管理分析/最大值电芯': 'Highest Cell Temperature Index',
  '热管理分析/最小值': 'Lowest Cell Temperature',
  '热管理分析/最小值电芯': 'Lowest Cell Temperature Index',
  '热管理分析/正极': 'Positive',
  '热管理分析/负极': 'Negative',
  '热管理分析/正极温度': 'Positive Temperature',
  '热管理分析/负极温度': 'Negative Temperature',
  '热管理分析/A相IGBT温度1': 'A Phase IGBT Temperature 1',
  '热管理分析/B相IGBT温度1': 'B Phase IGBT Temperature 1',
  '热管理分析/C相IGBT温度1': 'C Phase IGBT Temperature 1',
  '热管理分析/A相IGBT温度2': 'A Phase IGBT Temperature 2',
  '热管理分析/B相IGBT温度2': 'B Phase IGBT Temperature 2',
  '热管理分析/C相IGBT温度2': 'C Phase IGBT Temperature 2',
  '热管理分析/日期范围过大，请选择范围为一天之内的日期': 'Date Range Too Large, Please Select a Date Range of One Day',
  '热管理分析/暂无数据': 'No Data',



  /* 储能分析 */
  '储能分析/充放电效率统计': 'Charge-Discharge Efficiency Statistics',
  '储能分析/系统效率': 'System Efficiency',
  '储能分析/能量链': 'eLink',
  '储能分析/能量块': 'eBlock',
  '储能分析/查询': 'Search',
  '储能分析/重置': 'Reset',
  '储能分析/总充电效率': 'Total Charge Efficiency',
  '储能分析/总放电效率': 'Total Discharge Efficiency',
  '储能分析/总充放效率': 'Total Charge-Discharge Efficiency',
  '储能分析/选择时间': 'Select Time',
  '储能分析/充电效率': 'Charge Efficiency',
  '储能分析/放电效率': 'Discharge Efficiency',
  '储能分析/效率': 'Efficiency',
  '储能分析/暂无数据': 'No Data',
  '储能分析/加载中': 'Loading',
  '储能分析/充放电日期': 'Charge-Discharge Date',
  '储能分析/电量': 'Electricity',
  '储能分析/充电量': 'Charge',
  '储能分析/放电量': 'Discharge',
  '储能分析/时间': 'Date',


  /* 电能质量 */
  '电能质量/三相平衡曲线': 'Three Phase Equalization Curve',
  '电能质量/方阵': 'Matrix',
  '电能质量/查询': 'Search',
  '电能质量/重置': 'Reset',
  '电能质量/关口三相不平衡度': 'PCC Three Phase Unequalizaiton Curve',
  '电能质量/负载三相不平衡度': 'Load Three PhaseUnequalization Curve',
  '电能质量/不平衡度': 'Unequalization Degree',
  '电能质量/三相不平衡度': 'Three Phase Unequalization Degree',
  '电能质量/并网点有功功率': 'GCP Active Power',
  '电能质量/关口点有功功率': 'PCC Active Power',
  '电能质量/负载有功功率': 'Load Active Power',
  '电能质量/系统无功-电压曲线': 'System Reactive Power-Voltage Curve',
  '电能质量/关口电表AB线电压': 'PCC Meter AB Line Voltage',
  '电能质量/关口电表BC线电压': 'PCC Meter BC Line Voltage',
  '电能质量/关口电表CA线电压': 'PCC Meter CA Line Voltage',
  '电能质量/并网电表A相无功功率': 'GCP Meter A Phase Reactive Power',
  '电能质量/并网电表B相无功功率': 'GCP Meter B Phase Reactive Power',
  '电能质量/并网电表C相无功功率': 'GCP Meter C Phase Reactive Power',
  '电能质量/请选择储能方阵': 'Please Select Energy Storage Matrix',
  '电能质量/请选择电站单元': 'Please Select Station Unit',
  '电能质量/A相': 'A Phase',
  '电能质量/B相': 'B Phase',
  '电能质量/C相': 'C Phase',
  '电能质量/月': 'Month',
  '电能质量/日': 'Day',
  '电能质量/电压': 'Voltage',
  '电能质量/无功功率': 'Reactive Power',
  '电能质量/功率': 'Power',
  '电能质量/相': 'Phase',

  /* 电价趋势 */
  '电价趋势/时间': 'Date',
  '电价趋势/查询': 'Search',
  '电价趋势/重置': 'Reset',
  '电价趋势/电价': 'Tariff',
  '电价趋势/分时电价': 'Time-of-Use Price',
  '电价趋势/现货交易电价': 'Spot Transaction Price',


  /* 电表数据分析 */
  '电表数据分析/查询': 'Search',
  '电表数据分析/重置': 'Reset',
  '电表数据分析/电表数据分析': 'Meter Data Analysis',
  '电表数据分析/有功功率': 'Active Power',
  '电表数据分析/无功功率': 'Reactive Power',
  '电表数据分析/功率因数': 'Power Factor',
  '电表数据分析/功率': 'Power',

  /* 充电电量汇总 */
  '充电电量汇总/请选择月份': 'Please Select Month',
  '充电电量汇总/查询': 'Search',
  '充电电量汇总/重置': 'Reset',
  '充电电量汇总/充电电量汇总': 'Charge Energy Summary',
  '充电电量汇总/日期': 'Date',
  '充电电量汇总/充电时间': 'Charge Time',
  '充电电量汇总/充电量': 'Charge Energy',
  '充电电量汇总/末端SOC': 'Terminal SOC',

  /* 设备管理 */
  '设备管理/添加电站单元': 'New Station Unit',
  '设备管理/编辑电站单元': 'Edit Station Unit',
  '设备管理/电站单元': 'Station Unit',
  '设备管理/变压器容量': 'Transformer Capacity',
  '设备管理/请输入电站单元名称': 'Please Input Station Unit Name',
  '设备管理/请输入变压器容量': 'Please Input Transformer Capacity',
  '设备管理/取消': 'Cancel',
  '设备管理/确定': 'Confirm',
  '设备管理/电站单元': 'Station Unit',
  '设备管理/搜索': 'Search',
  '设备管理/重置': 'Reset',
  '设备管理/新增': 'New',
  '设备管理/批量删除': 'Batch Delete',
  '设备管理/电表名称': 'Meter Name',
  '设备管理/电表类型': 'Meter Type',
  '设备管理/操作': 'Operation',
  '设备管理/暂无数据': 'No Data',
  '设备管理/能量链名称': 'eLink Name',
  '设备管理/产品型号': 'Product Model',
  '设备管理/能量块名称': 'eBlock Name',
  '设备管理/额定功率': 'Rated Power',
  '设备管理/容量': 'Capacity',
  '设备管理/删除后将丢失电站单元和设备的关系，你确定删除吗?': 'Delete will lose the relationship between the station unit and the equipment, are you sure you want to delete?',
  '设备管理/提示': 'Tips',
  '设备管理/删除成功': 'Delete Success',
  '设备管理/操作成功': 'Operation Success',
  '设备管理/删除': 'Delete',
  '设备管理/编辑': 'Edit',
  '设备管理/新增/编辑电表': 'New/Edit Meter',
  '设备管理/请输入uuid': 'Please Input UUID',
  '设备管理/请输入电表名称': 'Please Input Meter Name',
  '设备管理/请输入电表类型': 'Please Input Meter Type',
  '设备管理/请先选择要删除的项目': 'Please Select the Item to Delete',
  '设备管理/确定要删除这些电表吗？': 'Are You Sure You Want to Delete These Meters?',
  '设备管理/删除选中的电表后，这些电表的信息将不可恢复': 'Deleting the Selected Meters Will Make Their Information Irreversible',
  '设备管理/新增成功': 'New Success',
  '设备管理/更新成功': 'Update Success',
  '设备管理/电表类型不正确': 'Meter Type Incorrect',
  '设备管理/删除该电表后，该电表的信息将不可恢复': 'Deleting the Meter Will Make Its Information Irreversible',
  '设备管理/确定要删除该电表吗？': 'Are You Sure You Want to Delete This Meter?',
  '设备管理/关口电表': 'PCC Meter',
  '设备管理/计量电表': 'Meter',
  '设备管理/并网点电表': 'GCP Meter',
  '设备管理/备注': 'Remark',
  '设备管理/参数名称不能为空': 'Parameter Name Cannot Be Empty',
  '设备管理/参数键名不能为空': 'Parameter Key Name Cannot Be Empty',
  '设备管理/参数键值不能为空': 'Parameter Key Value Cannot Be Empty',
  '设备管理/删除该能量链后，该能量链信息将不可恢复': 'Deleting the eLink Will Make Its Information Irreversible',
  '设备管理/确定要删除该能量链吗？': 'Are You Sure You Want to Delete This eLink?',
  '设备管理/删除成功': 'Delete Success',
  '设备管理/请先选择要删除的项目': 'Please Select the Item to Delete',
  '设备管理/删除选中的能量链后，这些能量链信息将不可恢复': 'Deleting the Selected eLinks Will Make Their Information Irreversible',
  '设备管理/确定要删除这些能量链吗？': 'Are You Sure You Want to Delete These eLinks?',
  '设备管理/新增/编辑能量链': 'New/Edit eLink',
  '设备管理/关联电表': 'Associated Meter',
  '设备管理/请输入能量链名称': 'Please Input eLink Name',
  '设备管理/修改成功': 'Modify Success',
  '设备管理/删除该能量块后，该能量块信息将不可恢复': 'Deleting the eBlock Will Make Its Information Irreversible',
  '设备管理/确定要删除该能量块吗？': 'Are You Sure You Want to Delete This eBlock?',
  '设备管理/删除成功': 'Delete Success',
  '设备管理/请先选择要删除的项目': 'Please Select the Item to Delete',
  '设备管理/删除选中的能量块后，这些能量块信息将不可恢复': 'Deleting the Selected eBlocks Will Make Their Information Irreversible',
  '设备管理/确定要删除这些能量块吗？': 'Are You Sure You Want to Delete These eBlocks?',
  '设备管理/新增/编辑能量块': 'New/Edit eBlock',
  '设备管理/容量': 'Capacity',
  '设备管理/装机功率': 'Rated Power',
  '设备管理/请输入能量块名称': 'Please Input eBlock Name',
  '设备管理/请输入能量块型号': 'Please Input eBlock Model',
  '设备管理/请输入能量块容量': 'Please Input eBlock Capacity',
  '设备管理/请输入能量块额定功率': 'Please Input eBlock Rated Power',
  '设备管理/请输入能量块额定容量': 'Please Input eBlock Rated Capacity',
  '设备管理/请输入能量块额定电压': 'Please Input eBlock Rated Voltage',
  '设备管理/设备名称': 'Equipment Name',
  '设备管理/设备型号': 'Equipment Model',
  '设备管理/光伏名称': 'Photovoltaic Name',
  '设备管理/厂家名称': 'Factory Name',
  '设备管理/产品型号': 'Product Model',
  '设备管理/关联设备ID': 'Associated Equipment ID',
  '设备管理/设备SN': 'Equipment SN',
  '设备管理/备注': 'Remark',
  '设备管理/确定要删除该光伏吗？': 'Are You Sure You Want to Delete This Photovoltaic?',
  '设备管理/确定要删除这些光伏吗？': 'Are You Sure You Want to Delete These Photovoltaics?',
  '设备管理/删除选中的光伏后，这些光伏信息将不可恢复': 'Deleting the Selected Photovoltaics Will Make Their Information Irreversible',
  '设备管理/添加成功!': 'Add Success!',
  '设备管理/更新成功!': 'Update Success!',
  '设备管理/删除成功!': 'Delete Success!',
  '设备管理/请先选择要删除的项目': 'Please Select the Item to Delete',
  '设备管理/新增/编辑光伏': 'New/Edit Photovoltaic',
  '设备管理/请输入光伏名称': 'Please Input Photovoltaic Name',
  '设备管理/请输入厂家名称': 'Please Input Factory Name',
  '设备管理/请输入产品型号': 'Please Input Product Model',
  '设备管理/请输入关联设备ID': 'Please Input Associated Equipment ID',
  '设备管理/请输入设备SN': 'Please Input Equipment SN',
  '设备管理/请输入备注': 'Please Input Remark',
  '设备管理/请输入UUID': 'Please Input UUID',
  '设备管理/删除该光伏后，该光伏信息将不可恢复': 'Deleting the Photovoltaic Will Make Its Information Irreversible',


  /* 设备型号 */
  '设备型号/型号名称': 'Model Name',
  '设备型号/设备类型': 'Equipment Model',
  '设备型号/请输入型号名称': 'Please Input Model Name',
  '设备型号/搜索': 'Search',
  '设备型号/重置': 'Reset',
  '设备型号/隐藏搜索': 'Hide Search',
  '设备型号/刷新': 'Refresh',
  '设备型号/型号编号': 'Model Code',
  '设备型号/PACK数量': 'PACK Number',
  '设备型号/电芯总数': 'Cell Number',
  '设备型号/型号版本': 'Model Version',
  '设备型号/额定功率': 'Rated Power',
  '设备型号/设计容量': 'Capacity',
  '设备型号/操作': 'Operation',
  '设备型号/请输入型号编号': 'Please Input Model Code',
  '设备型号/请输入PACK数量': 'Please Input PACK Number',
  '设备型号/请输入电芯总数': 'Please Input Cell Number',
  '设备型号/请输入型号版本': 'Please Input Model Version',
  '设备型号/请输入额定功率': 'Please Input Rated Power',
  '设备型号/请输入设计容量': 'Please Input Capacity',
  '设备型号/请输入额定电压': 'Please Input Rated Voltage',
  '设备型号/添加设备型号基本信息': 'Add Model Basic Information',
  '设备型号/修改设备型号基本信息': 'Modify Model Basic Information',
  '设备型号/修改成功': 'Modify Success',
  '设备型号/新增成功': 'New Success',
  '设备型号/删除成功': 'Delete Success',
  '设备型号/警告': 'Warning',
  '设备型号/是否确认删除型号': 'Are You Sure You Want to Delete Model',
  '设备型号/PACK数量必须是整数': 'PACK Number Must Be an Integer',
  '设备型号/电芯数量必须是整数': 'Cell Number Must Be an Integer',
  '设备型号/删除提示': (names) => `Are You Sure You Want to Delete Model [${names}]?`,
  '设备型号/确定': 'Confirm',
  '设备型号/取消': 'Cancel',
  '设备型号/新增': 'New',
  '设备型号/修改': 'Edit',
  '设备型号/删除': 'Delete',
  '设备型号/能量块': 'eBlock',
  '设备型号/能量链': 'eLink',
  '设备型号/电表': 'Meter',
  '设备型号/设备品牌': 'Equipment Brand',
  '设备型号/光伏': 'Photovoltaic',
  '设备型号/充电桩': 'Charging Pile',


  /* 电站管理 */
  '电站管理/筛选': `Filter`,
  '电站管理/电站名称': `Station Name`,
  '电站管理/输入电站名称进行搜索': `Input Station Name to Search`,
  '电站管理/电站ID': `Station ID `,
  '电站管理/请输入电站ID': `Input Station ID `,
  '电站管理/全部': `Total`,
  '电站管理/投资方': `Investor`,
  '电站管理/业主方': `Owner`,
  '电站管理/渠道方': `Channel Party`,
  '电站管理/请输入投资方单位名称': `Input Investor Unit Name`,
  '电站管理/请输入业主方单位名称': `Input Owner  Unit Name`,
  '电站管理/请输入渠道方单位名称（选填）': `Input Channel Party (Optional)`,
  '电站管理/电站状态': `State`,
  '电站管理/未投运': `NC`,
  '电站管理/已投运': `Running`,
  '电站管理/暂停运营': `Suspending`,
  '电站管理/项目编码': `Project Code`,
  '电站管理/请输入项目编码': `Input Project Code`,
  '电站管理/搜索': `Search`,
  '电站管理/重置': `Reset`,
  '电站管理/新增电站': `New Station`,
  '电站管理/批量删除': `Batch Delete`,
  '电站管理/导出电站效率': `Download Station Efficiency`,
  '电站管理/导出电站': `Download Station List`,
  '电站管理/所属城市': `City`,
  '电站管理/电表模式': `Meter Mode`,
  '电站管理/实体': `Entity`,
  '电站管理/虚拟': `Virtual`,
  '电站管理/策略控制': `Strategy Control`,
  '电站管理/投运日期': `Operation Date`,
  '电站管理/额定功率/装机容量': `Rated Power/Installed Capacity`,
  '电站管理/eLink数量': `eLink Number`,
  '电站管理/eBlock数量': `eBlock Number`,
  '电站管理/eBlock型号': `eBlock Model`,
  '电站管理/创建日期': `Create Date`,
  '电站管理/操作': `Operation`,
  '电站管理/基本参数': `Parameters`,
  '电站管理/电站设备': `Equipment`,
  '电站管理/电站拓扑': `Topology`,
  '电站管理/维护记录': `Maintenance Record`,
  '电站管理/删除': `Delete`,
  '电站管理/项目简称': `Projct Name Abbreviation`,
  '电站管理/省份': `Province`,
  '电站管理/电站详细地址': `Station Detail Address`,
  '电站管理/安装企业': `Installation Company`,
  '电站管理/框架合同': `Frame Contract`,
  '电站管理/选填': `Optional`,
  '电站管理/运营模式': `Operation Mode`,
  '电站管理/用电类别': `Electricity Type`,
  '电站管理/自运营模式': `Self-Operating`,
  '电站管理/合同能源管理': `Energy Management Contract`,
  '电站管理/大工业用电': `General Industry`,
  '电站管理/一般工业用电': `Large-Scale Industry`,
  '电站管理/电压等级': `Voltage Level`,
  '电站管理/计费模式': `Charge Mode`,
  '电站管理/未知': `Unknown`,
  '电站管理/容量计费': `Capcacity`,
  '电站管理/需量计费': `Demand`,
  '电站管理/请输入关键字搜索地址': `Please Input Keyword to Search Address`,
  '电站管理/电站位置': `Station Address`,
  '电站管理/在地图中选择电站位置，可自动填充电站地址及经纬度信息': `Choose Station Position in the Map, then Autofill the Station's Address, Latitude, and Longitude`,
  '电站管理/下一步': `Next`,
  '电站管理/投资方负责人': `Investor Leader Name`,
  '电站管理/投资方负责人联系电话': `Investor Leader Phone Number`,
  '电站管理/请输入投资方负责人': `Please Input Investor Leader Name`,
  '电站管理/请输入投资方负责人联系电话': `Please Input Investor Leader Phone Number`,
  '电站管理/业主方负责人': `Owner Leader Name`,
  '电站管理/业主方联系电话': `Owner Leader Phone Number`,
  '电站管理/请输入业主方负责人': `Please Input Owner Leader Name`,
  '电站管理/请输入业主方联系电话': `Please Input Owner Leader Phone Number`,
  '电站管理/电站显示优先级': `Priority in Station Display`,
  '电站管理/电价模式': `Tariff Mode`,
  '电站管理/尖峰平谷模式': `Sharp-Peak-Flat-Valley PriceModel`,
  '电站管理/时段电价模式': `Time-of-Use Price Mode`,
  '电站管理/电站图片': `Station Photo`,
  '电站管理/上传': `Upload`,
  '电站管理/只能上传jpg/png文件，且不超过500kb': `Only jpg/png is Available, and Size is Less Than 500kb`,
  '电站管理/页面切换时间': `Page Switch Time`,
  '电站管理/光伏接入': `Photovoltaic Include`,
  '电站管理/第三方API接入情况': `Third API Access`,
  '电站管理/编辑设备信息': `Edit Equiipment Information`,
  '电站管理/返回': `Back`,
  '电站管理/完成': `Finish`,
  '电站管理/注意：这里只是记录一下有没有第三方接入，以及第三方接入信息，和电站实际运行没有任何关联': `Notice: Here only for recording third party access information, nothing to do with station operation`,
  '电站管理/开启时策略由系统控制，关闭时由客户控制': `Start to control strategy by sytem, Stop to control strategy by customer`,
  '电站管理/电站列表中电站的显示顺序，数字越大，优先级越高，显示越靠前': `The Display Order in the Station List, the Higher the Number, the Higher the Priority, and the Higher the Display`,
  '电站管理/开启时，数据可视化页面、站级监控页面显示光伏相关数据': `Start to Display Photovoltaic Data in "Data Visualizaiton" and "Station Monitor" Page`,
  '电站管理/数据可视化页面自动切换时间，0时不自动切换，最大可设置120s': `Data Visulaztion Page Automatic Switch Time. 0 to Turn Off Automatic Switch, Max Value: 120s`,
  '电站管理/装机功率': `Installed Power`,
  '电站管理/装机容量': `Installed Capacity`,
  '电站管理/方阵': `Matrix`,
  '电站管理/变压器容量': `Transformer Capacity`,
  '电站管理/关口电表名称': `PCC Meter Name`,
  '电站管理/关口电表UUID': `PCC Meter UUID`,
  '电站管理/能量链UUID': `eLink UUID`,
  '电站管理/设备ID': `Equipment ID `,
  '电站管理/能量链型号': `eLink Model`,
  '电站管理/并网点电表名称': `GCP Meter Name`,
  '电站管理/并网点电表UUID': `GCP Meter UUID`,
  '电站管理/序号': `Index`,
  '电站管理/导出配置': `Download Configuration`,
  '电站管理/编辑': `Edit`,
  '电站管理/填加eBlock': `New eBlock`,
  '电站管理/填加eLink': `New eLink`,
  '电站管理/填加方阵': `New Matrix`,
  '电站管理/填加/编辑方阵': `Add/Edit Matrix`,
  '电站管理/方阵名称': `Matrix Name`,
  '电站管理/安装位置': `Installation Address`,
  '电站管理/请输入安装位置文字描述': `Please Input Installation Address Description`,
  '电站管理/电表型号': `Meter Model`,
  '电站管理/请输入电表型号': `Please Input Meter Model`,
  '电站管理/电表变比': `Meter Transformation Ratio`,
  '电站管理/请输入电表变比': `Please Input Meter Transformation Ratio`,
  '电站管理/取消': `Cancel`,
  '电站管理/确定': `Confirm`,
  '电站管理/能量链名称': `eLink Name`,
  '电站管理/设备网络ID': `Equipment Network ID`,
  '电站管理/请输入设备网络ID': `Input Equipment Network ID`,
  '电站管理/计量点传输距离（米）': `Measure Point Transmission Distance(unit:meter)`,
  '电站管理/电表': `Meter`,
  '电站管理/撤销': `Undo`,
  '电站管理/重做': `Redo`,
  '电站管理/清空当前画布': `Clear Current Canvas`,
  '电站管理/导入': `Import`,
  '电站管理/隐藏属性': `Hide Attribute`,
  '电站管理/显示属性': `Show Attribute`,
  '电站管理/位置': `Position`,
  '电站管理/尺寸': `Size`,
  '电站管理/文字颜色': `Text Color`,
  '电站管理/请选择能量链': `Please Select eLink`,
  '电站管理/请选择能量块': 'Please Select eBlock',
  '电站管理/请选择电表': 'Please Select Meter',
  '电站管理/请选择变压器': 'Please Select Transformer',
  '电站管理/链接桩数量': 'Port Number',
  '电站管理/上': 'up',
  '电站管理/下': 'down',
  '电站管理/电站拓扑图': 'Station Topology',

  '电站管理/保存': `Save`,
  '电站管理/导出JSON': `Download JSON`,
  '电站管理/属性': `Attribute`,
  '电站管理/背景颜色': `Background Color`,
  '电站管理/清空': `Clear`,
  '电站管理/全局文字颜色': `Global Text Color`,
  '电站管理/显示网格': `Display Grid`,
  '电站管理/应用背景样式': `Apply Background Style`,
  '电站管理/快捷键提示': `Shotcut Key`,
  '电站管理/复制': `Copy`,
  '电站管理/粘贴': `Paste`,
  '电站管理/删除元素': `Delete Element`,
  '电站管理/按住鼠标右键平移画布': `Hold Mouse Right Key to Move Canvas`,
  '电站管理/按住滑动滚轮进行缩放': `Hold adn Scroll to Zoom`,
  '电站管理/基础元件': `General Element`,
  '电站管理/文本': `Text`,
  '电站管理/矩形': `Rectangle`,
  '电站管理/圆形': `Circle`,
  '电站管理/电气元件': `Electrical Element`,
  '电站管理/负载': `Load`,
  '电站管理/能量块': `eBlock`,
  '电站管理/电表': `Meter`,
  '电站管理/能量链': `eLink`,
  '电站管理/母线': `Bus`,
  '电站管理/变压器': `Transformer`,
  '电站管理/充电桩': `Charging Pile`,
  '电站管理/光伏': `Photovolaic`,
  '电站管理/储能系统': `Energy Storage System`,
  '电站管理/断路器': `Circuit Breaker`,
  '电站管理/接触器': `Contactor`,
  '电站管理/新增': `New`,
  '电站管理/维护时间': `Maintenance Time`,
  '电站管理/维护人': `Maintenance Operator`,
  '电站管理/维护动作': `Maintenance Action`,
  '电站管理/维护内容': `Maintencance Content`,
  '电站管理/创建时间': `Create Time`,
  '电站管理/操作': `Operation`,
  '电站管理/暂无数据': `No Data`,
  '电站管理/配网信息': `Distribution Network Information`,
  '电站管理/设备SN': `Equipment SN`,
  '电站管理/ap名称': `AP Name`,
  '电站管理/ap密码': `AP Password`,
  '电站管理/路由SSID': `Router SSID`,
  '电站管理/路由密码': `Router Password`,
  '电站管理/设备IP': `Equipment IP`,
  '电站管理/设备顺序': `Equipment Order`,
  '电站管理/方阵顺序': `Matrix Order`,
  '电站管理/业务模式': `Business Mode`,
  '电站管理/非自投': `Non-Autonomous Investment`,
  '电站管理/自投': `Autonomous Investment`,
  '电站管理/状态': 'State',
  '电站管理/功率': 'Power',
  '电站管理/电压': 'Voltage',
  '电站管理/电流': 'Current',
  '电站管理/功率因数': 'Power Factor',
  '电站管理/SOC': 'SOC',

  '电站管理/请选择日期范围': `Please Select Date Range`,
  '电站管理/按月': `Month`,
  '电站管理/按周': `Week`,
  '电站管理/开始月份': `Start Month`,
  '电站管理/结束月份': `End Month`,
  '电站管理/选择周': `Select Week`,
  '电站管理/第': `Week`,
  '电站管理/周': ` `,
  '电站管理/项目名称': `Project Name`,
  '电站管理/秒': `Second`,
  '电站管理/其他参数': `Other Parameters`,


  '电站管理/文件过大': `File Too Large`,
  '电站管理/请输入或从地图选择电站地址': `Please Input or Select Station Address from Map`,
  '电站管理/请输入或在右侧地图上点选地址': `Please Input or Click on the Map to Select Address`,
  '电站管理/请选择投运日期': `Please Select Operation Date`,
  '电站管理/对接方': `Partner`,
  '电站管理/对接协议': `Partner Protocol`,
  '电站管理/硬件配置': `Hardware Configuration`,

  '电站管理/请输入对接方': `Please Input Partner`,
  '电站管理/请选择对接协议': `Please Select Partner Protocol`,
  '电站管理/请输入硬件配置': `Please Input Hardware Configuration`,
  '电站管理/电站其他参数': `Station Other Parameters`,



  '电站管理/电站编码不能有中划线': `Station Code Cannot Have Hyphens`,
  '电站管理/请输入电站编码': `Please Input Station Code`,
  '电站管理/请选择电压等级': `Please Select Voltage Level`,
  '电站管理/请输入或从地图选择': `Please Input or Select from Map`,
  '电站管理/请输入或从地图选择电站地址': `Please Input or Select Station Address from Map`,
  '电站管理/请在地图上选择经度': `Please Select Longitude on the Map`,
  '电站管理/请在地图上选择维度': `Please Select Latitude on the Map`,
  '电站管理/请输入额定功率': `Please Input Rated Power`,
  '电站管理/只能输入数字': `Only Numbers Allowed`,
  '电站管理/请输入设计容量': `Please Input Installed Capacity`,

  '电站管理/请输入电站名称': `Input Station Name`,
  '电站管理/比如: 陕西省': `For Example: Shaanxi Province`,
  '电站管理/电站编码可以是电站名称首字母拼写，如SHUOBEIDE': `Station Code Can Be the First Letter of Station Name, For Example: SHUOBEIDE`,
  '电站管理/台': `Units`,
  '电站管理/确定要导出所有电站吗?': `Are you sure you want to download all stations?`,
  '电站管理/确定要删除该电站吗？': `Are you sure you want to delete this station?`,
  '电站管理/删除选中的电站后，这些电站信息将不可恢复': `After deleting the selected stations, the station information will not be recoverable`,
  '电站管理/确定要删除这些电站吗？': `Are you sure you want to delete these stations?`,
  '电站管理/已删除': `Deleted`,
  '电站管理/目前不支持在web端创建eBlock-100C方阵，请在APP中创建': `Create eBlock-100C Equipment in Web is Not Supported Currently, Please Use APP Instead`,
  '电站管理/数量': `Number`,
  '电站管理/确定要删除吗': `Are you sure you want to delete?`,
  '电站管理/变压器名称': `Transformer Name`,
  '电站管理/新增变压器': `New Transformer`,
  '电站管理/编辑变压器': `Edit Transformer`,
  '电站管理/请输入变压器名称': `Input Transformer Name`,
  '电站管理/请输入变压器容量': `Input Transformer Capacity`,
  '电站管理/请输入变压器UUID': `Input Transformer UUID`,
  '电站管理/添加': `Add`,
  '电站管理/设备ID': `Equipment ID`,
  '电站管理/型号': `Model`,
  '电站管理/添加/编辑': `Add/Edit`,
  '电站管理/请输入计量点传输距离': `Input Measure Point Transmission Distance`,
  '电站管理/能量块数量': `eBlock Number`,

  '电站管理/计量电表': `Measure Meter`,
  '电站管理/计量电表名称': `Measure Meter Name`,
  '电站管理/请输入计量电表名称': `Input Measure Meter Name`,
  '电站管理/请输入计量电表uuid': `Input Measure Meter UUID`,
  '电站管理/请输入计量电表设备ID': `Input Measure Meter Device ID`,
  '电站管理/请输入电表SN码': `Input Measure Meter SN`,
  '电站管理/计量电表UUID': `Measure Meter UUID`,
  '电站管理/计量电表设备ID': `Measure Meter Device ID`,
  '电站管理/电表SN码': `Meter SN`,
  '电站管理/添加计量电表': `Add Measure Meter`,
  '电站管理/请上传类似如下的照片': `Please Upload Similar to the Following Photo`,
  '电站管理/排序': `Sort`,
  '电站管理/设备序列号': `Equipment Serial Number`,
  '电站管理/电表类型': `Meter Type`,
  '电站管理/请选择电表类型': `Select Meter Type`,
  '电站管理/电表名称': `Meter Name`,
  '电站管理/请输入电表名称': `Input Meter Name`,
  '电站管理/请输入UUID': `Input UUID`,
  '电站管理/设备序列号': `Equipment Serial Number`,
  '电站管理/请输入设备序列号': `Input Equipment Serial Number`,
  '电站管理/电表名称不能为空！': `Meter Name Cannot Be Empty`,
  '电站管理/UUID不能为空！': `UUID Cannot Be Empty`,
  '电站管理/设备ID不能为空！': `Equipment ID Cannot Be Empty`,
  '电站管理/安装位置不能为空！': `Installation Location Cannot Be Empty`,
  '电站管理/电表型号不能为空！': `Meter Model Cannot Be Empty`,
  '电站管理/电表变比不能为空！': `Meter Transformation Ratio Cannot Be Empty`,
  '电站管理/电表正面照片不能为空！': `Meter Front Photo Cannot Be Empty`,
  '电站管理/电表正面照片': `Meter Front Photo`,
  '电站管理/查看图片': `View Image`,
  '电站管理/负载电表': `Load Meter`,
  '电站管理/关口电表': `PCC Meter`,
  '电站管理/光伏电表': `Photovoltaic Meter`,
  '电站管理/并网点电表': `GCP Meter`,
  '电站管理/外部电表': `External Meter`,
  '电站管理/新增外部电表': `New External Meter`,
  '电站管理/您输入的uuid': `You Input UUID`,
  '电站管理/已使用': `Already Used`,
  '电站管理/您输入的devId': `You Input devId`,
  '电站管理/名称': `Name`,
  '电站管理/容量': `Capacity`,
  '电站管理/请先添加eBlock': `Please Add eBlock First`,
  '电站管理/已保存设备信息': `Device Information Has Been Saved`,
  '电站管理/上传头像图片大小不能超过 2MB!': `Upload Avatar Image Size Cannot Be More Than 2MB`,
  '电站管理/提示': `Prompt`,
  '电站管理/请先输入或选择地址后再上传图片': `Please Input or Select Address First`,
  '电站管理/文件类型不支持': `File Type Not Supported`,
  '电站管理/文件过大': `File Too Large`,
  '电站管理/已保存电站基本信息': `Station Basic Information Has Been Saved`,
  '电站管理/保存失败': `Save Failed`,
  '电站管理/自定义控制权限': `Custom Control Permissions`,
  '电站管理/设置电站的特定控制权限': `Set the Specific Control Permissions of the Station`,
  '电站管理/防逆流': `Anti-Backflow`,
  '电站管理/箱变容量配比': `Transformer Capacity Ratio`,
  '电站管理/无功工作模式': `Reactive Power Working Mode`,
  '电站管理/联系手机号 *': `Contact Phone *`,
  '电站管理/联系手机号': `Contact Phone`,
  '电站管理/请输入联系手机号': `Please Input Contact Phone`,
  '电站管理/返回电站列表': `Return to the list of power stations`,
  '电站管理/自动需量': `Automatic demand`,
  '电站管理/开启时系统自动控制需量': `When turned on, the system automatically controls the demand`,
  '电站管理/元件连线颜色': `Element Line Color`,
  '电站管理/是否播放连线动画': `Whether to Play Line Animation`,
  '电站管理/箭头方向': `Arrow Direction`,
  '电站管理/正常': `Normal`,
  '电站管理/反向': `Reverse`,


  /* 维护记录 */
  '维护记录/维护记录': 'Maintenance Record',
  '维护记录/确定要删除本条维护记录吗?': 'Are You Sure You Want to Delete This Maintenance Record?',
  '维护记录/返回': 'Back',
  '维护记录/新增运维记录': 'New Maintenance Record',
  '维护记录/维护时间': 'Maintenance Time',
  '维护记录/维护人': 'Maintenance Person',
  '维护记录/维护动作': 'Maintenance Action',
  '维护记录/维护内容': 'Maintenance Content',
  '维护记录/请输入维护人': 'Please Input Maintenance Person',
  '维护记录/请输入维护动作': 'Please Input Maintenance Action',
  '维护记录/请输入维护内容': 'Please Input Maintenance Content',
  '维护记录/请输入维护时间': 'Please Input Maintenance Time',
  '维护记录/序号': 'Order',
  '维护记录/创建时间': 'Create Time',


  /* API白名单设置 */
  'API白名单设置/请输入IP地址': 'Please Input IP Address',
  'API白名单设置/组织': 'Organization',
  'API白名单设置/请输入组织名称': 'Please Input Organization Name',
  'API白名单设置/状态': 'State',
  'API白名单设置/正常': 'Normal',
  'API白名单设置/停用': 'Stop',
  'API白名单设置/请选择': 'Select',
  'API白名单设置/组织名称': 'Organization Name',
  'API白名单设置/协议': 'Protocol',
  'API白名单设置/用户名': 'User Name',
  'API白名单设置/创建人': 'Creator',
  'API白名单设置/更新时间': 'Update Time',
  'API白名单设置/备注信息': 'Remark',
  'API白名单设置/新增/编辑白名单': 'Add/Edit White List',
  'API白名单设置/IP地址不能为空': 'IP Address Cannot Be Empty',
  'API白名单设置/请输入正确的IP地址': 'Please Input Correct IP Address',
  'API白名单设置/用户名不能为空': 'User Name Cannot Be Empty',
  'API白名单设置/组织名称不能为空': 'Organization Name Cannot Be Empty',
  'API白名单设置/正在保存中': 'Saving...',
  'API白名单设置/删除成功': 'Delete Success',
  'API白名单设置/添加成功': 'Add Success',
  'API白名单设置/修改成功': 'Update Success',
  'API白名单设置/确定要删除吗?': 'Are You Sure You Want to Delete?',
  'API白名单设置/请输入用户名': 'Please Input User Name',

  /* eLink查询 */
  'eLink查询/电站名称': 'Station Name',
  'eLink查询/搜索': 'Search',
  'eLink查询/重置': 'Reset',
  'eLink查询/能量链名称': 'eLink Name',
  'eLink查询/产品型号': 'Product Model',



  /* 设备升级 */
  '设备升级/新增标签': 'New Label',
  '设备升级/标签': 'Label',
  '设备升级/关联电站': 'Associated Station',
  '设备升级/备注': 'Remark',
  '设备升级/创建者': 'Creator',
  '设备升级/创建日期': 'Create Date',
  '设备升级/操作': 'Operation',
  '设备升级/编辑': 'Edit',
  '设备升级/删除': 'Delete',
  '设备升级/编辑标签': 'Edit Label',
  '设备升级/标签名称': 'Label Name',
  '设备升级/全选': 'Select All',
  '设备升级/搜索电站': 'Search Station',
  '设备升级/取消': 'Cancel',
  '设备升级/确定': 'Confirm',
  '设备升级/请输入标签名称': 'Please Input Label Name',
  '设备升级/请至少选择一个电站': 'Please Select At Least One Station',
  '设备升级/标签管理': 'Label Management',
  '设备升级/固件升级': 'Fireware Upgrade',
  '设备升级/设备升级': 'Equipment Upgrade',
  '设备升级/版本信息': 'Version Information',
  '设备升级/新增升级包': 'New Upgrade Package',
  '设备升级/文件名称': 'File Name',
  '设备升级/文件类型': 'File Type',
  '设备升级/文件大小': 'File Size',
  '设备升级/上传时间': 'Upload Time',
  '设备升级/操作': 'Operation',
  '设备升级/下载': 'Download',
  '设备升级/上传升级包': 'Upload Upgrade Package',
  '设备升级/选择标签': 'Select Label',
  '设备升级/请选择': 'Please Select',
  '设备升级/请选择文件类型': 'Please Select File Type',
  '设备升级/文件上传': 'Upload File',
  '设备升级/拖拽到次或点击上传': 'Drag Here or Press Upload',
  '设备升级/请选择文件，最大不超过50Mb': 'Please Select File,  Size is Less Than 500Mb',
  '设备升级/升级': 'Upgrade',
  '设备升级/升级历史': 'Upgrade History',
  '设备升级/状态': 'State',
  '设备升级/全部': 'Total',
  '设备升级/电站': 'Station',
  '设备升级/升级类型': 'Upgrade Device',
  '设备升级/开始升级时间': 'Upgrade Start Time',
  '设备升级/进度': 'Progress',
  '设备升级/用时': 'Duration',
  '设备升级/操作': 'Operation',
  '设备升级/升级结果': 'Upgrade Result',
  '设备升级/升级成功': 'Upgrade Success',
  '设备升级/升级版本和运行版本相同': 'Uprade and Current Have the Same Version',
  '设备升级/升级失败': 'Upgrade Fail',
  '设备升级/升级失败设备序号': 'Upgrage Faile Equipment Index',
  '设备升级/选择电站': 'Select Station',
  '设备升级/表格视图': 'Table View',
  '设备升级/树形视图': 'Tree View',
  '设备升级/eLink版本信息': 'eLink Version Information',
  '设备升级/序列号': 'Serial Number',
  '设备升级/创建时间': 'Create Time',
  '设备升级/确认删除': 'Confirm Delete',
  '设备升级/添加': 'Add',
  '设备升级/编辑': 'Edit',
  '设备升级/创建成功': 'Create Success',
  '设备升级/编辑成功': 'Edit Success',
  '设备升级/拖拽到此或': 'Drag Here or',
  '设备升级/点击上传': 'Click Upload',
  '设备升级/请选择文件': 'Please Select File',
  '设备升级/最大不超过': 'Max Size: 50Mb',


  '设备升级/请先选择标签': 'Please Select Label',
  '设备升级/请先上传文件': 'Please Upload File',
  '设备升级/请先选择文件类型': 'Please Select File Type',
  '设备升级/上传成功': 'Upload Success',
  '设备升级/文件太大，请选择小于50Mb的文件': 'File Too Large, Please Select File Less Than 50Mb',
  '设备升级/文件格式不正确': 'File Format is Incorrect',
  '设备升级/确认要删除吗': 'Are you sure you want to delete',
  '设备升级/成功': 'Success',
  '设备升级/文件名': 'File Name',

  '设备升级/私钥文件': 'Private Key File',
  '设备升级/无响应时可手动结束': 'If No Response, You Can Manually End',
  '设备升级/请输入结束原因': 'Please Input End Reason',
  '设备升级/选择升级包': 'Select Upgrade Package',
  '设备升级/请选择电站': 'Please Select Station',
  '设备升级/选择eLink': 'Select eLink',
  '设备升级/请选择eLink': 'Please Select eLink',
  '设备升级/开始升级': 'Start Upgrade',
  '设备升级/结束': 'End',
  '设备升级/文件': 'File',
  '设备升级/升级命令已下发': 'Upgrade Command Has Been Sent',
  '设备升级/请选择文件': 'Please Select File',
  '设备升级/请选择私钥文件': 'Please Select Private Key File',
  '设备升级/提示': 'Prompt',
  '设备升级/选填': 'Optional',
  '设备升级/电站ID': 'Station ID',
  '设备升级/电站名称': 'Station Name',
  '设备升级/eBlock版本信息': 'eBlock Version Information',

  '设备升级/返回': 'Back',
  '设备升级/版本详情': 'Version Detail',
  '设备升级/记录时间': 'Record Time',
  '设备升级/操作': 'Operation',
  '设备升级/时间范围': 'Time Range',
  '设备升级/搜索': 'Search',
  '设备升级/重置': 'Reset',
  '设备升级/版本号': 'version',
  '设备升级/更新时间': 'Update Time',
  '设备升级/序号': 'Order',
  '设备升级/名称': 'Name',


  '设备升级/命令已下发': 'Command Has Been Sent',
  '设备升级/收到请求': 'Request Received',
  '设备升级/下载中': 'Downloading',
  '设备升级/准备升级': 'Preparing Upgrade',
  '设备升级/正在升级': 'Upgrading',
  '设备升级/版本校验中': 'Version Verification',
  '设备升级/数据传输中': 'Data Transmission',
  '设备升级/等待结果': 'Waiting for Result',
  '设备升级/未知': 'Unknown',
  '设备升级/升级包校验失败': 'Upgrade Package Verification Fail',
  '设备升级/升级前查询运行版本失败': 'Upgrade Before Querying Running Version Fail',
  '设备升级/升级后查询运行版本失败': 'Upgrade After Querying Running Version Fail',


  /* 数据可视化 */
  '数据可视化/数据可视化': `Visualization`,
  '数据可视化/电站拓扑': `Topology`,
  '数据可视化/智慧储能电站管理平台': `Intelligent Energy Storage Management System`,
  '数据可视化/综合运维': `Operation`,
  '数据可视化/视频监控': `Video Monitoring`,
  '数据可视化/全国': `Countrywide`,
  '数据可视化/广东省': `Guangdong Province`,
  '数据可视化/浙江省': `Zhejiang Province`,
  '数据可视化/电站规模': `Station Scale`,
  '数据可视化/安全运行天数': `Safe Operation Days`,
  '数据可视化/天': `Days`,
  '数据可视化/累计装机容量': `Accumulated Installed Capacity`,
  '数据可视化/累计装机功率': `Accumulated Installed Power`,
  '数据可视化/电站个数': `The number of Station`,
  '数据可视化/能量链数量': `The number of eLink`,
  '数据可视化/能量块数量': `The number of eBlock`,
  '数据可视化/储能分析': `Energy Storage Analysis`,
  '数据可视化/充电': `Charge`,
  '数据可视化/放电': `Discharge`,
  '数据可视化/累计总充电量(不含今日)': `Accumulated Charging Energy(Exclude Today)`,
  '数据可视化/累计总放电量(不含今日)': `Accumulated Discharging Energy(Exclude Today)`,
  '数据可视化/节能减排': `Energy Saving and Emission Reduction`,
  '数据可视化/CO2减排量': `CO2 Emission Reduction `,
  '数据可视化/节约标准煤': `Standard Coal Saving`,
  '数据可视化/减少森林砍伐': `Deforestation Reduction`,
  '数据可视化/收益分析': `Earning Analysis`,
  '数据可视化/所辖电站近12月收益(万元)': `All Stations' Earning Over the Past Year (Thousand Euros)`,
  '数据可视化/所辖电站累计收益': `All Station's Accumulated Earning`,
  '数据可视化/电站系统效率TOP10': `Station System Efficiency TOP10`,
  '数据可视化/排名': `Rank`,
  '数据可视化/电站': `Station`,
  '数据可视化/累计充电量': `Charging`,
  '数据可视化/累计放电量': `Discharging`,
  '数据可视化/系统效率(%)': `Efficiency(%)`,
  '数据可视化/各省电站收益率': `Irr in Provinces`,
  '数据可视化/运行评价': `Operation Assessment`,
  '数据可视化/优级': `Excellent`,
  '数据可视化/良级': `Medium`,
  '数据可视化/中级': `Good`,
  '数据可视化/合格': `Qualified`,
  '数据可视化/不合格': `Unqualified`,
  '数据可视化/统计信息': `Statistics Information`,
  '数据可视化/当日放电量': `Daily Discharging Energy`,
  '数据可视化/当日充电量': `Daily Charging Energy`,
  '数据可视化/母线': `Bus`,
  '数据可视化/方阵': `Matrix`,
  '数据可视化/关口电表': `PCC Meter`,
  '数据可视化/功率': `Power`,
  '数据可视化/电压': `Voltage`,
  '数据可视化/电流': `Current`,
  '数据可视化/负载': `Load`,
  '数据可视化/并网点电表': `Grid-Connected Meter`,
  '数据可视化/状态': `State`,
  '数据可视化/直流功率': `Direct Current Power`,
  '数据可视化/直流电压': `Direct Current Voltage`,
  '数据可视化/直流电流': `Direct Current`,
  '数据可视化/电站运行信息': `Station Operation Information`,
  '数据可视化/电站评价结果': `Station Assessment`,
  '数据可视化/装机容量': `Installed Capacity`,
  '数据可视化/装机功率': `Installed Power`,
  '数据可视化/实时功率': `Real-Time Power`,
  '数据可视化/可用电量': `Available Energy`,
  '数据可视化/月累计收益': `Accumulated Earning Monthly`,
  '数据可视化/电池簇分析': `Battery Cluster Analysis`,
  '数据可视化/温度': `Temperature`,
  '数据可视化/位置': `Position`,
  '数据可视化/最高单体电压': `Highest Cell Voltage`,
  '数据可视化/最低单体电压': `Lowest Cell Voltage`,
  '数据可视化/最大压差': `Highest Voltage Difference`,
  '数据可视化/最高电压位置编号': `Highest Cell Voltage Index`,
  '数据可视化/最低电压位置编号': `Lowest Cell Voltage Index`,
  '数据可视化/最高单体温度': `Highest Cell Temperature`,
  '数据可视化/最低单体温度': `Lowest Cell Temperature`,
  '数据可视化/最大温差': `Highest Temperature Difference`,
  '数据可视化/最高温度位置编号': `Highest Cell Temperature Index`,
  '数据可视化/最低温度位置编号': `Lowest Cell Temperature Index`,
  '数据可视化/功率曲线': `Power Curve`,
  '数据可视化/运行信息': `Operation Information`,
  '数据可视化/实时告警': `Real-Time Alarm`,
  '数据可视化/紧急': `Emergency`,
  '数据可视化/重要': `Primary`,
  '数据可视化/一般': `General`,
  '数据可视化/设备ID': `Equipment ID`,
  '数据可视化/设备类型': `Equipment Model`,
  '数据可视化/告警名称': `Alarm Name`,
  '数据可视化/告警等级': `Alarm Level`,
  '数据可视化/暂无告警数据': `No Alarm Data`,
  '数据可视化/负荷跟踪': `Load Tracking`,
  '数据可视化/并网点功率': `PCC Power`,
  '数据可视化/关口表功率': `GCP Power`,
  '数据可视化/负载功率': `Load Power`,
  '数据可视化/电站个数(个)': `The number of Station`,
  '数据可视化/能量链数量(个)': `The number of eLink`,
  '数据可视化/能量块数量(个)': `The number of eBlock`,
  '数据可视化/累计总充电量（不含今日）': `Accumulated Charging Energy(Exclude Today)`,
  '数据可视化/累计总放电量（不含今日）': `Accumulated Discharging Energy(Exclude Today)`,
  '数据可视化/充放电量': `Energy`,
  '数据可视化/月': `Month`,
  '数据可视化/万元': `Thousand Euros`,
  '数据可视化/所辖电站近12月收益(万元)': `All Stations' Earning Over the Past Year (Thousand Euros)`,
  '数据可视化/收益率': `Irr`,
  '数据可视化/月累计收益(元)': `Accumulated Earning Monthly (Yuan)`,
  '数据可视化/SOC - 功率曲线': `SOC - Power Curve`,
  '数据可视化/eBlock运行信息': `eBlock Running Information`,
  '数据可视化/光伏当日发电量': `PV Daily Generation`,
  '数据可视化/光伏累计发电量': `PV Accumulated Generation`,
  '数据可视化/收益(万元)': `Earning (Thousand Euros)`,
  '数据可视化/时间': `Time`,
  '数据可视化/搜索': 'Search',
  '数据可视化/电站名称': 'Station Name',


  /* 登录 */
  '登录/eMind智慧储能电站管理平台': 'eMind Intelligent ESS',
  '登录/用户名密码登录': 'Account',
  '登录/手机号验证登录': 'Phone Number',
  '登录/账号': 'Account Number',
  '登录/请输入您的账号': 'Please Input Your Accout Number',
  '登录/请输入您的密码': 'Please Input Your Password',
  '登录/请输入手机号': 'Please Input Phone Number',
  '登录/验证码': 'Verification Code',
  '登录/请输入验证码': 'Please Input Verification Code',
  '登录/记住密码': 'Remember Password',
  '登录/手机号': 'Phone Number',
  '登录/请输入正确的手机号': 'Please Input Correct Phone Number',
  '登录/获取验证码': 'Get Code',
  '登录/登录': 'Log in',
  '登录/密码': 'Password',
  '登录/网站备案/许可证号': 'Website Record/License Number',
  '登录/奇点能源': 'JD Energy',
  '登录/登录中': 'Logging in',
  '登录/验证码已发送，五分钟后失效': 'The Verification Code has been sent, Invalid in 5 Minutes',
  '登录/重发': 'Resend',
  '登录/确定注销并退出系统吗': 'Are You Sure to Log Off and Exit the System',

  /* 设备模型 */
  '设备型号/请输入设备型号': 'Please Input Equipment Model',
  '设备型号/请输入数据源': 'Please Input Data Source',
  '设备型号/请输入数据表': 'Please Input Data Table',
  '设备型号/请输入版本号': 'Please Input Version',
  '设备型号/修改点表': 'Edit Point Table',
  
  '设备型号/设备型号': 'Equipment Model',
  '设备型号/数据源': 'Data Source',
  '设备型号/数据表': 'Data Table',
  '设备型号/版本号': 'Version',
  '设备型号/数据间隔': 'Data Interval',
  '设备型号/保存方式': 'Save Mode',
  '设备型号/数据上传方式': 'Data Upload Method',
  '设备型号/数据模板': 'Data Template',
  '设备型号/操作成功': 'Operation Success',

  '设备型号/编辑设备型号': 'Edit Equipment Model',
  '设备型号/新增设备型号': 'New Equipment Model',

  '设备型号/数据地址位(10进制)': 'Data Address (Decimal)',
  '设备型号/子分类': 'Sub Category',
  '设备型号/中文名': 'Chinese Name',
  '设备型号/英文key': 'English Key',
  '设备型号/单位': 'Unit',
  '设备型号/数据类型': 'Data Type',
  '设备型号/数据类别': 'Data Category',
  '设备型号/默认值': 'Default Value',
  '设备型号/最小值': 'Minimum Value',
  '设备型号/最大值': 'Maximum Value',
  '设备型号/比率': 'Ratio',
  '设备型号/偏移量': 'Offset',
  '设备型号/排序': 'Sort',
  '设备型号/保存开关': 'Save Switch',
  '设备型号/是否展示': 'Is Hide',
  '设备型号/字典': 'Dictionary',
  '设备型号/备注': 'Remark',
  '设备型号/遥测': 'Telemetry(YC)',
  '设备型号/遥信': 'Telecontrol(YX)',
  '设备型号/保存': 'Save',
  '设备型号/不保存': 'Not Save',
  '设备型号/展示': 'Show',
  '设备型号/隐藏': 'Hide',
  '设备型号/排序必须是整数': 'Sort Must Be Integer',
  '设备型号/请输入数据地址位(10进制)': 'Please Input Data Address (Decimal)',
  '设备型号/请输入子分类': 'Please Input Sub Category',
  '设备型号/请输入中文名': 'Please Input Chinese Name',
  '设备型号/请输入英文key': 'Please Input English Key',
  '设备型号/请输入单位': 'Please Input Unit',
  '设备型号/请输入数据类型': 'Please Input Data Type',
  '设备型号/请输入数据类别': 'Please Input Data Category',
  '设备型号/请输入默认值': 'Please Input Default Value',
  '设备型号/请输入最小值': 'Please Input Minimum Value',
  '设备型号/请输入最大值': 'Please Input Maximum Value',
  '设备型号/请输入比率': 'Please Input Ratio',
  '设备型号/请输入偏移量': 'Please Input Offset',
  '设备型号/编辑模型': 'Edit Model',
  '设备型号/新增模型': 'New Model',
  '设备型号/值': 'Value',
  '设备型号/描述': 'Description',
  '设备型号/请输入值': 'Please Input Value',
  '设备型号/继续创建下一个': 'Continue Create Next',
  '设备型号/勾选后不关闭弹框，基于现有数据继续创建下一个点表': 'If Checked, Do Not Close the Dialog, Continue to Create the Next Point Table Based on the Existing Data',
  '设备型号/刷新缓存': 'Refresh Cache',
}
